export const es = {
  gatePage: {
    title: 'Caseta',
    subtitle: 'Verifica el pase de lista de una cuadrilla y registra el paso de vehículos.',
    people: 'Personas',
    vehicles: 'Vehículos',
    codeLabel: 'Código del pase (lector o a mano)',
    codeHint: 'Con un lector USB o Bluetooth, deja el cursor aquí y escanea el QR.',
    search: 'Buscar',
    camera: 'Usar cámara',
    cameraOff: 'Cerrar cámara',
    cameraUnsupported: 'No se pudo abrir la cámara. Revisa el permiso del navegador, o usa un lector o escribe el código.',
    invalidCode: 'Código no válido, o la lista ya venció (24 h).',
    group: 'Grupo',
    closedAt: 'Lista cerrada',
    present: 'Presentes en la lista',
    countedLabel: 'Personas que contaste',
    entry: 'Entrada',
    exit: 'Salida',
    confirm: 'Confirmar conteo',
    match: 'Coincide: el conteo es correcto.',
    mismatch: (exp: number, got: number) => `No coincide: la lista dice ${exp} y contaste ${got}. Quedó como incidencia.`,
    plate: 'Placa',
    driver: 'Conductor',
    company: 'Empresa',
    occupants: 'Ocupantes',
    note: 'Nota',
    register: 'Registrar paso',
    allowed: 'Vehículo autorizado.',
    visitor: 'Vehículo sin alta: registrado como visita.',
    authorizeTitle: 'Alta de vehículo autorizado',
    validUntil: 'Vigente hasta',
    save: 'Guardar vehículo',
    saved: 'Vehículo guardado.',
    logTitle: 'Bitácora de hoy',
    colTime: 'Hora',
    colType: 'Tipo',
    colDetail: 'Detalle',
    colResult: 'Resultado',
    emptyLog: 'Sin movimientos hoy.',
    faceTitle: 'Reconocimiento facial',
    inactiveInList: '{n} persona(s) de la lista están de baja. Avisa a Recursos Humanos.',
    status: { ACTIVE: 'Activo', PRE_TERMINATION: 'Pre-baja', INACTIVE: 'De baja', EXTRA: 'Extra' },
    cameraTitle: 'Cámara',
    cameraHint: 'Ábrela una vez: lee sola un QR o un código de barras; para un rostro, usa Identificar.',
    openCameraFirst: 'Abre la cámara para identificar un rostro.',
    faceHint: 'Abre la cámara, toma la foto y confirma quién es. La foto no se guarda.',
    faceCamera: 'Abrir cámara de rostro',
    identify: 'Identificar',
    faceError: 'No se pudo identificar. Acércate a la cámara e inténtalo de nuevo.',
    letIn: 'Registrar entrada',
    letOut: 'Registrar salida',
    pickCandidate: 'No es seguro quién es. Elige a la persona:',
    terminatedPending: (n: string) => `${n} está de baja: solicitud enviada, falta que alguien con permiso la autorice.`,
    terminatedDenied: (n: string) => `${n} está de baja: acceso negado y registrado.`,
    authReason: 'Motivo de la autorización',
    logAsVisitor: 'Registrar como visita',
    authorizePass: 'Autorizar paso',
    requestAuth: 'Solicitar autorización',
    logDenied: 'Negar y registrar',
    resolved: 'Resuelta',
    authorizedOk: 'Paso autorizado.',
    saveRules: 'Guardar reglas',
    rulesTitle: 'Reglas para personas dadas de baja',
    rulesHint: 'Se revisan en orden y gana la primera que coincide. Estricto: no pasa. Visita: se registra como visita. Con autorización: espera a alguien con permiso.',
    ruleRole: 'Rol',
    ruleDirection: 'Entrada/salida',
    ruleAction: 'Acción',
    anyRole: 'Cualquier rol',
    anyDirection: 'Entrada y salida',
    moveUp: 'Subir',
    moveDown: 'Bajar',
    removeRule: 'Quitar',
    addRule: 'Agregar regla',
    otherwise: 'Si ninguna coincide',
    rulesSaved: 'Reglas guardadas.',
    policyLabels: { STRICT: 'Estricto', VISITOR: 'Visita', AUTHORIZE: 'Con autorización' },
    terminated: '{name} está de baja. No lo dejes pasar y avisa a Recursos Humanos.',
    notActive: 'no activo',
    visitorName: 'Nombre de la visita',
    logVisitor: 'Registrar visita',
    tooSmall: 'El rostro se ve muy pequeño: acércate a la cámara.',
    personLogged: (n: string) => `Paso registrado: ${n}.`,
    visitorLogged: (n: string) => `Visita registrada: ${n}.`,
    typePerson: 'Persona',
    invalidVehicle: 'Revisa los datos: la placa debe tener de 4 a 10 letras o números y los ocupantes, máximo 200.',
    typeList: 'Pase de lista',
    typeVehicle: 'Vehículo',
    results: { MATCH: 'Coincide', MISMATCH: 'No coincide', ALLOWED: 'Autorizado', VISITOR: 'Visita', DENIED: 'Negado', PENDING: 'Por autorizar', AUTHORIZED: 'Autorizado por RH' },
  },
  attendancePage: {
    personnelTitle: 'Personal',
    attendanceTitle: 'Asistencia',
    subtitlePersonnel: 'Padrón de personal, enrolamiento por rostro, pre-bajas y borrado de datos biométricos.',
    subtitleAttendance: 'Listas del día por cuadrilla. Presentes, faltantes y fotos de cada registro.',
    addPerson: 'Agregar persona',
    edit: 'Editar',
    editTitle: 'Editar persona',
    save: 'Guardar',
    numberShort: 'No. empleado',
    fullName: 'Nombre completo',
    employeeNumber: 'Número de empleado (opcional)',
    colCrew: 'Cuadrilla',
    noCrew: 'Sin cuadrilla',
    colUser: 'Usuario del sistema',
    noUser: 'Sin usuario',
    crewHint: 'Cuadrilla',
    newCrewName: 'Nueva cuadrilla (nombre)',
    createCrew: 'Crear cuadrilla',
    deleteCrewConfirm: (n: string) => `¿Borrar la cuadrilla «${n}»? Las listas anteriores conservan su nombre.`,
    add: 'Agregar',
    importTitle: 'Importar desde Excel',
    importHint: 'Primera hoja con una columna de nombre (Nombre, Empleado o Trabajador). Opcionales: número, cuadrilla.',
    chooseFile: 'Elegir archivo .xlsx',
    preview: 'Revisar',
    confirmImport: 'Confirmar importación',
    toCreate: 'Por crear',
    alreadyExist: 'Ya existían',
    importDone: 'Personas importadas',
    errorsFound: 'Corrige estos errores y vuelve a intentar',
    rowLabel: (n: number) => `Fila ${n}`,
    methods: { AUTO: 'Automático', CONFIRMED: 'Confirmado', MANUAL: 'Manual', EXTRA: 'Persona extra' },
    errors: {
      FEATURE_DISABLED: 'La asistencia por rostro no está activada en tu empresa.',
      FORBIDDEN: 'No tienes permiso para esta acción.',
      NOT_FOUND: 'No se encontró. Puede que ya no exista.',
      DUPLICATE_NUMBER: 'Ese número de empleado ya existe. Usa otro.',
      REASON_REQUIRED: 'Escribe un motivo para autorizar.',
      HAS_ATTENDANCE: 'No se puede borrar: ya tiene asistencias. Dala de baja.',
      INVALID_INPUT: 'Revisa los datos e inténtalo de nuevo.',
      INVALID_BODY: 'La solicitud no es válida.',
      INVALID_DECISION: 'La decisión no es válida.',
      INVALID_FILE: 'El archivo no es válido.',
      FILE_TOO_LARGE: 'El archivo es demasiado grande.',
      INVALID_RANGE: 'El rango de fechas no es válido.',
      RANGE_TOO_LARGE: 'El rango de fechas es demasiado grande (máximo 93 días).',
      CONSENT_REQUIRED: 'Primero hay que registrar el consentimiento firmado de la persona.',
      SESSION_CLOSED: 'La lista ya está cerrada.',
      MISSING_UNDECIDED: 'Falta decidir qué pasó con algunas personas antes de cerrar.',
      NO_FACE: 'No se ve ningún rostro. Acércate y revisa la luz.',
      MULTIPLE_FACES: 'Salió más de una persona.',
      FACE_TOO_SMALL: 'El rostro se ve muy pequeño. Acércate.',
      EYES_NOT_VISIBLE: 'No se ven los dos ojos.',
      LOW_QUALITY: 'La foto no tiene calidad suficiente. Repítela.',
      TOO_MANY_FACES: 'Salieron más personas de las permitidas por foto.',
      GATE_CODE_INVALID: 'Código no válido, o la lista ya venció (24 h).',
      USER_ALREADY_LINKED: 'Ese usuario ya está ligado a otra persona.',
      CREW_HAS_PEOPLE: 'La cuadrilla tiene personas. Reasígnalas primero.',
    },
    genericError: 'No se pudo completar la acción. Inténtalo de nuevo.',
    listLabel: 'Lista',
    pickList: (n: number) => `Elige una lista (${n})`,
    filterSearch: 'Buscar por nombre o número',
    allCrews: 'Todas las cuadrillas',
    allStatuses: 'Todos los estados',
    allEnrollment: 'Todo enrolamiento',
    filterPending: 'Enrolamiento incompleto',
    clearFilters: 'Quitar filtros',
    noMatches: 'Ninguna persona coincide con los filtros.',
    validating: 'Revisando…',
    importing: 'Importando…',
    colRow: 'Fila',
    template: 'Descargar plantilla',
    warnings: 'Avisos',
    colName: 'Nombre',
    colStatus: 'Estado',
    colEnrollment: 'Enrolamiento',
    colMisses: 'Inasistencias',
    colActions: 'Acciones',
    statusACTIVE: 'Activo',
    statusPRE_TERMINATION: 'Pre-baja',
    statusINACTIVE: 'Baja',
    enrolled: 'Enrolado',
    noConsent: 'Sin consentimiento',
    photosOf: 'fotos',
    keep: 'Mantener',
    terminate: 'Dar de baja',
    deleteBiometrics: 'Eliminar datos biométricos',
    deleteTitle: 'Eliminar datos biométricos de',
    deleteBody: 'Se borran el rostro registrado, las fotos de enrolamiento y las fotos de asistencia de esta persona. En fotos de grupo solo se tapa su rostro. Se conserva su nombre y las fechas y horas de asistencia. No se puede deshacer.',
    typeName: 'Escribe el nombre completo para confirmar',
    reason: 'Motivo (obligatorio)',
    cancel: 'Cancelar',
    deletePerson: 'Borrar persona',
    deletePersonTitle: 'Borrar a',
    deletePersonBody: 'Se elimina el registro de esta persona, su rostro y sus fotos de enrolamiento. Solo se puede si nunca tuvo asistencias; si ya tiene historial, dala de baja. No se puede deshacer.',
    confirmDelete: 'Eliminar datos biométricos',
    receiptTitle: 'Comprobante de eliminación',
    receiptFaces: 'Rostros eliminados',
    receiptEnroll: 'Fotos de enrolamiento eliminadas',
    receiptAttendance: 'Fotos de asistencia eliminadas',
    receiptId: 'Folio',
    close: 'Cerrar',
    loading: 'Cargando…',
    empty: 'Todavía no hay personas.',
    disabled: 'La asistencia por rostro no está activada en tu empresa. Pídele a un Super Admin que la active.',
    date: 'Fecha',
    lote: 'Lote',
    sessionStatus: 'Estado',
    open: 'Abierta',
    closed: 'Cerrada',
    present: 'Presentes',
    missing: 'Faltantes',
    extras: 'Personas extra',
    noSessions: 'No hay listas para esa fecha.',
    viewStamped: 'Ver foto con sello',
    viewEnrollPhotos: 'Ver fotos de enrolamiento',
    enrollPhotosTitle: 'Fotos de enrolamiento de',
    noEnrollPhotos: 'Sin fotos de enrolamiento.',
    sessionPhotos: 'Fotos de esta lista',
    allStaff: 'Todo el personal',
    destination: 'Destino',
    sessionNotes: 'Notas',
    noSessionPhotos: 'Esta lista aún no tiene fotos.',
    tabDay: "Listas del día",
    tabReport: "Reporte",
    from: "Desde",
    to: "Hasta",
    allLotes: "Todos los lotes",
    download: "Descargar Excel",
    byPerson: "Por persona",
    byDay: "Por día",
    totalSessions: "Listas",
    colPresent: "Presente",
    colAbsent: "Ausencias",
    colJustified: "Justificadas",
    colUndecided: "Sin decidir",
    colPct: "% asistencia",
    colLate: "Retardos",
    colHours: "Horas",
    colExpected: "Esperados",
    colExtras: "Extra",
    colDate: "Fecha",
    colLote: "Lote",
    reportHint: "Porcentaje = días presente / (presente + ausencias). Las justificadas no cuentan a favor ni en contra.",
    reportEmpty: "No hay listas en ese periodo.",
    rangeError: "Revisa las fechas: máximo 93 días y la fecha inicial no puede ser mayor a la final.",
    extrasTotal: "Personas extra",
    undecided: 'Sin decidir',
    absent: 'Ausente',
    justified: 'Justificado',
    back: 'Volver',
  },
  evidencePage: {
    open: 'Abrir',
    download: 'Descargar',
    folders: 'Carpetas',
    empty: 'Aún no hay fotos de evidencia.',
  },
  invalidRequest: 'Solicitud no válida',
  shipmentEvidence: {
    title: 'Evidencia de embarque',
    createTitle: 'Crear enlace',
    label: 'Nombre del enlace',
    days: 'Días de vigencia (1 a 30)',
    stages: 'Etapas incluidas (vacío = todas)',
    stageNames: { LOADING: 'Carga', SEALING: 'Sello', DEPARTURE: 'Salida', CHECKPOINT: 'Tránsito', INSPECTION: 'Inspección', DELIVERY: 'Entrega', INCIDENT: 'Incidente' },
    create: 'Crear enlace',
    created: 'Enlace creado. Cópialo ahora: el token no se vuelve a mostrar.',
    copy: 'Copiar enlace',
    shareTitle: 'Enlaces compartidos',
    none: 'Este embarque no tiene enlaces.',
    active: 'Activo',
    revoked: 'Revocado',
    expired: 'Vencido',
    revoke: 'Revocar',
    expiresOn: 'Vence el',
    loading: 'Cargando…',
    public: 'Evidencia compartida',
    invalid: 'El enlace no es válido o ya venció.',
    noEvidence: 'Sin evidencias.',
    stageLabel: 'Etapa',
    takenAt: 'Tomada el',
    open: 'Abrir',
  },
  budgetNotice: {
    title: 'Aviso de presupuesto',
  },
  footer: {
    socialTitle: "Redes sociales",
    networks: {
      facebook: "Facebook",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      youtube: "YouTube",
      x: "X",
    },
    openBot: "Abrir el bot de Agrovid",
    openQr: "Abrir en el celular",
    qrTitle: "Abre Agrovid en tu celular",
    qrHint: "Escanea el código con la cámara de tu teléfono.",
    qrClose: "Cerrar",
    legalNav: "Información legal",
    usagePolicy: "Políticas de uso",
    terms: "Términos y condiciones",
    privacy: "Aviso de privacidad",
    rights: (year: number) => `© ${year} Agrovid. Todos los derechos reservados.`,
  },
  legal: {
    contactLabel: "Contacto",
    back: "← Volver al inicio",
    updated: "Última actualización: octubre de 2026",
    draftNotice: "Borrador pendiente de revisión legal. Este texto es informativo y no sustituye el asesoramiento de un abogado; no debe considerarse definitivo hasta su validación.",
    docs: {
      usage: {
        title: "Políticas de uso",
        sections: [
          {
            heading: "1. Uso permitido",
            body: "La plataforma se usa para gestionar operaciones agrícolas de tu empresa: registros de campo, inventario, finanzas y reportes. Solo las personas autorizadas por el administrador de la empresa pueden acceder.",
          },
          {
            heading: "2. Conductas no permitidas",
            body: "No se permite compartir credenciales, intentar acceder a datos de otras empresas, introducir información falsa a propósito, extraer datos de forma masiva ni interferir con el funcionamiento del servicio.",
          },
          {
            heading: "3. Responsabilidad sobre los datos",
            body: "Cada empresa es responsable de la veracidad de la información que registra, incluidos los datos de aplicaciones fitosanitarias, cosechas y evidencias.",
          },
          {
            heading: "4. Suspensión",
            body: "Podemos suspender cuentas que incumplan estas políticas o pongan en riesgo la seguridad del servicio o de otros usuarios.",
          },
        ],
      },
      copyright: {
        title: "Derechos de autor",
        sections: [
          {
            heading: "1. Titularidad",
            body: "El software, el diseño, las marcas, los logotipos y los textos de Agrovid son propiedad de sus titulares y están protegidos por las leyes de derechos de autor y propiedad industrial aplicables.",
          },
          {
            heading: "2. Licencia de uso",
            body: "Se concede a cada empresa una licencia limitada, no exclusiva e intransferible para usar la plataforma durante la vigencia de su contrato. No se permite copiar, modificar, descompilar ni redistribuir el software.",
          },
          {
            heading: "3. Datos de la empresa",
            body: "Los datos que cada empresa registra siguen siendo suyos. Agrovid solo los trata para prestar el servicio.",
          },
          {
            heading: "4. Reclamaciones",
            body: "Si crees que algún contenido infringe derechos de autor, escríbenos al correo de contacto con la descripción del contenido y de tu titularidad.",
          },
        ],
      },
      terms: {
        title: "Términos y condiciones",
        sections: [
          {
            heading: "1. Aceptación",
            body: "Al acceder o usar Agrovid aceptas estos términos. Si usas la plataforma en nombre de una empresa, declaras tener autoridad para obligarla.",
          },
          {
            heading: "2. Servicio y disponibilidad",
            body: "Ofrecemos la plataforma web y los bots de Telegram tal como están, procurando alta disponibilidad, sin garantizar un servicio ininterrumpido ni libre de errores.",
          },
          {
            heading: "3. Cuentas y seguridad",
            body: "Eres responsable de la confidencialidad de tu acceso y de la actividad realizada con tu cuenta. Avísanos de inmediato si sospechas un uso no autorizado.",
          },
          {
            heading: "4. Limitación de responsabilidad",
            body: "Las recomendaciones agronómicas y los cálculos son apoyos a la decisión; la decisión final y su cumplimiento normativo corresponden al usuario. En la medida permitida por la ley, no respondemos por daños indirectos.",
          },
          {
            heading: "5. Cambios y ley aplicable",
            body: "Podemos actualizar estos términos y lo avisaremos en la plataforma. Se rigen por las leyes de los Estados Unidos Mexicanos.",
          },
        ],
      },
      privacy: {
        title: "Aviso de privacidad",
        sections: [
          {
            heading: "1. Responsable",
            body: "Agrovid es responsable del tratamiento de tus datos personales conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares. Contacto: el correo de contacto indicado al final de esta página.",
          },
          {
            heading: "2. Datos que tratamos",
            body: "Nombre, teléfono, correo, identificador de Telegram, rol y actividad dentro de la plataforma, además de la información operativa que registras (lotes, aplicaciones, inventarios, finanzas) y las fotos o ubicaciones que adjuntes como evidencia.",
          },
          {
            heading: "3. Finalidades",
            body: "Prestar el servicio, autenticarte, mantener la trazabilidad y el cumplimiento normativo, enviarte avisos operativos y mejorar la plataforma. No vendemos tus datos personales.",
          },
          {
            heading: "4. Transferencias y proveedores",
            body: "Usamos proveedores de infraestructura en la nube y de inteligencia artificial para operar el servicio, bajo medidas de confidencialidad y seguridad.",
          },
          {
            heading: "5. Derechos ARCO",
            body: "Puedes acceder, rectificar, cancelar u oponerte al tratamiento de tus datos escribiendo al correo de contacto. Responderemos en los plazos que marca la ley.",
          },
          {
            heading: "6. Cambios",
            body: "Publicaremos en esta página cualquier modificación a este aviso.",
          },
        ],
      },
    },
  },
  // ── Navegación ──────────────────────────────────────────────────────────────
  nav: {
    myDay: "Mi día",
    groups: {
      campo: "Campo",
      cosechaVenta: "Cosecha y venta",
      recursos: "Recursos",
      finanzas: "Finanzas",
      cumplimiento: "Cumplimiento y reportes",
      admin: "Administración",
    },
    sections: {
      campoOperacion: 'Operación de Campo',
      finanzasInversion: 'Finanzas e Inversión',
      comercialLogistica: 'Comercial y Logística',
      riesgoCumplimiento: 'Riesgo y Cumplimiento',
      admin: 'Administración',
    },
    dashboard:  'Inicio',
    investorOverview: 'Resumen',
    investorModules: 'Zonas',
    investorYield: 'Rendimiento',
    investorLogistics: 'Logística',
    investorFunding: 'Inversión y Fondos',
    investorProduction: 'Producción',
    tasks:      'Tareas',
    finance:    'Finanzas',
    fieldLots:  'Campo & Lotes',
    irrigation: 'Riego',
    harvest:    'Cosecha',
    inventory:  'Inventario',
    inventories: 'Carga Masiva',
    machinery:  'Maquinaria',
    spray:      'Aplicaciones',
    porcino:    'Porcino',
    payroll:    'Nómina',
    reports:    'Reportes',
    map:        'Mapa GIS',
    chat:       'Chat IA',
    users:      'Usuarios',
    settings:   'Configuración',
    config:     'Configuración',
    gettingStarted: 'Primeros pasos',
    companies:  'Empresas',
    ranchos:    'Ranchos',
    system:     'Sistema',
    bulkImport: 'Carga masiva',
    // Sprint A
    merma:      'Merma',
    crop:       'Cultivo',
    // Sprint B
    export:      'Exportación',
    transport:   'Transporte',
    traceability:'Trazabilidad',
    fsmaExport:  'Entrega FSMA 204',
    protocol:    'Protocolos',
    permisos:    'Permisos',
    vocabulary:  'Vocabulario',
    drones:      'Drones',
    devices:     'Dispositivos',
    sales:       'Ventas',
    documents:   'Documentos',
    evidence:    'Evidencias',
    personnel: 'Personal',
    attendance: 'Asistencia',
    gate: 'Caseta',
    riesgos:     'Riesgos',
    complianceRules: 'Reglas de cumplimiento',
    costos:      'Costos',
    calculators: 'Calculadoras',
    expensesDashboard: 'Gastos',
    expenseApprovals: 'Por aprobar',
    incompleteDrafts: 'Registros incompletos',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    changeLanguage: 'Cambiar idioma',
    changeTheme: 'Cambiar tema',
    viewProfile: 'Ver perfil',
  },

  // ── Común ───────────────────────────────────────────────────────────────────
  telegramHelp: {
    tooltip: 'Cómo hacer esto por Telegram',
    title: 'Hazlo por Telegram',
    intro: 'Esta misma operación se puede registrar hablándole o escribiéndole al bot de Agrovid en Telegram, sin usar este formulario.',
    asCommand: 'Como comando',
    naturalLanguage: 'Con lenguaje natural (voz o texto)',
    defaultDesc: 'La IA entiende la instrucción, prepara un borrador y te pide confirmar antes de guardar cualquier dato.',
    gotIt: 'Entendido',
    openBot: 'Abrir en Telegram',
    botOnline: 'en línea',
    examples: {
      machinery: [
        { voice: "Arranqué el tractor John Deere en el lote 4, rastreo", desc: "El bot inicia el cronómetro de la máquina en ese lote con la actividad indicada." },
        { voice: "Terminé con el tractor, gasté 40 litros de diésel y trabajé 6 hectáreas", desc: "Cierra la sesión y calcula el costo por hectárea con combustible y horas." },
      ],
      sales: [
        { voice: "Nos depositó 20 mil dólares de la factura 123", desc: "El bot arma un borrador del cobro y baja el saldo al confirmar." },
        { voice: "Cobramos 150 mil pesos del cliente Frutas del Norte", desc: "Funciona con pesos o dólares; siempre pide confirmación antes de guardar." },
      ],
      cropPhenology: [
        { voice: "El bitter melon del lote 4 ya entró en floración, va en el día 35 después de siembra", desc: "El bot registra la etapa fenológica actual del cultivo." },
        { voice: "Lote 2 ya está en fructificación, día 60", desc: "Cambia la etapa del lote y recalcula los días a cosecha." },
        { voice: "El ejote del lote 7 apenas emergió, día 8", desc: "Sirve para dar seguimiento a cultivos recién sembrados." },
      ],
      cropPest: [
        { voice: "Encontré mosca blanca en el lote 4, presión media, como el 25% de las plantas", desc: "El bot registra la plaga o enfermedad y calcula el nivel de presión." },
        { voice: "Hay trips en el lote 2, presión alta, casi la mitad del lote", desc: "Una presión alta puede disparar una alerta para el agrónomo." },
        { voice: "Vi manchas de mildiu en el lote 7, apenas unas plantas", desc: "Registra enfermedades igual que plagas, con su incidencia." },
      ],
      finance: [
        { voice: "Define el presupuesto del lote 4 ciclo 2026-A en 40,000 pesos por hectárea", desc: "El bot puede registrar un presupuesto base para el ciclo, con producción y precio estimados." },
        { voice: "Presupuesto del lote 7 ciclo 2026-B: 55,000 pesos, esperamos 12 toneladas a 18 pesos el kilo", desc: "Incluye la producción y el precio estimados para proyectar el margen." },
        { voice: "¿Cuánto llevamos gastado del presupuesto del lote 4?", desc: "También puedes consultar el avance contra lo presupuestado." },
      ],
      harvest: [
        { voice: "Empacamos 40 cajas de ejote grado A y 5 de grado B del lote 4, calibre mediano", desc: "El bot registra el empaque con el desglose de grados y calcula el packout %." },
        { voice: "Cosecha del lote 2: 120 cajas grado A, 30 grado B y 10 de segunda", desc: "Puedes dictar varios grados en un solo mensaje." },
        { voice: "Hoy cortamos 300 kilos de bitter melon en el lote 7", desc: "Si no hay cajas, el bot puede registrar el peso cosechado." },
      ],
      inventory: [
        { voice: "Entraron 20 sacos de fertilizante Novatec al almacén, factura de $15,000", desc: "El bot registra la entrada o salida de bodega automáticamente, validando el producto contra el catálogo." },
        { voice: "Salieron 5 litros de Abamectin de la bodega para el lote 4", desc: "Las salidas descuentan del inventario y quedan ligadas al lote." },
        { voice: "¿Cuánto queda de Novatec en bodega?", desc: "También puedes consultar existencias sin abrir el sistema." },
      ],
      irrigation: [
        { voice: "Regamos 4 horas el lote Norte con la mochila motorizada, agregamos 2 litros de nitrógeno", desc: "El bot registra el riego (manual, medidor o simplificado) y la fertirrigación si aplica." },
        { voice: "Riego por goteo en el lote 4, de 6 a 10 de la mañana", desc: "Con la hora de inicio y fin calcula la duración del riego." },
        { voice: "Lectura del medidor del lote 7: 1,250 metros cúbicos", desc: "Para riego con medidor, el bot calcula el consumo contra la lectura previa." },
      ],
      merma: [
        { voice: "Hubo merma de 50 kilos de ejote en el lote 4 por pudrición", desc: "El bot registra la merma con la causa y calcula el impacto económico." },
        { voice: "Se perdieron 12 cajas de bitter melon del lote 2 por golpe de calor", desc: "Puedes indicar cajas en lugar de kilos." },
        { voice: "Tiramos 30 kilos de producto en empaque por daño mecánico", desc: "Registra mermas también después de la cosecha." },
      ],
      payroll: [
        { voice: "Juan Pérez trabajó 3 jornales en el lote 4 a $250 el día", desc: "El bot registra el pago (jornal, destajo o contrato) en el período de nómina abierto." },
        { voice: "María López cortó 80 cajas de ejote en el lote 2 a 6 pesos la caja", desc: "Para destajo, indica la cantidad y la tarifa por unidad." },
        { voice: "Pedro Ramírez, contrato de $3,000 por limpiar el canal del lote 7", desc: "Los contratos se registran con un monto fijo." },
      ],
      porcinoEntry: [
        { voice: "Entraron 80 cerdos al corral 3, peso promedio 25 kilos, proveedor Granja del Norte", desc: "El bot registra el lote de engorda y marca el corral como en uso." },
        { voice: "Llegaron 120 lechones al corral 1, 18 kilos en promedio", desc: "Cada entrada abre un nuevo lote de engorda." },
        { voice: "Recibimos 60 cerdos del proveedor Los Pinos en el corral 5, 30 kilos promedio", desc: "Incluye el proveedor para llevar trazabilidad." },
      ],
      porcinoEvent: [
        { voice: "Pesamos el lote del corral 3, ahora andan en 55 kilos promedio", desc: "El bot detecta si es pesaje, alimento, mortalidad o venta y registra el evento correspondiente." },
        { voice: "Hoy se murieron 2 cerdos en el corral 3", desc: "Registra mortalidad y descuenta cabezas del lote." },
        { voice: "Dimos 400 kilos de alimento al corral 3", desc: "El alimento alimenta el cálculo de conversión." },
        { voice: "Vendimos 50 cerdos del corral 3, 6,000 kilos totales a 32 pesos el kilo", desc: "La venta cierra cabezas y calcula el ingreso." },
      ],
      protocol: [
        { voice: "Aquí está el protocolo de fertilización para bitter melon", desc: "Se puede enviar junto con una foto o PDF del protocolo; la IA no inventa dosis, solo extrae lo que viene en el documento." },
        { voice: "Este es el programa de control de plagas para ejote, ciclo 2026-A", desc: "Funciona con protocolos fitosanitarios y de nutrición." },
        { voice: "Te mando la lista de precios de agroquímicos del proveedor", desc: "También extrae el catálogo de precios del documento." },
      ],
      spray: [
        { voice: "Apliqué Abamectin en el lote 4 con el dron, 2 cargas, entré a las 7 y salí a las 8", desc: "El bot valida automáticamente el compliance MRL/PHI antes de guardar cualquier aplicación fitosanitaria." },
        { voice: "Fumigué el lote 2 con mochila, 3 tanques de Spinosad, operador Luis", desc: "Registra equipo, tanques y operador." },
        { voice: "Apliqué cobre en el lote 7, 4 litros por hectárea, mercado Estados Unidos", desc: "Si el producto no cumple el MRL del mercado, el bot te avisa antes de guardar." },
      ],
      tasks: [
        { voice: "Mañana hay que aplicar fertilizante en el lote 4, avísale a Everardo", desc: "El bot programa la tarea para el trabajador indicado y le notifica a las 7am." },
        { voice: "El viernes toca podar el lote 2, asígnaselo a Manuel", desc: "Puedes indicar el día y el responsable en la misma frase." },
        { voice: "Recuérdale a todo el equipo de riego revisar las mangueras el lunes", desc: "Una tarea se puede enviar a todo un grupo." },
      ],
      transport: [
        { voice: "Sale un embarque del lote 4 hacia McAllen, 200 cajas de ejote grado A, chofer Manuel, placas ABC-123", desc: "El bot registra el embarque con destino, cajas y datos del transporte." },
        { voice: "Mandamos 150 cajas de bitter melon a la central de abastos de Guadalajara", desc: "Con destino y cajas basta; el resto se puede completar después." },
        { voice: "El embarque a McAllen ya llegó, entregamos 198 cajas", desc: "Puedes avisar la llegada y las cajas entregadas." },
      ],
    },
    cropPhenologyVoice: 'El bitter melon del lote 4 ya entró en floración, va en el día 35 después de siembra',
    cropPhenologyDesc: 'El bot registra la etapa fenológica actual del cultivo.',
    cropPestVoice: 'Encontré mosca blanca en el lote 4, presión media, como el 25% de las plantas',
    cropPestDesc: 'El bot registra la plaga o enfermedad y calcula el nivel de presión.',
    financeVoice: 'Define el presupuesto del lote 4 ciclo 2026-A en 40,000 pesos por hectárea',
    financeDesc: 'El bot puede registrar un presupuesto base para el ciclo, con producción y precio estimados.',
    harvestVoice: 'Empacamos 40 cajas de ejote grado A y 5 de grado B del lote 4, calibre mediano',
    harvestDesc: 'El bot registra el empaque con el desglose de grados y calcula el packout %.',
    inventoryVoice: 'Entraron 20 sacos de fertilizante Novatec al almacén, factura de $15,000',
    inventoryDesc: 'El bot registra la entrada o salida de bodega automáticamente, validando el producto contra el catálogo.',
    irrigationVoice: 'Regamos 4 horas el lote Norte con la mochila motorizada, agregamos 2 litros de nitrógeno',
    irrigationDesc: 'El bot registra el riego (manual, medidor o simplificado) y la fertirrigación si aplica.',
    mermaVoice: 'Hubo merma de 50 kilos de ejote en el lote 4 por pudrición',
    mermaDesc: 'El bot registra la merma con la causa y calcula el impacto económico.',
    payrollVoice: 'Juan Pérez trabajó 3 jornales en el lote 4 a $250 el día',
    payrollDesc: 'El bot registra el pago (jornal, destajo o contrato) en el período de nómina abierto.',
    porcinoEntryVoice: 'Entraron 80 cerdos al corral 3, peso promedio 25 kilos, proveedor Granja del Norte',
    porcinoEntryDesc: 'El bot registra el lote de engorda y marca el corral como en uso.',
    porcinoEventVoice: 'Pesamos el lote del corral 3, ahora andan en 55 kilos promedio',
    porcinoEventDesc: 'El bot detecta si es pesaje, alimento, mortalidad o venta y registra el evento correspondiente.',
    protocolCommandDesc: 'El agrónomo envía la foto o documento del protocolo de insumos y la IA extrae aplicaciones, dosis y catálogo de precios automáticamente.',
    protocolVoice: 'Aquí está el protocolo de fertilización para bitter melon',
    protocolDesc: 'Se puede enviar junto con una foto o PDF del protocolo; la IA no inventa dosis, solo extrae lo que viene en el documento.',
    sprayVoice: 'Apliqué Abamectin en el lote 4 con el dron, 2 cargas, entré a las 7 y salí a las 8',
    sprayDesc: 'El bot valida automáticamente el compliance MRL/PHI antes de guardar cualquier aplicación fitosanitaria.',
    tasksVoice: 'Mañana hay que aplicar fertilizante en el lote 4, avísale a Everardo',
    tasksDesc: 'El bot programa la tarea para el trabajador indicado y le notifica a las 7am.',
    transportVoice: 'Sale un embarque del lote 4 hacia McAllen, 200 cajas de ejote grado A, chofer Manuel, placas ABC-123',
    transportDesc: 'El bot registra el embarque con destino, cajas y datos del transporte.',
  },

  inventoryUpload: {
    dragDrop: 'Arrastra y suelta aquí el archivo de Excel',
    orBrowse: 'o haz clic para buscarlo',
    selected: 'Seleccionado:',
    upload: 'Subir',
    historyTitle: 'Historial de cargas',
    colFile: 'Archivo',
    colStatus: 'Estado',
    colRecords: 'Registros',
    colErrors: 'Errores',
    colDate: 'Fecha',
  },

  common: {
    colorLabel: 'Color en el mapa',
    colorCustom: 'Color personalizado',
    colorClear: 'Quitar color',
    loading:    'Cargando...',
    save:       'Guardar',
    cancel:     'Cancelar',
    edit:       'Editar',
    delete:     'Eliminar',
    search:     'Buscar',
    noData:     'Sin datos.',
    yes:        'Sí',
    no:         'No',
    of:         'de',
    actions:    'Acciones',
    status:     'Estado',
    date:       'Fecha',
    total:      'Total',
    name:       'Nombre',
    type:       'Tipo',
    method:     'Método',
    notes:      'Notas',
    reloadPage: 'Recargar página',
    errorUnexpected: 'Ocurrió un error inesperado en la aplicación.',
    somethingWrong:  'Algo salió mal',
    searchNoResults: 'Sin resultados',
    createNamed: 'Crear «{name}»',
    close: 'Cerrar',
    zoneCycleClosed: 'Ciclo cerrado',
    searchRanchoPlaceholder: 'Buscar rancho...',
    searchLotePlaceholder: 'Buscar lote...',
    searchBatchPlaceholder: 'Buscar ciclo...',
    validation: {
      fieldRequired: 'Este campo es requerido',
      nameRequired:       'El nombre es requerido',
      ranchoRequired:     'El rancho es requerido',
    },
    valueLabel: 'Valor',
    rangeLabel: 'Rango',
    configSaveError: 'No se pudo guardar la configuración.',
  },

  // ── Auth ────────────────────────────────────────────────────────────────────
  phoneField: {
    countryLabel: 'País',
    phoneLabel: 'Teléfono',
    placeholder: '4421234567',
    favorites: 'Favoritos',
    allCountries: 'Todos los países',
    invalidTen: 'Escribe los 10 dígitos de tu número, sin lada de país ni 0 inicial. Ej. 4421234567',
    invalidGeneric: 'Número inválido para el país elegido (8 a 15 dígitos en total).',
    hint: 'Solo tu número, sin lada de país.',
  },
  passwordField: {
    show: 'Mostrar contraseña',
    hide: 'Ocultar contraseña',
    confirmLabel: 'Confirmar contraseña',
    mismatch: 'Las contraseñas no coinciden',
    rulesTitle: 'Tu contraseña debe tener:',
    ruleLength: 'Al menos {n} caracteres',
    ruleUpper: 'Una letra mayúscula',
    ruleLower: 'Una letra minúscula',
    ruleNumber: 'Un número',
    ruleSpecial: 'Un carácter especial (ej. ! @ # $)',
    rulePass: 'Cumple',
    ruleFail: 'Falta',
  },
  auth: {
    title:        'Agrovid',
    subtitle:     'Gestión agrícola inteligente',
    loginGoogle:  'Inicia sesión con tu cuenta de Google',
    googleBtn:    'Iniciar sesión con Google',
    demoBtn:      'Entrar como Demo (sin cuenta)',
    otpSent:      'Enviamos un código a tu Telegram',
    otpPlaceholder: '000000',
    verify:       'Verificar',
    back:         '← Volver',
    errorGoogle:  'Error al autenticar con Google',
    errorOtp:     'Código incorrecto',
    errorDemo:    'Error al iniciar demo',
    logOut:       'Salir',
    hasPasswordLink: '¿Tienes contraseña? Inicia sesión aquí',
    emailPasswordTitle: 'O entra con tu correo y contraseña',
    emailLoginPlaceholder: 'tucorreo@ejemplo.com',
    passwordSubtitle: 'Inicia sesión con teléfono y contraseña',
    passwordPlaceholder: 'Contraseña',
    phonePlaceholder: '4421234567',
    enter:        'Entrar',
    errorPassword: 'Credenciales inválidas',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    passwordResetSubtitle: 'Recupera tu contraseña',
    resetViaTelegram: 'Vía Telegram',
    resetViaEmail: 'Vía Email',
    resetEmailPlaceholder: 'tucorreo@ejemplo.com',
    phoneCountryHint: 'Escribe tu número con código de país, ej. +52…',
    phoneInvalid: 'Teléfono inválido. Escribe tu número a 10 dígitos, ej. 4421234567',
    emailInvalid: 'Correo inválido',
    resetCodeSentHint: 'Si el dato está registrado y tiene el método vinculado, recibirás un código.',
    resetNotArrived: 'No me llegó: probar por otro método',
    resendCode: 'Reenviar código',
    resendIn: 'Reenviar en {n} s',
    resetLocked: 'Se agotaron los envíos de código. Pide a tu administrador que desbloquee la recuperación de contraseña.',
    otpWait: 'Espera {n} s antes de pedir otro código.',
    otpLocked: 'Se agotaron los envíos de código. Pide a tu administrador que desbloquee el acceso.',
    googleEmailNotRegistered: 'El correo {email} no está registrado.',
    googleUseOtherAccount: 'Usar otra cuenta',
    sendCode: 'Enviar código',
    enterResetCode: 'Ingresa el código y tu nueva contraseña',
    newPasswordPlaceholder: 'Nueva contraseña',
    resetPassword: 'Establecer contraseña',
    tenantNotFound: 'Empresa no encontrada',
    tenantNotFoundHint: 'Verifica la URL o contacta al administrador.',
    inviteBanner: 'Tienes una invitación para unirte como',
    // F0.10 — página de aceptación de invitación
    acceptInviteTitle: 'Completa tu registro',
    acceptInviteSubtitle: 'Te invitaron a unirte como',
    acceptInviteName: 'Nombre completo',
    acceptInvitePhone: 'Teléfono',
    acceptInvitePhoneOptional: "Teléfono (opcional)",
    acceptInviteIdentityRequired: "Escribe un teléfono o un correo, o entra con Google.",
    acceptInvitePasswordNeedsEmail: "Para usar contraseña escribe también tu correo.",
    acceptInviteEmail: 'Email (para entrar con Google)',
    acceptInvitePassword: 'Contraseña (opcional)',
    acceptInvitePasswordHint: 'Si la dejas en blanco entrarás con Google o con Telegram.',
    acceptInviteSubmit: 'Crear mi cuenta',
    acceptInviteLoading: 'Verificando invitación...',
    acceptInviteInvalid: 'Esta invitación no es válida o ya expiró. Pide una nueva a tu administrador.',
    acceptInviteUsed: 'Esta invitación ya se usó. Si ya tienes cuenta, inicia sesión.',
    acceptInvitePhoneTaken: 'Ya existe una cuenta con ese teléfono. Inicia sesión en vez de registrarte.',
    acceptInviteLinkTelegram: 'Vincular mi Telegram',
    acceptInviteError: 'No pudimos crear tu cuenta. Revisa los datos e intenta de nuevo.',
    acceptInviteNameRequired: 'Escribe tu nombre',
    acceptInvitePhoneRequired: 'Escribe un teléfono válido (México y EE. UU.: 10 dígitos)',
    acceptInviteEmailInvalid: 'Email inválido',
    acceptInvitePasswordShort: 'La contraseña debe tener al menos 8 caracteres',
    acceptInviteGoToLogin: 'Ir a iniciar sesión',
    // F0.10 — Google pide OTP pero la cuenta no tiene Telegram vinculado
    telegramNotLinked: 'Tu cuenta no tiene Telegram vinculado, así que no podemos enviarte el código.',
    telegramNotLinkedHint: 'Pide a tu administrador el enlace de vinculación de Telegram.',
    telegramNotLinkedPassword: 'También puedes entrar con tu contraseña.',
    roleSelectionTitle: 'Selecciona tu rol',
    roleSelectionSubtitle: 'Elige el rol con el que deseas acceder',
    selectRoleError: 'Error al seleccionar el rol. Intenta de nuevo.',
    noRoleAssigned: 'Tu cuenta no tiene un rol asignado, habla con tu administrador.',
    noRoleSignOut: 'Salir',
    roles: {
      fieldWorker: 'Trabajador de Campo',
      supervisor: 'Supervisor',
      admin: 'Administrador',
      agronomist: 'Agrónomo',
      superAdmin: 'Super Administrador',
      auditor: 'Auditor',
      warehouseManager: 'Bodeguero',
      investor: 'Inversionista',
    },
  },

  // ── Demo usuarios ────────────────────────────────────────────────────────────
  demo: {
    fieldWorker:      'Acceso a operaciones y registro de actividades',
    supervisor:       'Autoridad en operaciones y gestión de tareas',
    warehouseManager: 'Gestión de inventario, stock y control FEFO',
    agronomist:       'Protocolos de cultivo, fenología y monitoreo de plagas',
    investor:         'KPIs financieros, reportes y vista de inversión (solo lectura)',
    admin:            'Acceso administrativo completo incluyendo usuarios y finanzas',
  },

  // ── Dashboard ───────────────────────────────────────────────────────────────
  dashboard: {
    title:          'Dashboard',
    kpiCostToday:   'Costo hoy',
    kpiActivities:  'Actividades',
    kpiActivitiesSub: 'últimas 24h',
    kpiPendingTasks: 'Tareas pendientes',
    kpiOverdueTasks: 'Tareas vencidas',
    kpiActiveLots:   'Lotes activos',
    kanbanTitle:    'Kanban — Tareas de hoy',
    activityTitle:  'Actividad reciente',
    loadingKpis:    'Cargando KPIs...',
    moveTo:         'Mover a',
  },

  // ── Onboarding ───────────────────────────────────────────────────────────────
  onboarding: {
    title:          'Cómo Empezar',
    celebration:    '¡Felicidades! Ya estás listo para arrancar 🎉',
    stepPotreros:   'Carga tus campos y lotes',
    stepCultivos:   'Configura tus cultivos',
    stepInsumos:    'Carga tu inventario inicial',
    go:             'Ir',
    bulkImportHint: '¿Vas a dar de alta un rancho completo? Carga ranchos, lotes, usuarios y catálogo de un solo Excel.',
    bulkImportCta:  'Ir a carga masiva',
    required:       'Requerido',
    optional:       'Opcional',
    optionalTitle:  'Opcionales',
    markReviewed:   'Marcar como revisado',
    blocks: { structure: 'Estructura', people: 'Personas', operation: 'Operación', finance: 'Finanzas', system: 'Sistema' },
    items: {
      rancho: { label: 'Crea tu rancho', desc: 'Da de alta al menos un rancho.' },
      lotes_geocerca: { label: 'Lotes con geocerca', desc: 'Dibuja el contorno de tus lotes en el mapa.' },
      cultivo: { label: 'Cultivo y siembra', desc: 'Asigna cultivo y fecha de siembra.' },
      usuarios_accesos: { label: 'Usuarios y accesos', desc: 'Invita usuarios y define sus ranchos y lotes.' },
      telegram: { label: 'Telegram vinculado', desc: 'Vincula tu Telegram para usar el bot de campo.' },
      grupo_telegram: { label: 'Grupo de Telegram', desc: 'Conecta el grupo de Telegram de tu rancho.' },
      productos_reglas: { label: 'Productos y reglas', desc: 'Carga productos y reglas PHI/REI/MRL.' },
      bodega_stock: { label: 'Bodega y stock', desc: 'Registra el stock inicial de tu bodega.' },
      maquinaria: { label: 'Maquinaria', desc: 'Registra tus tractores y equipos.' },
      nomina: { label: 'Nómina', desc: 'Configura la nómina de tu personal.' },
      presupuesto: { label: 'Presupuesto', desc: 'Define el presupuesto de un ciclo.' },
      locale: { label: 'Idioma y zona horaria', desc: 'Revisa idioma, zona horaria y moneda.' },
      proveedores_ia: { label: 'Proveedores de IA', desc: 'Verifica que los proveedores de IA respondan.' },
      reportes: { label: 'Reportes programados', desc: 'Programa el envío de reportes.' },
    },
  },

  // ── Product Tour (driver.js) ───────────────────────────────────────────────────
  tour: {
    next:     'Siguiente',
    prev:     'Anterior',
    done:     'Listo',
    progress: '{{current}} de {{total}}', // sintaxis propia de driver.js — no es interpolación de nuestro i18n
    dashboard: {
      title: 'Inicio',
      description: 'Aquí ves el resumen general de tu operación: KPIs, últimas actividades y tu progreso de configuración.',
    },
    camposLotes: {
      title: 'Campos y Lotes',
      description: 'Da de alta tus lotes, dibuja sus límites en el mapa y asigna el cultivo o uso de cada uno.',
    },
    tareas: {
      title: 'Tareas',
      description: 'Programa y asigna labores de campo — siembra, pulverización, fertilización — con fecha límite y responsable.',
    },
    insumos: {
      title: 'Insumos',
      description: 'Lleva el inventario de agroquímicos, fertilizantes y demás insumos, con alertas de stock mínimo.',
    },
    finanzas: {
      title: 'Finanzas',
      description: 'Registra gastos e ingresos, y consulta reportes de costo por hectárea y flujo de caja.',
    },
  },

  // ── Contador de adopción (mini-leaderboard privado) ───────────────────────────
  adoption: {
    countSingular: '{count} dato ingresado esta semana',
    countPlural:   '{count} datos ingresados esta semana',
    teamRankingTitle: 'Adopción del equipo esta semana',
  },

  // ── Tareas ───────────────────────────────────────────────────────────────────
  tasks: {
    title:             'Tareas',
    loading:           'Cargando tareas...',
    taskUnit:          'tarea',
    taskUnitPlural:    'tareas',
    overdueLabel:      'vencidas',
    viewKanban:        'Vista Kanban',
    viewList:          'Vista Lista',
    searchPlaceholder: 'Buscar tarea...',
    filterAllLots:     'Todos los lotes',
    filterPriority:    'Prioridad',
    filterType:        'Tipo',
    clearFilters:      'Limpiar filtros',
    emptyColumn:       'Sin tareas',
    emptyFilter:       'Sin tareas que coincidan con los filtros.',
    overdueBadge:      'Vencida',
    tableTitle:        'Tarea',
    tableLot:          'Lote',
    tableType:         'Tipo',
    tablePriority:     'Prioridad',
    tableDate:         'Fecha',
    tableStatus:       'Estado',
    newTask:           '+ Nueva tarea',
    newTaskTitle:      'Nueva tarea',
    editTaskTitle:     'Editar tarea',
    deleteTaskTitle:   'Eliminar tarea',
    deleteTaskConfirm: '¿Eliminar esta tarea? Esta acción no se puede deshacer.',
    fieldLote:         'Lote *',
    fieldZone:         'Zona (opcional)',
    zoneAllLote:       'Todo el lote',
    fieldTaskTitle:    'Título *',
    fieldTaskTitlePlaceholder: 'Aplicar fertilizante en V9...',
    fieldDescription:  'Descripción',
    fieldActivityType: 'Tipo de actividad *',
    fieldScheduledDate: 'Fecha programada *',
    fieldDueDate:      'Fecha límite',
    fieldPriority:     'Prioridad',
    fieldAssignedTo:   'Asignado a (teléfono)',
    loteRequired:      'Selecciona un lote',
    noLoteOption: 'Sin lote (tarea general)',
    generalLabel: 'General',
    audTitle: 'Dirigir a',
    audIndividual: 'Individual (sin audiencia)',
    audAll: 'Todos (con acceso al rancho)',
    audRoles: 'Por rol',
    audLotes: 'Por lote',
    audCrops: 'Por cultivo',
    audPickRoles: 'Roles',
    audPickLotes: 'Lotes',
    audPickCrops: 'Cultivos',
    audReachCount: 'Llegará a {n} personas',
    audReachOne: 'Llegará a 1 persona',
    audNoRecipients: 'Esta audiencia no tiene destinatarios',
    audTooMany: 'Supera el máximo de {max} destinatarios: quita personas',
    audRemove: 'Quitar',
    audAdd: 'Añadir persona',
    audAddPlaceholder: 'Buscar persona…',
    audNoTelegram: 'Sin Telegram',
    audLoading: 'Calculando destinatarios…',
    audPreviewError: 'No se pudo calcular la lista de destinatarios',
    audSnapshotHint: 'Esta lista se guarda como foto fija: los cambios de accesos o cultivos no la modifican salvo que pulses “Recalcular destinatarios”.',
    audRecompute: 'Recalcular destinatarios',
    audRecomputed: 'Se añadieron {n} destinatarios nuevos',
    audRecomputeNone: 'No hay destinatarios nuevos',
    audRecomputeError: 'No se pudo recalcular los destinatarios',
    audNoRecipientsError: 'Agrega al menos un destinatario',
    audRoleNames: {
      SUPER_ADMIN: 'Super Admin', ADMIN: 'Admin', AGRONOMIST: 'Agrónomo', SUPERVISOR: 'Supervisor',
      WAREHOUSE_MANAGER: 'Bodeguero', FIELD_WORKER: 'Campo', AUDITOR: 'Auditor', HR: 'Recursos Humanos', GUARD: 'Vigilante', INVESTOR: 'Inversionista',
    },
    ranchoRequired: 'Selecciona un rancho para la tarea general',
    fieldRancho: 'Rancho *',
    titleRequired:     'El título es requerido',
    dateRequired:      'La fecha programada es requerida',
    createTaskError:   'Error al crear la tarea',
    updateTaskError:   'Error al actualizar la tarea',
    deleteTaskError:   'Error al eliminar la tarea',
    assignedToPlaceholder: 'Seleccionar persona...',
    fieldNotifyAt: 'Programar aviso (opcional)',
    notifyAtHint: 'Vacío = se avisa por Telegram al guardar. Con fecha y hora, el aviso sale en ese momento.',
      notifyScheduledLabel: 'Aviso programado', notifyCancelButton: 'Cancelar aviso', notifyKeepButton: 'Conservar aviso', notifyCancelledHint: 'El aviso programado se cancelará al guardar.',
    noAssigneesHint:   'No hay usuarios registrados en Telegram todavía.',
    telegramHelpTooltip: 'Cómo dar de alta a alguien en Telegram',
    telegramHelpTitle:  'Dar de alta un usuario en Telegram',
    telegramHelpIntro:  'Para que alguien aparezca en esta lista, primero debe registrarse con el bot de Agrovid en Telegram. Hay dos formas de hacerlo:',
    telegramHelpCommandLabel: 'Como comando',
    telegramHelpCommandDesc:  'La persona abre el chat con el bot y escribe /start. El bot le pedirá compartir su número de teléfono para autenticarse.',
    telegramHelpVoiceLabel:   'Con lenguaje natural (voz o texto)',
    telegramHelpVoiceExample: 'Hola, quiero registrarme',
    telegramHelpVoiceDesc:    'La IA reconoce la intención y guía el mismo proceso de autenticación paso a paso, sin necesidad de recordar el comando exacto.',
    confirmDialog:            'Entendido',
    linkedShipment:           'Ligada a embarque',
    linkedPayroll:            'Ligada a nómina',
    groupPending:             'Pendientes',
    groupCompleted:           'Completados',
    markComplete:             'Marcar como completada',
    alreadyCompleted:         'Ya completada',
  },

  // ── Tareas (estados y prioridades) ───────────────────────────────────────────
  taskStatus: {
    PENDING:     'Pendiente',
    IN_PROGRESS: 'En progreso',
    COMPLETED:   'Completado',
    CANCELLED:   'Cancelado',
  },

  taskPriority: {
    HIGH:   'Alta',
    MEDIUM: 'Media',
    LOW:    'Baja',
  },

  // ── Registro incompleto — wizard web (Fase 2) ────────────────────────────────
  incompleteDrafts: {
    pageTitle:            'Registros incompletos',
    pageDescription:      'Completa los registros que quedaron pendientes por falta de un dato.',
    emptyState:           'No tienes registros pendientes de completar. 🎉',
    reasonNotSpecified:   'No especificaste el lote.',
    reasonNotFound:       'El lote que mencionaste no está disponible ahora mismo.',
    reasonRestricted:     'El lote que mencionaste no está disponible ahora mismo.',
    reasonAmbiguous:      'Hay más de un lote con ese nombre — elige el correcto.',
    fieldLote:            'Lote',
    fieldQuantity:        'Cantidad / costo',
    fieldDate:            'Fecha',
    fieldNotes:           'Notas',
    completeButton:       'Completar',
    saveButton:           'Guardar cambios',
    cancelButton:         'Cancelar registro',
    cancelConfirmTitle:   '¿Cancelar este registro?',
    cancelConfirmBody:    'Esta acción no se puede deshacer. El registro dictado se perderá.',
    cancelConfirmConfirm: 'Sí, cancelar',
    cancelConfirmDismiss: 'Volver',
    completeSuccess:      '¡Registro completado! Ya puedes confirmarlo desde Telegram.',
    stillIncomplete:      'Guardado, pero todavía falta completar otro dato.',
    cancelSuccess:        'Registro cancelado.',
    myTab:                'Mis registros',
    teamTab:               'Equipo',
    teamEmptyState:       'No hay registros pendientes en tu equipo. 🎉',
    ownerLabel:           'Registro de {name}',
  },

  // ── Campo & Lotes ────────────────────────────────────────────────────────────
  field: {
    title:          'Campo & Lotes',
    searchPlaceholder: 'Buscar lote o cultivo...',
    lots:           'lote',
    lotsPlural:     'lotes',
    loadingLots:    'Cargando lotes...',
    hectares:       'ha',
    lotStatus: {
      ACTIVE:  'Activo',
      FALLOW:  'En barbecho',
      INACTIVE: 'Inactivo',
    },
    // Detalle
    detail: {
      accumulatedCost: 'Costo acumulado',
      costByType:      'Costo por tipo',
      recentActivity:  'Actividad reciente',
      noActivities:    'Sin actividades recientes.',
      loadingCosts:    'Cargando costos...',
    },
    // Form
    editTitle:              'Editar — {name}',
    newLoteTitle:           'Nuevo lote / parcela',
    lotNameLabel:           'Nombre del lote *',
    ranchoIdLabel:          'Rancho *',
    ranchoIdHint:           'ID del rancho al que pertenece este lote',
    searchRanchoPlaceholder: 'Buscar rancho...',
    cropTypeLabel:          'Cultivo actual',
    hectaresLabel:          'Hectáreas',
    usoLabel:               'Uso del lote',
    usoCampo:               'Campo',
    usoAdministrativo:      'Administrativo (oficina, no cuenta como campo)',
    latitudeLabel:          'Latitud',
    goToMapAfterCreate:     'Al guardar, ir al mapa para dibujar la geocerca',
    addGeofence:            'Geocerca',
    geofenceCaptured: 'Geocerca capturada',
    geofenceMissing:  'Sin geocerca',
    editGeofence:     'Editar geocerca',
    addModules:             'Zonas',
    pickOnMapBtn:           'Elegir en el mapa',
    locationDialogTitle:    'Ubicación de {name}',
    locationDialogTitleGeneric: 'Ubicación del lote',
    longitudeLabel:         'Longitud',
    noResultsSearch:        'Sin resultados para tu búsqueda.',
    noLotsRegistered:       'No hay lotes registrados.',
    createFirst:            'Crear primer lote',
    editLot:                'Editar lote',
    newLot:                 'Nuevo lote',
    deleteTitle:            'Eliminar lote',
    deleteMessagePrefix:    '¿Eliminar ',
    deleteMessageSuffix:    '? Esta acción no se puede deshacer. Solo es posible si el lote no tiene actividades registradas.',
    saveChanges:            'Guardar cambios',
    createLote:             'Crear lote',
  },

  // ── Riego ────────────────────────────────────────────────────────────────────
  irrigation: {
    lotesLoadError: 'No se pudieron cargar los lotes.',
    title:         'Riego & Fertirrigación',
    selectLot:     'Seleccionar lote',
    zoneFilter:    'Lote o zona',
    allLotes:      'Todos los lotes',
    tableLote:     'Lote',
    kpiVolume:     'Volumen total (L)',
    kpiVolumeSub:  'riegos',
    kpiEfficiency: 'Promedio L/kg',
    kpiEfficiencySub: 'eficiencia hídrica',
    kpiLastIrrigation: 'Último riego',
    chartVolume:   'Volumen por sesión (últimos 30)',
    chartEfficiency: 'Eficiencia hídrica (L/kg)',
    tableTitle:    'Registros de riego',
    tableDate:     'Fecha',
    tableMethod:   'Método',
    tableVolume:   'Volumen (L)',
    tableDuration: 'Duración (min)',
    tableDepthMm:  'Lámina (mm)',
    fieldDepthMm:  'Lámina (mm, opcional)',
    tableLPerKg:   'L/kg',
    tableFert:     'Fert.',
    tableFertCost: 'Costo Fert.',
    tableTimestamps: 'Tiempos',
    tableRecordedBy: 'Registrado por',
    sourceTelegram: 'Telegram',
    sourceWeb:      'Web',
    chartByLote:    'Volumen por lote (L)',
    flowUnit:       'L/h',
    noRecords:     'Sin registros para este lote.',
    methods: {
      MANUAL:     'Manual',
      METER:      'Medidor',
      SIMPLIFIED: 'Simplificado',
    },
    timestamps: {
      title:               'Tiempos de riego',
      inicioHidratacion:   'Inicio hidratación',
      inicioFertilizacion: 'Inicio fertirrigación',
      finFertilizacion:    'Fin fertirrigación',
      finLavadoCintilla:   'Fin lavado cintilla',
      duracionFert:        'Duración fert.',
    },
    newRecord:          '+ Registrar riego',
    newRecordTitle:     'Registrar riego',
    fieldBatch:         'Ciclo (batchId) *',
    fieldMethod:        'Método *',
    methodManual:       'Manual',
    methodMedidor:      'Medidor',
    methodSimplificado: 'Simplificado',
    fieldDurationMin:   'Duración (minutos)',
    fieldFlowRate:      'Caudal estimado (L/h)',
    fieldMeterStart:    'Lectura inicial',
    fieldMeterEnd:      'Lectura final',
    fieldDescription:   'Descripción',
    fieldNotes:         'Notas',
    batchRequired:      'El ciclo (batchId) es requerido',
    createError:        'Error al registrar el riego',
    create:             'Registrar',
    kpiLoadError: 'No se pudo cargar el KPI de riego.',
    tsHydrationStart: 'Inicio hid',
    tsFertStart: 'Inicio fert',
    tsFertEnd: 'Fin fert',
    tsWashEnd: 'Fin lavado',
    stockDeductWarnTitle: 'Descuento de inventario incompleto',
    stockDeductFailed: 'El riego quedó guardado, pero el descuento automático de insumos no se pudo hacer. Revisa y ajusta el stock en Inventario.',
    stockDeductPartial: 'El riego quedó guardado, pero el descuento automático de insumos quedó parcial (algún insumo no se descontó). Revisa el stock en Inventario.',
  },

  // ── Aplicación de Químicos ────────────────────────────────────────────────────
  spray: {
    title:            'Aplicaciones Fitosanitarias',
    selectLot:        'Seleccionar lote',
    zoneFilter:    'Lote o zona',
    kpiTotal:         'Aplicaciones totales',
    kpiLastApp:       'Última aplicación',
    tableTitle:       'Historial de aplicaciones',
    tableDate:        'Fecha',
    tableLote:        'Lote',
    tableProduct:     'Producto',
    tableDosis:       'Dosis',
    tableOperator:    'Operador',
    tableEquipo:      'Equipo',
    tableCargas:      'Cargas',
    tableVelocidad:   'Velocidad (km/h)',
    tableLitrosAgua:  'Litros agua',
    tableHoraEntrada: 'Hora entrada',
    tableHoraSalida:  'Hora salida',
    noRecords:        'Sin aplicaciones registradas.',
    newApplicationBtn:  '+ Registrar aplicación',
    newApplicationTitle: 'Registrar aplicación fitosanitaria',
    fieldOccurredAt:    'Fecha/hora de aplicación *',
    fieldProductName:   'Producto (nombre) *',
    fieldQty:           'Cantidad *',
    fieldUnit:          'Unidad *',
    fieldProductId:     'Product ID (catálogo, para compliance) *',
    searchProductPlaceholder: 'Buscar producto...',
    fieldCrop:          'Cultivo (compliance) *',
    fieldMarket:        'Mercado destino *',
    fieldPlannedHarvest: 'Fecha de cosecha planeada',
    fieldBatchId:       'Ciclo (batchId)',
    sprayDataTitle:     'Datos de aplicación con equipo (opcional)',
    fieldEquipo:        'Equipo (tractor, dron, mochila)',
    fieldCargas:        'Cargas/tanques',
    fieldVelocidad:     'Velocidad (km/h)',
    fieldLitrosAgua:    'Litros de agua',
    fieldHoraEntrada:   'Hora entrada (HH:MM)',
    fieldHoraSalida:    'Hora salida (HH:MM)',
    fieldOperador:      'Operador',
    fieldNotes:         'Notas',
    dateRequired:       'La fecha es requerida',
    productRequired:    'El nombre del producto es requerido',
    productIdRequired:  'El Product ID es requerido para validar compliance',
    cropRequired:       'El cultivo es requerido para validar compliance',
    complianceBlockedTitle: 'Bloqueado por Compliance MRL/PHI',
    createError:        'Error al registrar la aplicación',
    create:             'Registrar',
  },

  // ── Finanzas ──────────────────────────────────────────────────────────────────
  finance: {
    title:            'Finanzas',
    totalCost:        'Costo total acumulado',
    costByLot:        'Costo por lote',
    weeklyTrend:      'Tendencia semanal',
    byLotTable:       'Desglose por lote',
    tableLot:         'Lote',
    tableActivities:  'Actividades',
    tableCost:        'Costo',
    tableTotal:       'Total',
    loadingSummary:   'Cargando resumen financiero...',
    costLabel:        'Costo',
    // Protocolos
    protocolsTitle:   'Protocolos de insumos cargados',
    protocolsDesc:    'Enviados por Telegram. El costo/ha se usa como presupuesto base al aplicar a un lote.',
    protocolsLoading: 'Cargando protocolos...',
    protocolsEmpty:   'Aún no hay protocolos registrados.',
    protocolCropCycle: 'Cultivo / Ciclo',
    protocolType:     'Tipo',
    protocolChemHa:   'Químico/ha',
    protocolFertHa:   'Fertilizante/ha',
    protocolTotalHa:  'Total/ha',
    protocolOrigin:   'Origen',
    protocolTypeQuimico:     'Químico',
    protocolTypeFertilizante: 'Fertilizante',
    protocolTypeAmbos:       'Ambos',
    protocolSourceDoc:   'DOCX',
    protocolSourcePhoto: 'Foto',
    protocolSourceText:  'Texto',
    tabResumen:          'Resumen',
    tabPL:               'P&L',
    tabCashflow:         'Flujo de Caja',
    tabPresupuesto:      'Presupuesto',
    plTitle:             'Estado de Resultados (P&L)',
    plRevenue:           'Ingresos estimados',
    plRevenueSub:        'Basado en rendimiento × precio en presupuestos activos',
    plCosts:             'Costos reales',
    plMargin:            'Margen bruto',
    plMarginPct:         'Margen %',
    plCostByCategory:    'Costos por categoría',
    plLoading:           'Cargando P&L...',
    cashflowTitle:       'Flujo de Caja',
    cashflowInflow:      'Ingresos',
    cashflowOutflow:     'Egresos',
    cashflowBalance:     'Saldo',
    cashflowWeek:        'Semanal',
    cashflowMonth:       'Mensual',
    cashflowLoading:     'Cargando flujo de caja...',
    budgetTitle:         'Presupuesto vs Ejecutado',
    budgetCategory:      'Categoría',
    budgetPlanned:       'Presupuestado',
    budgetExecuted:      'Ejecutado',
    budgetVariance:      'Variación',
    budgetPct:           '%',
    budgetCommitted:     'Comprometido',
    budgetTotalPlanned:  'Total planificado',
    budgetTotalExecuted: 'Total ejecutado',
    budgetTotalCommitted: 'Total comprometido',
    editCommittedTitle:  'Editar monto comprometido',
    editCommittedLabel:  'Monto comprometido (MXN)',
    editCommittedSave:   'Guardar',
    noActiveBudget:      'Este lote no tiene un presupuesto activo',
    budgetLoading:       'Cargando presupuesto...',
    budgetAllLots:       'Todos los lotes',
    newBudgetBtn:        '+ Nuevo presupuesto',
    newBudgetTitle:      'Nuevo presupuesto',
    fieldRanchoId:       'Rancho *',
    fieldLoteId:         'Lote *',
    searchRanchoPlaceholder: 'Buscar rancho...',
    searchLotePlaceholder: 'Buscar lote...',
    fieldCiclo:          'Ciclo *',
    fieldCurrency:       'Moneda del presupuesto',
    fieldTotalBudget:    'Presupuesto total ($) *',
    fieldEstimatedYield: 'Producción estimada',
    fieldEstimatedPrice: 'Precio estimado ($/unidad)',
    fieldNotes:          'Notas',
    ranchoRequired:      'El rancho es requerido',
    loteRequired:        'El lote es requerido',
    cicloRequired:       'El ciclo es requerido',
    totalBudgetRequired: 'El presupuesto total debe ser mayor a 0',
    createBudgetError:   'Error al crear el presupuesto',
    create:              'Crear',
    categories: {
      PREPARACION: 'Preparación',
      SIEMBRA: 'Siembra',
      RIEGO: 'Riego',
      FERTILIZACION: 'Fertilización',
      FITOSANITARIO: 'Fitosanitario',
      COSECHA: 'Cosecha',
      MAQUINARIA: 'Maquinaria',
      LABORES: 'Labores',
      OTRO: 'Otro',
    },
  },

  // ── Cosecha ───────────────────────────────────────────────────────────────────
  topbar: {
    project: 'Proyecto',
    allProjects: 'Todos los proyectos',
    rancho: 'Rancho',
    allRanchos: 'Todos los ranchos',
  },

  terrain: {
    cropAssignedInCultivo: 'El cultivo y la fecha de siembra se asignan en la pantalla Cultivo.',
    module: 'Zona',
    modules: 'Zonas',
    valve: 'Válvula',
    areaHa: 'Superficie (ha)',
    crop: 'Cultivo',
    noModules: 'Este rancho todavía no tiene zonas dadas de alta.',
    legend: 'Estado de la zona',
    lastClosedCycle: 'Último ciclo cerrado',
    status: {
      PREPARACION: 'Preparación',
      NORMAL: 'Normal',
      ATENCION: 'Atención',
      CRITICO: 'Crítico',
      COSECHANDO: 'Cosechando',
    },
    createModuleBtn: 'Crear zona',
    editLoteBtn: 'Editar lote',
    newModuleTitle: 'Nueva zona',
    editModuleTitle: 'Editar zona',
    editModuleBtn: 'Editar',
    saveModuleBtn: 'Guardar',
    updateModuleError: 'No se pudo guardar la zona',
    fieldModuleCode: 'Código',
    fieldModuleCodePlaceholder: 'ej. M-01',
    fieldModuleCodeReadonlyHint: 'El código no se puede modificar después de crear la zona',
    fieldParentModule: 'Zona padre',
    attendanceZoneLabel: 'Válida para pasar lista',
    attendanceZoneHint: 'Se puede pasar lista aquí (entradas, gerencia, campo...). Sin zonas marcadas se usa el lote.',
    fieldLoteReadonly: 'Lote',
    parentModuleNone: 'Ninguna (primer nivel)',
    fieldModuleName: 'Nombre',
    fieldCropName: 'Cultivo',
    fieldValves: 'Válvulas',
    fieldPlantingDate: 'Fecha de siembra',
    createModuleSuccess: 'Zona creada',
    createModuleError: 'No se pudo crear la zona',
    duplicateModuleCode: 'Ya existe una zona con ese código',
    selectLote: 'Selecciona un lote',
    noProjectSelectedHint: 'Selecciona un proyecto/temporada activo antes de crear una zona',
    farmModulesDisabledTooltip: 'Este rancho no usa subdivisión en Zonas',
    noPermissionHint: 'No tienes permiso para modificar zonas',
    deleteModuleBoundaryBtn: 'Borrar geocerca',
    deleteModuleBtn: 'Eliminar zona',
    deleteModuleConfirm: '¿Eliminar la zona',
    deleteModuleHasChildren: 'Esta zona tiene subzonas. Elimina o mueve primero las subzonas.',
    deleteModuleError: 'No se pudo eliminar la zona.',
    newCropBtn: '+ Nuevo cultivo',
    newCropPlaceholder: 'Nombre del cultivo',
  },

  map: {
    title:      'Mapa de Parcelas',
    loading:    'Cargando lotes...',
    lotesCount: 'parcelas',
    badgeGPS:   'GPS',
    badgePoly:  'Geocerca',
    badgeNoPoly: 'Sin geocerca',
    searchPlaceholder: 'Buscar lote, zona, código, estado o cultivo',
    ranchoUnknown: 'Rancho sin nombre',
    collapseLote: 'Contraer lote',
    expandLote: 'Expandir lote',
    collapseSidebar: 'Colapsar panel de parcelas',
    expandSidebar: 'Expandir panel de parcelas',
    drawBtn:    'Trazar geocerca',
    deleteBtn:  'Borrar geocerca',
    saveBtn:    'Guardar geocerca',
    saving:     'Guardando...',
    cancelBtn:  'Cancelar',
    saveError:  'Error al guardar la geocerca',
    areaTooLargeError: 'El área del polígono es demasiado grande ({area} ha) — revisa los puntos trazados',
    inviteAfterGeofenceHint: 'Lote configurado. ¿Quieres invitar a alguien a trabajar en este rancho?',
    inviteAfterGeofenceCta:  'Invitar usuario',
    drawHint:   'Haz clic en el mapa para agregar puntos',
    drawPoints: 'puntos',
    drawReady:  'listo para guardar',
    satellite:  'Satélite',
    fieldLatitude:   'Latitud',
    fieldLongitude:  'Longitud',
    useMapPointBtn:  'Usar mapa',
    saveLocationBtn: 'Guardar ubicación',
    discardTitle:   '¿Descartar cambios?',
    discardBody:    'El trazado no se ha guardado. Si sales ahora, se pierde.',
    discardConfirm: 'Descartar',
    discardCancel:  'Seguir editando',
    dateSliderLabel: 'Fecha',
    ndviLayerToggle: 'Capa NDVI',
    ndviDisabled: 'NDVI no está habilitado para este rancho; pídele a un administrador que lo active.',
    ndviSceneDate: 'Imagen satelital más cercana',
    fillThemeLabel: 'Relleno',
    fillThemeStatus: 'Estado',
    fillThemeNdvi: 'NDVI',
    fillThemeStage: 'Etapa fenológica',
    fillThemeCustom: 'Color elegido',
    stageNoData: 'Sin etapa registrada',
    labelsToggle: 'Etiquetas',
    labelFieldName: 'Nombre',
    labelFieldCrop: 'Cultivo',
    labelFieldHectares: 'Hectáreas',
    labelFieldCode: 'Código',
    ndviHigh: 'NDVI alto (≥ 0.5)',
    ndviMid: 'NDVI medio (0.3–0.5)',
    ndviLow: 'NDVI bajo (< 0.3)',
    ndviNoData: 'Sin dato',
    ndviScale: 'Escala del NDVI',
    ndviScaleFixed: 'Fija',
    ndviScaleDynamic: 'Dinámica',
    ndviRangeMin: 'NDVI mín. {min}',
    ndviRangeMax: 'NDVI máx. {max}',
  },

  chat: {
    title:            'Asistente Agrovid',
    subtitle:         'Solo lectura · Consulta tus datos del campo',
    clearBtn:         'Limpiar chat',
    welcomeTitle:     'Hola, soy el Asistente Agrovid',
    welcomeBody:      'Pregúntame sobre tus parcelas, actividades, tareas y costos.',
    noRanchoNotice:   'No hay un rancho activo: las respuestas pueden incluir todos tus ranchos. Conviene elegir uno en el selector de rancho.',
    inputPlaceholder: 'Escribe tu pregunta... (Enter para enviar)',
    sendBtn:          'Enviar',
    errorGeneric:     'Error al contactar al asistente. Intenta de nuevo.',
    fallbackWebHint:  'Esto vive en:',
    fallbackWebGo:    'Ir a {label}',
    feedbackUp:       'Respuesta útil',
    feedbackDown:     'Respuesta no útil',
    feedbackSaved:    'Calificación guardada',
    fallbackBotHint:  'Esto se registra por Telegram — prueba con {command} en el bot.',
    sidebar: {
      newChat:       'Nuevo chat',
      empty:         'Sin conversaciones guardadas',
      rename:        'Renombrar',
      delete:        'Borrar',
      deleteConfirmTitle: '¿Borrar esta conversación?',
      deleteConfirmBody:  'Esta acción no se puede deshacer.',
      cancel:        'Cancelar',
      confirmDelete: 'Borrar',
      toggle:        'Conversaciones',
    },
    suggestions: {
      s1: '¿Cuántas parcelas tengo activas?',
      s2: '¿Cuál fue la última actividad registrada?',
      s3: '¿Qué tareas están pendientes hoy?',
      s4: '¿Cuál es el costo acumulado de hoy?',
    },
    fallbackLabels: {
      reports: 'Reportes',
      sales: 'Ventas y Precios',
      logistics: 'Logística',
      traceability: 'Trazabilidad',
      devices: 'Dispositivos',
      permissions: 'Matriz de Permisos',
      inventory: 'Inventario',
      tasks: 'Tareas',
    },
  },
  notifications: {
    bell:        'Notificaciones',
    panelTitle:  'Actividad reciente',
    markAllRead: 'Marcar todas leídas',
    empty:       'Sin actividad en las últimas 24 h',
  },

  // ── TopBar ──────────────────────────────────────────────────────────────────
  topBar: {
    selectTenant:     'Cambiar empresa',
    tenants:          'Empresas',
    loading:          'Cargando...',
    noTenants:        'Sin empresas asignadas',
    switchTenantError: 'Error al cambiar de empresa',
    roleLabels: {
      SUPER_ADMIN:       'Super Admin',
      ADMIN:             'Administrador',
      SUPERVISOR:        'Supervisor de campo',
      AGRONOMIST:        'Agrónomo',
      FIELD_WORKER:      'Trabajador de campo',
      BODEGUERO:         'Bodeguero',
      WAREHOUSE_MANAGER: 'Bodeguero',
      AUDITOR:           'Auditor',
      HR:           'Recursos Humanos',
      GUARD:           'Vigilante',
      INVESTOR:          'Inversionista',
    },
    timeJustNow: 'Ahora mismo',
    timeMinutesAgo: 'Hace {n} min',
    timeHoursAgo: 'Hace {n} h',
    timeDaysAgo: 'Hace {n} d',
    startTourTooltip: 'Ver tutorial',
    restartTourLabel: 'Ver tutorial de nuevo',
    dayCloseTimeLabel: 'Cierre de día por Telegram',
    assignedAccessLabel: 'Acceso asignado',
    assignedRanchos: 'Rancho(s)',
    assignedLotes: 'Lote(s)',
    assignedAll: 'Todos',
    dayCloseTimeHint: 'A esta hora te preguntamos si quieres dejar algo registrado antes de cerrar el día (solo si no registraste nada)',
    dayCloseTimeDisable: 'Desactivar',
    telegramLink: {
      title:          'Telegram',
      linked:         'Telegram vinculado',
      notLinked:      'Telegram no vinculado',
      link:           'Vincular Telegram',
      openTelegram:   'Abrir en Telegram',
      waiting:        'Abre el enlace en Telegram y confirma la vinculación. Esperando confirmación...',
      expired:        'El enlace venció sin confirmarse. Genera uno nuevo para intentarlo otra vez.',
      unavailable:    'La vinculación con Telegram no está disponible por ahora. Intenta más tarde.',
      unlink:         'Desvincular',
      unlinkConfirm:  '¿Seguro que quieres desvincular Telegram de tu cuenta?',
      unlinkConfirmBtn: 'Sí, desvincular',
      cancel:         'Cancelar',
    },
  },

  reports: {
    title:               'Reportes PDF',
    subtitle:            'Genera y descarga reportes del sistema en formato PDF. Los archivos se almacenan 24 horas.',
    loading:             'Cargando tipos de reporte...',
    generateBtn:         'Generar PDF',
    generating:          'Generando...',
    generateError:       'Error al generar el reporte',
    readyTitle:          'Reporte listo',
    downloadBtn:         'Descargar PDF',
    expiresNote:         'Disponible por 24 horas',
    selectLote:          'Seleccionar lote',
    selectLotePlaceholder: '— Elige un lote —',
    badgeTenant:         'Todo el rancho',
    badgeLote:           'Por lote',
    recentTitle:         'Reportes recientes',
    noRecent:            'Aún no se ha generado ningún reporte.',
    colName:             'Nombre',
    colType:             'Tipo',
    colDate:             'Fecha',
    scheduledTitle:      'Reportes programados',
    noScheduled:         'No hay reportes programados.',
    frequencyWEEKLY:     'Semanal',
    frequencyMONTHLY:    'Mensual',
    nextRun:             'Próxima corrida',
    lastRun:             'Última corrida',
    colFrequency:        'Frecuencia',
    createSchedule:      'Programar reporte',
    deleteSchedule:      'Eliminar',
    scheduleTypeLabel:   'Tipo de reporte',
    scheduleFrequencyLabel: 'Frecuencia',
    scheduleCreateBtn:   'Crear',
    pushToTelegramLabel: 'Enviar por Telegram a administradores',
    pushToTelegramHint:  'ADMIN, SUPERVISOR y AGRONOMIST del rancho reciben el PDF por Telegram cada semana.',
    scheduleCreateError: 'No se pudo crear el reporte programado.',
    scheduleDeleteError: 'No se pudo eliminar el reporte programado.',
  },

  sales: {
    title:          'Ventas y Precios',
    newOrder:       'Nueva orden',
    newOrderNoPermission: 'No tienes permiso para crear órdenes de venta',
    newCustomer: '+ Nuevo cliente',
    newCustomerNoPermission: 'No tienes permiso para crear clientes',
    newCustomerTitle: 'Nuevo cliente',
    customerName: 'Nombre',
    customerCountry: 'País',
    customerContact: 'Contacto',
    customerEmail: 'Correo',
    customerPhone: 'Teléfono',
    customerTermsDays: 'Días de crédito',
    customerCreateError: 'No se pudo crear el cliente. Verifica los datos.',
    customerInvalidEmail: 'Correo no válido',
    noCustomers: 'Aún no hay clientes. Crea uno con "+ Nuevo cliente".',
    customer:       'Cliente',
    crop:           'Cultivo',
    grade:          'Grado',
    qty:            'Cantidad',
    targetPrice:    'Precio objetivo',
    lote:           'Lote',
    loteOptional:   'Sin lote',
    stockNotice:    (over: number, lote: string) => `Aviso: la venta excede en ${over} kg lo disponible del lote ${lote}. La venta quedó registrada.`,
    unitPrice:      'Precio real',
    variance:       'Varianza',
    status:         'Estado',
    total:          'Total',
    statusDraft:     'Borrador',
    statusConfirmed: 'Confirmada',
    statusFulfilled: 'Surtida',
    statusCancelled: 'Cancelada',
    createError:    'No se pudo crear la orden. Verifica los datos.',
    kpiRevenue: 'Total facturado',
    kpiOrders: 'Órdenes',
    kpiAvgPrice: 'Precio promedio ponderado',
    kpiAvgVariance: 'Varianza promedio',
    kpiTopCustomer: 'Cliente top',
    kpiTopCrop: 'Cultivo top',
    priceHistoryTitle: 'Precio histórico por cultivo',
    priceHistorySubtitle: 'Promedio mensual ponderado, observado en las órdenes registradas.',
    priceRangeTitle: 'Rango de precio proyectado',
    priceRange: 'Rango observado',
    performanceTitle: 'Desempeño de ventas por cliente',
  },

  harvest: {
    title:           'Cosecha',
    selectLot:       'Seleccionar lote',
    kpiTotalKg:      'Total cosechado (kg)',
    kpiPackout:      'Packout promedio',
    kpiPackoutSub:   'Grado A / total',
    kpiCycles:       'Ciclos registrados',
    kpiCostPerKg:    'Costo/kg',
    kpiCostPerKgSub: 'MXN/kg',
    chartByLot:      'Kg por lote',
    chartGradeBreakdown: 'Desglose por grado (últimos 20)',
    chartGradeA:     'Grado A',
    chartGradeB:     'Grado B',
    chartGradeC:     'Grado C',
    tableTitle:      'Historial de cosechas',
    tableLot:        'Lote',
    tableCycle:      'Ciclo',
    tableDate:       'Fecha',
    tableKg:         'Kg total',
    tableGradeA:     'Grado A (kg)',
    tablePackout:    'Packout %',
    tableCostPerKg:  'Costo/kg',
    tableRecordedBy: 'Registrado por',
    noHarvests:      'Sin cosechas registradas.',
    loadingHarvests: 'Cargando cosechas...',
    // Merma
    mermaTitle:           'Merma / Pérdidas',
    mermaKpiRejectedKg:   'Total rechazado (kg)',
    mermaKpiImpact:       'Impacto económico',
    mermaKpiRecords:      'Eventos registrados',
    mermaTableDate:       'Fecha',
    mermaTableReason:     'Causa',
    mermaTableKg:         'Kg rechazados',
    mermaTableBoxes:      'Cajas',
    mermaTableLabel:      'Etiqueta',
    mermaTableImpact:     'Impacto ($)',
    mermaTableStatus:     'Estado',
    mermaNoRecords:       'Sin merma registrada.',
    mermaLoading:         'Cargando merma...',
    mermaReasonCLIMA:           'Daño por clima',
    mermaReasonPLAGA:           'Daño por plaga',
    mermaReasonMECANICO:        'Daño mecánico',
    mermaReasonRECHAZO_CALIDAD: 'Rechazo calidad/calibre',
    mermaReasonPUDRICION:       'Pudrición',
    mermaReasonOTRO:            'Otra causa',
    mermaChartTitle:      'Merma por razón (kg)',
    newHarvestBtn:      '+ Registrar cosecha',
    newHarvestTitle:    'Registrar cosecha / empaque',
    fieldLoteId:        'Lote *',
    fieldLoteZone:      'Lote o zona',
    fieldBatchId:       'Ciclo (batchId) *',
    fieldContainerCode: 'Código de contenedor',
    fieldBoxesTitle:    'Cajas',
    fieldCalibre:       'Calibre',
    fieldBoxCount:      'Cantidad de cajas',
    fieldWeightKg:      'Peso (kg)',
    fieldGrade:         'Grado',
    addBoxRow:          '+ Agregar fila',
    removeBoxRow:       'Quitar',
    fieldNotes:         'Notas',
    loteRequired:       'El lote es requerido',
    batchRequired:      'El ciclo (batchId) es requerido',
    boxesRequired:      'Agrega al menos una fila de cajas',
    createError:        'Error al registrar la cosecha',
    create:             'Registrar',
  },

  // ── Inventario ────────────────────────────────────────────────────────────────
  inventory: {
    title:          'Inventario',
    tabStock:       'Stock',
    tabMovements:   'Movimientos',
    selectWarehouse: 'Seleccionar bodega',
    warehouseShared: 'Compartida (toda la empresa)',
    lowStockAlert:  'Productos con stock bajo',
    tableProduct:   'Producto',
    tableCategory:  'Categoría',
    tableQuantity:  'Cantidad',
    tableUnit:      'Unidad',
    tableExpiry:    'Caducidad',
    tableCost:      'Costo',
    tableDate:      'Fecha',
    tableType:      'Tipo',
    tableReason:    'Razón',
    tableRef:       'Referencia',
    tableLote: 'Lote',
    tableEquipment: 'Equipo',
    tableRecipient: 'Recibe',
    tableUser: 'Usuario',
    productDetailTitle: 'Detalle del producto',
    productDetailTabSummary: 'Resumen',
    productDetailTabMovements: 'Movimientos',
    productDetailClose: 'Cerrar',
    productDetailOpen: 'Ver detalle',
    productDetailNoMovements: 'Este producto no tiene movimientos.',
    productDetailLoading: 'Cargando movimientos...',
    productDetailError: 'No se pudieron cargar los movimientos.',
    productDetailCurrentStock: 'Stock actual',
    productDetailMovementCount: 'Movimientos registrados',
    productDetailLastMovement: 'Último movimiento',
    noStock:        'Sin productos en stock.',
    noMovements:    'Sin movimientos registrados.',
    loadingStock:   'Cargando stock...',
    loadingMovements: 'Cargando movimientos...',
    movementTypes: {
      ENTRY:      'Entrada',
      EXIT:       'Salida',
      RETURN:     'Devolución',
      ADJUSTMENT: 'Ajuste',
      EXPIRY:     'Caducidad',
    },
    reasonLabels: {
      PURCHASE:   'Compra',
      FIELD_USE:  'Uso campo',
      RETURN:     'Devolución',
      ADJUSTMENT: 'Ajuste',
      EXPIRY:     'Caducidad',
    },
    stockLow:     'Stock bajo',
    stockExpiring: 'Por vencer',
    stockOk:      'OK',
    kpiTotalValue:    'Valor total en bodega',
    kpiLowStock:      'Productos bajo mínimo',
    kpiExpiringSoon:  'Por vencer (30 días)',
    // ── Catálogo (tab de productos/insumos) ──────────────────────────────────
    tabCatalog:         'Catálogo',
    catalogTitle:       'Catálogo de productos / insumos',
    productSingular:    'producto',
    productPlural:      'productos',
    allCategories:      'Todas las categorías',
    loadingCatalog:     'Cargando catálogo...',
    noProductsPrefix:   'No hay productos registrados',
    noProductsFilterSuffix: ' en esta categoría',
    noProductsSuffix:   '.',
    addFirstProduct:    'Agregar primer producto',
    newProduct:         'Nuevo producto',
    editProductTitlePrefix: 'Editar — ',
    newProductDialogTitle: 'Nuevo producto / insumo',
    createError:        'Error al crear producto',
    updateError:        'Error al actualizar producto',
    nameRequired:       'El nombre es requerido',
    invalidCost:        'Costo unitario inválido',
    fieldName:          'Nombre *',
    fieldNamePlaceholder: 'Abamectin, Novatec...',
    fieldCategory:      'Categoría *',
    fieldUnit:          'Unidad *',
    fieldUnitCost:      'Costo unitario ($) *',
    fieldUnitCostPlaceholder: '0.00',
    fieldMinStock:      'Stock mínimo',
    fieldMinStockPlaceholder: '10',
    fieldActiveIngredient: 'Ingrediente activo',
    fieldActiveIngredientPlaceholder: 'Abamectin 18g/L...',
    fieldSenasica:      'Registro SENASICA',
    fieldSenasicaPlaceholder: 'SENASICA-12345',
    fieldDescription:   'Descripción',
    fieldDescriptionPlaceholder: 'Notas adicionales...',
    fieldNotifyUsers:    'Avisar a (usuarios)',
    fieldNotifyUsersHint: 'Reciben un mensaje de Telegram cuando el stock cruza el mínimo hacia abajo.',
    fieldNotifyUsersPlaceholder: 'Selecciona usuarios',
    fieldNotifyRoles:    'Avisar a (roles)',
    fieldNotifyRolesPlaceholder: 'Selecciona roles',
    cancel:             'Cancelar',
    saveChanges:        'Guardar cambios',
    createProduct:      'Crear producto',
    deleteProductTitle: 'Eliminar producto',
    deleteProductConfirmPrefix: '¿Eliminar ',
    deleteProductConfirmSuffix: '? Esta acción no se puede deshacer. Si hay stock activo en bodega, puede afectar los reportes.',
    delete:             'Eliminar',
    colName:            'Nombre',
    colCategory:        'Categoría',
    colUnit:            'Unidad',
    colUnitCost:        'Costo unitario',
    colMinStock:        'Stock mín.',
    colActiveIngredient: 'Ingrediente activo',
    colImage:           'Imagen',
    productImage:       'Imagen del producto',
    uploadImage:        'Subir imagen',
    imageError:         'No se pudo subir la imagen. Intenta de nuevo.',
    colSenasica:        'SENASICA',
    colActions:         'Acciones',
    catAgroquimico:     '🧪 Agroquímico',
    catFertilizante:    '🌱 Fertilizante',
    catSemilla:         '🌾 Semilla',
    catCombustible:     '⛽ Combustible',
    catOtro:            '📦 Otro',
    unitLitros:         'Litros',
    unitKg:             'Kilogramos',
    unitPiezas:         'Piezas',
    unitToneladas:      'Toneladas',
    unitCajas:          'Cajas',
    newMovement:            'Nuevo movimiento',
    newMovementDialogTitle: 'Registrar entrada / salida',
    fieldMovementType:      'Tipo *',
    movementTypeIn:         'Entrada',
    movementTypeOut:        'Salida',
    fieldProduct:           'Producto *',
    selectProduct:          'Selecciona un producto',
    fieldQty:               'Cantidad *',
    fieldQtyPlaceholder:    '0',
    fieldReason:            'Motivo *',
    fieldReasonPlaceholder: 'Compra a proveedor, aplicación en Lote 4...',
    fieldExpiryDate:        'Fecha de vencimiento',
    fieldLoteNumber:        'Número de lote (fabricante)',
    fieldLoteNumberPlaceholder: 'L-2026-001',
    productRequired:        'Selecciona un producto',
    qtyRequired:            'La cantidad debe ser mayor a 0',
    reasonRequired:         'El motivo es requerido',
    createMovementError:    'Error al registrar el movimiento',
    registerMovement:       'Registrar',
    transferButton:         'Traspasar',
    transferDialogTitle:    'Traspaso entre bodegas',
    fieldFromWarehouse:     'Bodega origen',
    fieldToWarehouse:       'Bodega destino',
    fieldTransferNote:      'Nota',
    fieldTransferNotePlaceholder: 'Motivo o referencia del traspaso',
    transferWarehouseRequired: 'Selecciona la bodega',
    transferSameWarehouse:  'El origen y el destino deben ser distintos',
    transferNeedTwoWarehouses: 'Necesitas al menos dos bodegas para traspasar',
    transferSubmit:         'Traspasar',
    transferError:          'Error al registrar el traspaso',
    // ── Cola de alertas de stock negativo ────────────────────────────────────
    tabAlerts:              'Alertas',
    tabTransfers: "Traspasos",
    transfersColDate: "Fecha",
    transfersColOrigin: "Origen",
    transfersColDestination: "Destino",
    transfersColProduct: "Producto",
    transfersColQty: "Cantidad",
    transfersColBy: "Realizado por",
    transfersBadgeReversed: "Revertido",
    transfersBadgeReverse: "Reverso",
    transfersRefresh: "Actualizar",
    transfersLoadMore: "Cargar más",
    transfersEmpty: "No hay traspasos registrados.",
    transfersLoading: "Cargando traspasos...",
    transfersLoadError: "No se pudieron cargar los traspasos.",
    noAlerts:               'No hay alertas de stock negativo.',
    alertSince:             'Desde',
    resolveAlert:           'Resolver',
    ignoreAlert:            'Ignorar',
    ignoreAllAlerts:        'Ignorar Todas',
    ignoreDialogTitle:      'Ignorar alerta',
    ignoreAllDialogTitle:   'Ignorar todas las alertas',
    ignoreReasonLabel:      'Motivo',
    ignoreReasonPlaceholder: 'Ej. ya se sabe la causa, stock físico confirmado...',
    ignoreAllConfirmWarehouse: '¿Ignorar todas las alertas de esta bodega?',
    ignoreAllConfirmTenant: '¿Ignorar todas las alertas de toda la empresa?',
    confirmIgnore:          'Ignorar',
    // ── Panel de diagnóstico por producto ────────────────────────────────────
    diagnosticsTitle:       'Diagnóstico de stock',
    deleteMovement:         'Eliminar',
    editMovement:           'Editar',
    editMovementDialogTitle: 'Editar movimiento',
    confirmDeleteMovement:  '¿Eliminar este movimiento? El stock se recalculará automáticamente.',
    systemMovementLocked:   'Automático',
    systemMovementLockedTooltip: 'Este movimiento fue generado automáticamente por una operación de campo y no puede editarse ni eliminarse.',
  },

  // ── Ajustes ───────────────────────────────────────────────────────────────────
  settings: {
    title:        'Ajustes',
    usersTitle:   'Ajustes — Usuarios',
    noPermission: 'No tienes permisos para acceder a esta sección.',
    loadingUsers: 'Cargando usuarios...',
    languageTitle: 'Idioma del sistema',
    languageLabel: 'Idioma',
    languageEs:   'Español',
    languageEn:   'English',
    languageZh:   '中文',
    // ── Configuración Rancho ──────────────────────────────────────────────────
    ranchoTitle:      'Configuración del Rancho',
    ranchoName:       'Nombre del rancho',
    ranchoLocation:   'Ubicación',
    ranchoSave:       'Guardar cambios',
    ranchoSaved:      'Cambios guardados',
    // ── Configuración de Lotes ────────────────────────────────────────────────
    // ── Comportamiento del sistema ────────────────────────────────────────────
    behaviorTitle:    'Comportamiento del sistema',
    warehouseMode:    'Modo bodega porcino',
    warehouseModeDesc: 'Configura si los lotes porcinos usan bodega compartida, separada o ambas.',
    warehouseShared:  'Compartida',
    warehouseSeparate: 'Separada',
    warehouseBoth:    'Ambas',
    reportMode:       'Modo reporte porcino',
    reportModeDesc:   'Define si el reporte semanal porcino se integra al Farm Report o va aparte.',
    reportIntegrated: 'Integrado',
    reportSeparate:   'Separado',
    budgetBlock:      'Bloqueo de presupuesto',
    budgetBlockDesc:  'Bloqueo soft al 100% — requiere autorización del Admin.',
    budgetBlockSoft:  'Soft (pide autorización)',
    budgetBlockHard:  'Hard (bloquea siempre)',
    // ── Proveedores de IA ─────────────────────────────────────────────────────
    aiProvidersTitle:    'Proveedores de IA (Field Bot)',
    aiProvidersDesc:     'Orden de respaldo cuando un proveedor de IA falla. Los deshabilitados se omiten por completo.',
    aiPresetLabel:       'Prioridad',
    aiPresetCost:        'Costo (gratuitos primero)',
    aiPresetSpeed:       'Velocidad (calidad primero)',
    aiPresetCustom:      'Personalizado',
    aiProviderEnabled:   'Habilitado',
    aiMoveUp:            'Subir',
    aiMoveDown:          'Bajar',
    aiProvidersSave:     'Guardar orden',
    aiProvidersSaved:    'Orden guardado',
    // ── Admin Config — tabs dinámicos (Fase 3.2-3.4) ──────────────────────────
    adminConfig: {
      tabProviders: 'Proveedores IA', tabScouting: 'Scouting', tabBudget: 'Presupuesto',
      tabMachinery: 'Maquinaria', tabHarvest: 'Cosecha', tabLocalization: 'Localización',
      tabBotBehavior: 'Comportamiento Bot', tabSchedules: 'Cronogramas', tabCompliance: 'Compliance',
      tabFeatureFlags: 'Feature Flags', tabScope: 'Alcance por rancho', tabInventory: 'Inventario y bodegas', tabCashflow: 'Cashflow y anomalías', tabAgromonitoring: 'Agromonitoring (NDVI)', tabInvoicing: 'Facturación (CFDI)', tabSystem: 'Sistema', tabAgroModules: 'Módulos del sistema',
      tabSelfRegister: 'Auto-registro',
      tabRoutines: 'Rutinas',
      tabGateRules: 'Reglas de caseta',
      routinesTitle: 'Rutinas automáticas',
      routinesDesc: 'Tareas que el sistema ejecuta solo, a una hora fija de tu empresa. Todas están apagadas hasta que las actives.',
      routinesEmpty: 'Todavía no hay rutinas disponibles.',
      routinesColRoutine: 'Rutina', routinesColSchedule: 'Horario', routinesColEnabled: 'Activa', routinesColLastRun: 'Última corrida',
      routinesNever: 'Nunca',
      routinesScheduleDaily: 'Todos los días a las {hour}:00',
      routinesScheduleWeekly: '{day} a las {hour}:00',
      routinesDay1: 'Lunes', routinesDay2: 'Martes', routinesDay3: 'Miércoles', routinesDay4: 'Jueves',
      routinesDay5: 'Viernes', routinesDay6: 'Sábado', routinesDay7: 'Domingo',
      routinesLogTitle: 'Bitácora de corridas',
      routinesLogEmpty: 'Aún no hay corridas registradas.',
      routinesColDate: 'Fecha', routinesColCompany: 'Empresa', routinesColResult: 'Resultado', routinesColError: 'Error',
      routinesStatusRUNNING: 'En curso', routinesStatusOK: 'Correcta', routinesStatusERROR: 'Con error',
      routinesStatusSKIPPED: 'Sin cambios', routinesStatusAWAITING_CONFIRMATION: 'Esperando confirmación',
      routinesStatusCONFIRMED: 'Confirmada', routinesStatusCANCELLED: 'Cancelada', routinesStatusEXPIRED: 'Vencida',
      routinesToggleError: 'No se pudo cambiar la rutina. Intenta de nuevo.',
      groupScope: 'Ranchos y alcance', groupInventory: 'Inventario y bodegas', groupFinance: 'Finanzas', groupIntegrations: 'Integraciones',
      groupField: 'Operación y costos', groupBot: 'IA y bot', groupSystem: 'Sistema y acceso', groupsLabel: 'Grupos de configuración',
      pageTitle: 'Configuración',
      systemInfoTitle: 'Información del Sistema',
      backendLabel: 'Backend', frontendLabel: 'Frontend',
      botBehaviorDesc: 'Configuración de respuestas, timeout, reintentos y logging.',
      schedulesDesc: 'Alertas, snapshots de pronóstico, expiración de sesiones y otros jobs programados.',
      complianceDesc: 'Reglas de PHI/REI/MRL, ventanas de restricción y alertas de seguridad de cosecha.',
      featureFlagsDesc: 'Habilitar/deshabilitar módulos y features del sistema.',
      saveButton: 'Guardar', savedBadge: 'Guardado',
      scoutingTitle: 'Umbrales de Severidad de Plagas',
      scoutingLowLabel: 'Severidad BAJA (%)', scoutingLowDesc: 'Daño mínimo para marcar scouting como BAJA',
      scoutingMediumLabel: 'Severidad MEDIA (%)', scoutingMediumDesc: 'Daño mínimo para marcar scouting como MEDIA',
      scoutingHighLabel: 'Severidad ALTA (%)', scoutingHighDesc: 'Daño mínimo para marcar scouting como ALTA',
      budgetTitle: 'Umbrales de Presupuesto',
      budgetWarnLabel: 'Alerta (%)', budgetWarnDesc: 'Porcentaje de consumo que dispara alerta amarilla',
      budgetBlockLabel: 'Bloqueo (%)', budgetBlockDesc: 'Porcentaje de consumo que dispara alerta crítica',
      budgetModeLabel: 'Modo', budgetModeDesc: 'Qué hacer al superar presupuesto',
      machineryTitle: 'Alertas de Maquinaria',
      machineryYellowLabel: 'Alerta Amarilla (%)', machineryYellowDesc: '% de presupuesto que dispara alerta',
      machineryOrangeLabel: 'Alerta Naranja (%)', machineryOrangeDesc: '% de presupuesto que dispara alerta',
      machineryRedLabel: 'Alerta Roja (%)', machineryRedDesc: '% de presupuesto que dispara alerta',
      harvestTitle: 'Umbrales de Cosecha',
      harvestGoodLabel: 'Packout Bueno (%)', harvestGoodDesc: 'Packout a partir del cual es bueno',
      harvestWarnLabel: 'Packout Advertencia (%)', harvestWarnDesc: 'Packout por debajo del cual es advertencia',
      harvestBadLabel: 'Packout Crítico (%)', harvestBadDesc: 'Packout por debajo del cual es crítico',
      harvestGradesLabel: 'Etiquetas de Grados', harvestGradesDesc: 'Separadas por coma (ej. A,B,C)',
      localizationTitle: 'Configuración Regional',
      currencyLabel: 'Moneda', currencyDesc: 'Moneda de costos y precios',
      timezoneLabel: 'Zona Horaria', timezoneDesc: "Define qué es 'hoy' en recordatorios",
      defaultLangLabel: 'Idioma Predeterminado', defaultLangDesc: 'Idioma de la empresa para usuarios sin idioma propio',
      phonePrefixLabel: 'Prefijo Telefónico', phonePrefixDesc: 'Ej. +52 para México',
      workdayHoursLabel: 'Horas de Jornada', workdayHoursDesc: 'Horas de trabajo completo',
      dateFormatLabel: 'Formato de fecha', dateFormatDesc: 'Patrón para mostrar fechas (dd/MM/yyyy, MM/dd/yyyy, o yyyy-MM-dd).',
      decimalSeparatorLabel: 'Separador decimal', decimalSeparatorDesc: 'Carácter usado para decimales en números (punto o coma).',
      speedUnitLabel: 'Unidades de velocidad', speedUnitDesc: 'Unidades para velocidad en maquinaria y transporte (km/h o mi/h).',
      botBehaviorTitle: 'Comportamiento del Bot',
      scheduledNoticeEnabledLabel: 'Avisos programados de tareas', scheduledNoticeEnabledDesc: 'Apagado: los avisos programados quedan en espera y salen al volver a encenderlo',
      scheduledNoticeIntervalLabel: 'Revisión de avisos programados (min)', scheduledNoticeIntervalDesc: 'Cada cuántos minutos se revisan (múltiplos de 5)',
      reminderHourLabel: 'Hora de Recordatorio Diario', reminderHourDesc: 'Hora local a la que se envían recordatorios de tareas del día siguiente',
      schedulesTitle: 'Cronogramas de Pronóstico',
      spread7Label: 'Amplitud 7 días (±%)', spread7Desc: 'Amplitud entre escenario conservador e ideal a 7 días',
      spread15Label: 'Amplitud 15 días (±%)', spread15Desc: 'Amplitud entre escenario conservador e ideal a 15 días',
      spread60Label: 'Amplitud 60 días (±%)', spread60Desc: 'Amplitud entre escenario conservador e ideal a 60 días',
      confidence7Label: 'Confianza 7 días (%)', confidence7Desc: 'Confianza reportada con el pronóstico a 7 días',
      confidence15Label: 'Confianza 15 días (%)', confidence15Desc: 'Confianza reportada con el pronóstico a 15 días',
      confidence60Label: 'Confianza 60 días (%)', confidence60Desc: 'Confianza reportada con el pronóstico a 60 días',
      complianceTitle: 'Cadena de Frío',
      coldMinLabel: 'Temperatura Mínima (°C)', coldMinDesc: 'Temperatura mínima admitida en tránsito antes de marcar excursión',
      coldMaxLabel: 'Temperatura Máxima (°C)', coldMaxDesc: 'Temperatura máxima admitida en tránsito antes de marcar excursión',
      featureFlagsTitle: 'Feature Flags',
      trackingEnabledLabel: 'Seguimiento de Embarques', trackingEnabledDesc: 'Activa el seguimiento por telemetría (ruta y temperatura)',
      autoDeductLabel: 'Descuento Automático de Bodega', autoDeductDesc: 'Descuenta automáticamente del inventario al confirmar una operación',
      negativeStockIgnoreScopeLabel: 'Alcance de "Ignorar Todas" (stock negativo)', negativeStockIgnoreScopeDesc: 'Al ignorar todas las alertas de stock negativo desde la cola de Inventario: solo la bodega activa, o toda la empresa.',
      inventoryScopeByRanchoLabel: 'Inventario por rancho activo', inventoryScopeByRanchoDesc: 'Filtra bodegas y productos por el rancho seleccionado. Apagado: se muestra toda la empresa. Los registros sin rancho asignado siempre se ven.',
      machineryScopeByRanchoLabel: 'Maquinaria por rancho activo', machineryScopeByRanchoDesc: 'Filtra la maquinaria por el rancho seleccionado. Apagado: se muestra toda la empresa. Los equipos sin rancho asignado siempre se ven.',
      invoicingEnabledLabel: 'Facturación electrónica (CFDI)', invoicingEnabledDesc: 'Permite emitir facturas CFDI 4.0 desde el bot vía Facty. Apagada por defecto. La conexión con Facty se configura aparte.',
      invoicingRfcLabel: 'RFC del emisor', invoicingRfcDesc: 'RFC de la empresa que factura (12 o 13 caracteres). Vacío bloquea el timbrado.',
      invoicingRegimenLabel: 'Régimen fiscal del emisor', invoicingRegimenDesc: 'Código SAT de 3 dígitos (p. ej. 601). Vacío bloquea el timbrado.',
      invoicingModeLabel: 'Modo de timbrado', invoicingModeDesc: 'Sandbox para pruebas; production solo cuando la conexión con Facty esté validada.',
      factyCredentialsTitle: 'Conexión con Facty', factyCredentialsConfigured: 'Conexión configurada', factyCredentialsMissing: 'Sin conexión: el timbrado está bloqueado', factyOrgLabel: 'Organización (org) de Facty', factyApiKeyLabel: 'API key de Facty', factyCredentialsSave: 'Guardar conexión', factyCredentialsRemove: 'Quitar conexión', factyCredentialsError: 'No se pudo guardar. Revisa los datos e inténtalo de nuevo.',
      ndviEnabledLabel: 'Imágenes satelitales NDVI', ndviEnabledDesc: 'Habilita el módulo NDVI (imágenes satelitales de Agromonitoring, consume la cuota del plan). Apagado por defecto. Cada rancho puede sobrescribir este valor.',
      ndviRanchosTitle: 'NDVI por rancho', ndviRanchosDesc: 'Sobrescribe el ajuste de la empresa para cada rancho. Marcado = NDVI habilitado en ese rancho.',
      mrlMissingDoseLabel: 'Cosecha sin dosis registrada (MRL)', mrlMissingDoseDesc: 'Cuando una aplicación fitosanitaria no tiene dosis registrada, el MRL no se puede evaluar. Bloquear: la cosecha se detiene hasta registrar la dosis. Advertir (predeterminado): solo muestra una advertencia. El PHI y el REI siempre bloquean.',
      mrlMissingDoseBlock: 'Bloquear cosecha', mrlMissingDoseWarn: 'Solo advertir',
      mrlMissingDoseRanchosTitle: 'Regla de dosis en cosecha por rancho', mrlMissingDoseRanchosDesc: 'Sobrescribe el ajuste de la empresa para cada rancho. Bloquear es una decisión por rancho: déjalo en Advertir salvo que el rancho lo necesite.',
      anomalyAutoLabel: 'Detección Automática de Anomalías', anomalyAutoDesc: 'Levanta anomalías automáticamente al detectar desviaciones del plan',
      cashflowBudgetLabel: 'Presupuesto en Cashflow', cashflowBudgetDesc: 'Incluye el presupuesto del ciclo como salidas en el cashflow proyectado',
      cashflowForecastLabel: 'Pronóstico en Cashflow', cashflowForecastDesc: 'Proyecta la cosecha pronosticada como ingreso futuro',
      useFarmModulesLabel: 'Usa subdivisión en Zonas', useFarmModulesDesc: 'Si se desactiva, los ranchos solo se administran a nivel Lote',
      agroModulesTab: 'Módulos del sistema',
      agroModulesHelp: 'Activa o desactiva las capacidades del bot para esta empresa.',
      agroModulesHelpWithCompany: 'Activa o desactiva las capacidades del bot para {company}.',
      notifyDisabledSwitch: 'Notificar módulos deshabilitados sin usar IA',
      saveAgroModules: 'Guardar módulos',
      selfRegisterTitle: 'Link de Auto-registro',
      selfRegisterDesc: 'Genera un link con código único para que el agrónomo o dueño de la empresa cree su propia cuenta sin invitación individual.',
      generateSelfRegisterLink: 'Generar link de auto-registro',
      regenerateSelfRegisterLink: 'Regenerar link',
      selfRegisterLinkHint: 'Comparte este link — el código anterior deja de funcionar en cuanto generas uno nuevo:',
      selfRegisterCopyLink: 'Copiar link',
      selfRegisterCopied: '✓ Copiado',
      selfRegisterError: 'No se pudo generar el link de auto-registro',
    },
    roles: {
      SUPER_ADMIN:       'Super Admin',
      ADMIN:             'Admin',
      AGRONOMIST:        'Agrónomo',
      SUPERVISOR:        'Supervisor',
      WAREHOUSE_MANAGER: 'Bodeguero',
      FIELD_WORKER:      'Campo',
      AUDITOR:           'Auditor',
      HR:           'Recursos Humanos',
      GUARD:           'Vigilante',
      INVESTOR:          'Inversionista',
    },
    // ── Sistema (fusiona estado + versión) ────────────────────────────────────
    systemTab:        'Sistema',
    systemStatus:     'Estado del sistema',
    checking:         'Verificando...',
    refresh:          'Actualizar',
    checkingProviders: 'Verificando proveedores...',
    aiProviders:      'Proveedores de IA',
    telegramBots:     'Bots de Telegram',
    rotateTokenTitle: 'Rotar {name}',
    rotateTokenHint: 'Pega el valor nuevo. Se guarda en el servidor (nunca se muestra después) y puede tardar unos minutos en aplicarse en todas las instancias. Para el bot de Campo se valida con Telegram y se vuelve a registrar el webhook.',
    rotateTokenLabel: 'Valor nuevo',
    rotateTokenSubmit: 'Rotar',
    rotateTokenOk: 'Clave rotada.',
    rotateTokenError: 'No se pudo rotar la clave.',
    rotateTokenBtn: 'Rotar',
    rotateTokenOkBot: 'Token rotado. El bot {bot} quedó con el webhook registrado.',
    zoneCoordsTitle: 'Ubicación de zonas',
    zoneCoordsHint: 'Calcula la latitud y longitud (centro de la geocerca) de los lotes y zonas que tienen geocerca pero no coordenadas. Se usan para la ubicación exacta y el clima. No cambia las que ya tienen.',
    zoneCoordsBtn: 'Calcular coordenadas faltantes',
    zoneCoordsRunning: 'Calculando…',
    zoneCoordsDone: 'Listo: {lotes} lotes y {modules} zonas actualizados ({noBoundary} sin geocerca).',
    zoneCoordsNothing: 'No había nada que calcular: todas las zonas con geocerca ya tienen coordenadas ({noBoundary} sin geocerca).',
    zoneCoordsError: 'No se pudieron calcular las coordenadas.',
    secretsTitle: 'Claves y tokens',
    secretsHint: 'Claves de IA, bot de Campo y GitHub. Los valores nunca se muestran.',
    secretConfigured: 'Configurada',
    secretNotConfigured: 'Sin configurar',
    frontendSection:  'Frontend (Dashboard)',
    miniappSection:   'Mini App de cámara',
    miniappLabel:     'Versión',
    backendSection:   'Backend (Lambda API)',
    checkingVersion:  'Consultando versión...',
    versionError:     'No se pudo obtener la versión del backend.',
    version:          'Versión',
    cached:           '(caché)',
    fieldBotLabel:    'API · Field Bot',
    statusOk:            'OK',
    statusRateLimited:   'Rate limit',
    statusNoCredits:     'Sin créditos',
    statusNoWebhook:     'Sin webhook',
    statusPrivacyOn:     'Privacy mode ON',
    statusError:         'Error',
    statusUnconfigured:  'No configurado',
    statusDisabled:      'Desactivado',
    statusTimeout:       'Timeout',
    aiUsageTitle:        'Uso por modelo',
    aiUsageDays7:        'Últimos 7 días',
    aiUsageDays30:       'Últimos 30 días',
    aiUsageShareTitle:   '% de llamadas por modelo',
    aiUsageFailuresTitle: 'Fallos por causa',
    aiUsageNoData:       'Aún no hay uso registrado en este periodo.',
    aiUsageCalls:        'llamadas',
    aiUsageOk:           'OK',
    aiUsageFailed:       'Fallos',
    aiUsageAvgLatency:   'Latencia media',
    aiUsageTokens:       'Tokens (entrada / salida)',
    aiUsageLoadError:    'No se pudo cargar el uso de IA.',
    chatFeedbackTitle:   'Calificaciones del chat (👍 / 👎)',
    chatFeedbackUp:      'Útiles (👍)',
    chatFeedbackDown:    'No útiles (👎)',
    chatFeedbackFrom:    'Desde',
    chatFeedbackTo:      'Hasta',
    chatFeedbackLoadError: 'No se pudo cargar el conteo de calificaciones.',
    aiCause_timeout:     'Timeout',
    aiCause_rate_limited: 'Límite de peticiones',
    aiCause_no_credits:  'Sin crédito/cuota',
    aiCause_auth:        'Autenticación',
    aiCause_server_error: 'Error del proveedor',
    aiCause_other:       'Otro',
    webhookActive:       'webhook activo',
    privacyOnHint:       'Privacy mode ON — ve a BotFather para desactivarlo',
    noWebhookRegistered: 'Sin webhook registrado',
    pendingUpdates:      'updates pendientes',
  },

  // ── Configuración del Sistema (ConfigPage) ─────────────────────────────────
  config: {
    title:                'Configuración del Sistema',
    tabRancho:            'Rancho',
    tabComportamiento:    'Comportamiento',
    tabProveedores:       'Proveedores IA',
  },

  // ── Cuenta Inactiva ──────────────────────────────────────────────────────────
  accountInactive: {
    title: 'Cuenta inactiva',
    message: 'Tu cuenta ha sido desactivada. Contacta al administrador para más información.',
    backBtn: 'Volver al inicio',
  },

  // ── Página del Sistema ───────────────────────────────────────────────────────
  systemPage: {
    title: 'Configuración del Sistema',
    botBehavior: 'Comportamiento del Bot',
    botBehaviorDesc: 'Configurar modelo de IA, estilo de respuesta, idioma por defecto.',
    schedules: 'Horarios y Notificaciones',
    schedulesDesc: 'Hora de recordatorios, frecuencia de alertas, ventanas de actividad.',
    compliance: 'Cumplimiento (Compliance)',
    complianceDesc: 'PHI/REI/MRL guard strictness, reglas de cosecha.',
    versioning: 'Versionado',
    versioningDesc: 'Versión de la app, build info, cambios recientes.',
    featureFlags: 'Banderas de Características',
    featureFlagsDesc: 'Características experimentales, beta testing.',
    underConstruction: '⚠️ Página en construcción — por implementar',
  },

  // ── Guía del Sistema ────────────────────────────────────────────────────────
  a11yLabels: {
    telegram: 'Telegram',
    ndviImage: 'Imagen NDVI',
    logoPreview: 'Vista previa del logo',
    close: 'Cerrar',
  },
  sharedUi: {
    noAlerts: 'Sin alertas',
  },

  systemGuide: {
    title: 'Guía e Instructivo del Sistema Agrovid',
    subtitle: 'Aprende a utilizar el sistema conversacional por Telegram y el Dashboard Web.',
    searchPlaceholder: 'Buscar módulo, comando de voz, regla fitosanitaria o término...',
    helpTooltip: 'Guía del Sistema / Ayuda',
    openGuideBtn: 'Ver Guía del Sistema',
    tabs: {
      architecture: 'Cómo Funciona',
      roles: 'Guías por Rol',
      modules: 'Instructivo de Módulos',
      voiceCommands: 'Comandos de Voz Telegram',
      faq: 'Preguntas Frecuentes & Glosario',
    },
    dualEntry: {
      telegramTitle: '📱 Bot Conversacional (Campo)',
      telegramDesc: 'Permite a los trabajadores de campo enviar voz, foto y texto en lenguaje natural. El bot valida con el freno de confirmación (Draft Gate) y registra la operación automáticamente.',
      webTitle: '💻 Dashboard Web',
      webDesc: 'Consola administrativa completa con permisos por rol. Permite crear catálogos, aprobar salidas de inventario, cerrar nóminas y consultar reportes P&L.',
      commonDbTitle: '⚙️ Toda tu Información en un Solo Lugar',
      commonDbDesc: 'Ambos canales convergen en el mismo sistema, guardando la información de forma segura y sincronizada.',
    },
    copyBtn: 'Copiar comando',
    content: {
      archTitle: 'Dos formas de trabajar: Campo (Telegram) + Oficina (Dashboard Web)',
      archIntro: 'Agrovid ofrece dos caminos independientes para registrar y consultar información agrícola. Ambos canales convergen en el mismo lugar, así que la información se mantiene siempre consistente y actualizada.',
      draftGateBefore: 'Cuenta con',
      draftGateTerm: 'Draft Gate',
      draftGateAsk: 'el bot pregunta',
      draftGateQuestion: '¿Confirmas el registro?',
      draftGateAfter: 'antes de guardar.',
      webHint: '📊 Filtros avanzados por rancho/lote, reportes PDF/Excel y gráficos interactivos.',
      glossaryHeading: 'Glosario de Términos Agrícolas y Reglas de Negocio',
      glossaryQuestions: {
        PHI: '🧪 PHI (Pre-Harvest Interval / Días a Cosecha)',
        REI: '🚫 REI (Restricted Entry Interval / Reingreso)',
        FEFO: '📦 FEFO (First Expired, First Out)',
        Packout: '📊 Packout % (Porcentaje de Empaque)',
        DraftGate: '🛑 Draft Gate (Freno de Confirmación del Bot)',
      },
      phiBlockNote: 'El sistema bloquea automáticamente la cosecha en el lote si el PHI no ha vencido.',
      botLabel: 'Bot:',
      mainActions: 'Acciones principales:',
      cheatsheetIntroPre: 'Envía audios de voz o texto natural al Bot de Telegram. Haz clic en',
      cheatsheetIntroBtn: 'Copiar',
      cheatsheetIntroPost: 'para probar estas frases en tu bot:',
      voiceExamples: [
        { title: '🌾 Aplicación Fitosanitaria', phrase: 'Apliqué 25 litros de Kumulus DF en Lote 3 con tractor 01', note: 'El bot detectará el insumo, la dosis, el lote y requerirá tu confirmación.', role: 'Campo / Agrónomo' },
        { title: '💧 Riego por Horas', phrase: 'Regué 5 horas en Lote 1 usando bomba pozo profundo', note: 'Calcula automáticamente lámina en mm y m3 consumidos.', role: 'Campo' },
        { title: '📦 Cosecha y Packout', phrase: 'Empaqué 80 cajas de 4kg Calibre 40 de Aguacate Hass en Lote 2', note: 'Genera el folio de trazabilidad de empaque y actualiza el rendimiento.', role: 'Campo / Supervisor' },
        { title: '🚜 Maquinaria & Horómetro', phrase: 'Inicio subsuelo con Tractor John Deere en Lote 4 horómetro 2150', note: 'Abre la sesión de maquinaria para costeo por hectárea.', role: 'Campo / Tractorista' },
        { title: '🐛 Monitoreo de Plagas', phrase: 'Detecté trips nivel medio en Lote 5 con 4 puntos revisados', note: 'Actualiza el semáforo fitosanitario del lote y alerta al agrónomo.', role: 'Agrónomo' },
        { title: '👥 Asistencia y Destajo', phrase: 'Asistencia 6 trabajadores en Lote 1 por destajo 50 rejas', note: 'Registra el avance para el cálculo de nómina quincenal.', role: 'Supervisor' },
      ],
      modules: {
        'rancho-lote': { name: 'Gestión de Ranchos y Lotes', description: 'Gestión jerárquica de Ranchos y Lotes agrícolas. Delimitación de hectáreas y cultivos.', example: 'Dar de alta rancho Slp lote 4' },
        operations: { name: 'Operaciones Fitosanitarias y Labores', description: 'Captura por voz/texto de labores agrícolas, insumos aplicados, dosis y validación de PHI/REI.', example: 'Apliqué 20L de Kumulus en Lote 4 con tractor 2' },
        irrigation: { name: 'Riego y Fertirrigación', description: 'Registro de riegos por horas, metros cúbicos de pozo o mm de embalse, calculando eficiencia hídrica y N-P-K.', example: 'Regué 4 horas en Lote 1 con 15kg de Nitrato' },
        harvest: { name: 'Cosecha, Empaque y Packout', description: 'Registro de cajas cosechadas por calibre/grado, cierre de folio de trazabilidad y rendimiento t/ha.', example: 'Empaqué 120 cajas de 4kg Calibre 40 de Aguacate Lote 3' },
        'crop-management': { name: 'Monitoreo Agronómico y Plagas', description: 'Scouting de plagas/enfermedades, fenología, balance nutricional y cálculo de fecha de cosecha segura.', example: 'Detecté araña roja ligera en Lote 2 con 5 puntos de muestreo' },
        inventory: { name: 'Inventarios y Bodega (FEFO)', description: 'Catálogo de agroquímicos y fertilizantes. Entradas por factura, salidas con despacho FEFO y alertas de reorden.', example: 'Entraron 50 sacos de Urea a bodega central' },
        machinery: { name: 'Maquinaria y Horómetros', description: 'Cronómetro de labores mecánicas, horómetro inicial/final, consumo diésel y costo de operación por hectárea.', example: 'Inicio rastra con Tractor 01 en Lote 2 horómetro 1450' },
        payroll: { name: 'Nómina y Mano de Obra', description: 'Registro de asistencia y liquidación quincenal por modalidades Jornal, Destajo (rejas/cajas) y Contrato.', example: 'Registro 8 trabajadores destajo 40 rejas en Lote 1' },
        finance: { name: 'Finanzas y P&L por Lote', description: 'Consolidación de costos directos (químicos, agua, diésel, nómina) vs ingresos por cosecha para determinar margen $/ha.', example: 'Consulta costo acumulado de Lote 3' },
        protocol: { name: 'Carga de Protocolos Agronómicos', description: 'Carga y parsing de documentos/recetas agronómicas para planificar aplicaciones fitosanitarias de la temporada.', example: 'Cargar protocolo fitosanitario de aguacate 2026' },
        merma: { name: 'Control de Merma y Rechazo', description: 'Registro de fruta rechazada o perdida en campo/empaque etiquetando causa (viento, plaga, manejo).', example: 'Reporte merma 120kg fruta caída en Lote 4 por granizo' },
        export: { name: 'Logística de Exportación', description: 'Gestión de embarques internacionales, certificación FDA/Fito, precintos y monitoreo de temperatura.', example: 'Cerrar contenedor EXP-9901 con sello 44810' },
        transport: { name: 'Transporte Doméstico', description: 'Creación de manifiestos de salida, asignación de chofer/placas y flete de campo a empaque.', example: 'Salida camión 04 con 15 toneladas rumbo a empaque central' },
        traceability: { name: 'Trazabilidad Campo-Empaque', description: 'Rastreo completo de folios desde la parcela y aplicación de agroquímicos hasta el consumidor final.', example: 'Trazabilidad folio TR-2026-0044' },
        porcino: { name: 'Engorda Porcina', description: 'Gestión de granja de engorda porcina: entradas de lechones, pesajes, alimento, conversión (FCR) y ventas.', example: 'Registro consumo alimento 500kg alimento engorda naves 2' },
        resources: { name: 'Recursos y Cuadrillas', description: 'Catálogo de maquinaria, drones DJI Agras, cuadrillas de piscadores y contratistas.', example: 'Asignar cuadrilla 3 a cosecha Lote 1' },
        drone: { name: 'Vuelos de Aplicación con Dron', description: 'Registro de vuelos con dron DJI Agras T40: litros/ha, hectáreas cubiertas y tiempo de vuelo.', example: 'Vuelo dron T40 en Lote 5 aplicó 100L en 4 hectáreas' },
        calendar: { name: 'Calendario y Tareas Agrícolas', description: 'Programación de labores por lote y trabajador con recordatorios automáticos por Telegram.', example: 'Crear tarea riego Lote 2 para mañana 8am asignado a Juan' },
        weather: { name: 'Clima y Pronóstico Open-Meteo', description: 'Consulta de temperatura, precipitación acumulada y pronóstico de 7 días por geolocalización de lote.', example: '¿Cuál es el pronóstico de lluvia para Lote 1 esta semana?' },
        users: { name: 'Usuarios y Pre-registro', description: 'Alta de personal por número de teléfono, asignación de roles y vinculo con Telegram.', example: 'Pre-registrar usuario 8112345678 rol AGRONOMIST' },
        vocabulary: { name: 'Vocabulario y Alias de Voz', description: 'Catálogo de alias por empresa para corregir errores de transcripción de voz (ej: "Kumulo" -> "Kumulus DF").', example: 'Agregar alias "lote cuatro" para Lote-04' },
        sales: { name: 'Ciclo Comercial y Ventas', description: 'Registro de órdenes de venta, facturación y cobro de clientes por cosecha.', example: 'Venta 500 cajas aguacate a Cliente Frutas del Norte' },
        support: { name: 'Soporte y Tickets de Bot', description: 'Generación automática de tickets de soporte técnico si el Bot de Telegram detecta un error o confusión.', example: '/soporte El bot no reconoce el insumo X' },
        developer: { name: 'Diagnóstico Técnico', description: 'Herramientas internas de soporte y monitoreo para revisar el estado general del sistema.' },
      },
    },
    copied: '¡Copiado!',
    filterRole: 'Filtrar por Rol:',
    allRoles: 'Todos los roles',
    rolesList: {
      FIELD_WORKER: 'Trabajador de Campo',
      AGRONOMIST: 'Agrónomo',
      SUPERVISOR: 'Supervisor de Campo',
      ADMIN: 'Administrador / Gerente',
      INVESTOR: 'Inversionista (Read-only)',
    },
    rolesDesc: {
      FIELD_WORKER: 'Registra aplicaciones, riegos, labores de cosecha y asistencia por notas de voz en Telegram.',
      AGRONOMIST: 'Monitorea plagas/scouting, receta fitosanitarios, valida carencia (PHI) y carga de protocolos.',
      SUPERVISOR: 'Inicia horómetros de maquinaria, gestiona cuadrillas, solicita insumos a bodega y audita packout.',
      ADMIN: 'Gestiona ranchos/lotes, aprueba salidas de inventario, aprueba nóminas quincenales y audita finanzas.',
      INVESTOR: 'Acceso de lectura ejecutiva a P&L, avance de producción, rendimiento t/ha y trazabilidad.',
    },
    glossaryTitle: 'Glosario de Términos Agrícolas',
    glossary: {
      PHI: 'PHI (Intervalo a Cosecha): Días requeridos tras aplicar un químico antes de que la cosecha sea segura.',
      REI: 'REI (Período de Reingreso): Horas de espera antes de que los trabajadores puedan reingresar al lote.',
      FEFO: 'FEFO (First Expired, First Out): Regla de inventario que despacha primero el insumo más próximo a vencer.',
      Packout: 'Packout %: Porcentaje de fruta cosechada que cumple con estándar de calidad para empaque/exportación.',
      DraftGate: 'Draft Gate (Freno de Confirmación): El Bot responde "¿Confirmas registrar X?" antes de guardar en la base de datos.',
    },
    cards: {
      architecture: {
        title: '🚀 Cómo Funciona Agrovid',
        desc: 'Conoce las dos formas de registrar información: por voz con el Bot de Telegram o desde el Dashboard Web.',
      },
      modules: {
        title: '📦 Instructivo de Módulos',
        desc: 'Manual paso a paso de Riego, Cosecha, Fitosanitarios, Inventario FEFO, Maquinaria, Nómina y Finanzas.',
      },
      voice: {
        title: '🎙️ Comandos de Voz Telegram',
        desc: 'Ejemplos copiables de notas de voz para enviar al Bot de Telegram (aplicaciones, riegos, cosechas).',
      },
      roles: {
        title: '👤 Guías por Rol',
        desc: 'Aprende las responsabilidades y pantallas clave para Trabajadores, Agrónomos, Supervisores e Inversionistas.',
      },
      faq: {
        title: '❓ Glosario & Reglas de Negocio',
        desc: 'Entiende qué es el PHI, REI, FEFO, Packout %, Draft Gate y solución de dudas frecuentes.',
      },
    },
  },

  // ── Componentes Globales ────────────────────────────────────────────────────
  errorBoundary: {
    title: 'Algo salió mal',
    message: 'Ocurrió un error inesperado en la aplicación.',
    reloadBtn: 'Recargar página',
  },

  protectedRoute: {
    title: 'Acceso denegado',
    message: 'No tienes permiso para ver esta sección. Contacta a un administrador si crees que esto es un error.',
    dashboardBtn: 'Volver al Dashboard',
  },

  demoGate: {
    loading: 'Cargando demo…',
    error: 'No se pudo iniciar sesión demo. Verifica que el servidor esté activo.',
  },

  // ── Módulos de Permisos ──────────────────────────────────────────────────────
  permissionModules: {
    ASISTENCIA: 'Asistencia',
    GESTIÓN: 'Gestión',
    OPERACIONES: 'Operaciones',
    CAMPO: 'Campo',
    COSECHA: 'Cosecha',
    ANÁLISIS: 'Análisis',
    SISTEMA: 'Sistema',
  },

  // ── Matriz de Permisos ──────────────────────────────────────────────────────
  permissionsMatrix: {
    roleEditHint: 'Pulsa una casilla para dar o quitar un permiso a un rol en tu empresa. Aplica cuando cada persona vuelva a iniciar sesión. Super Admin no se puede modificar.',
    saveRoles: 'Guardar cambios de roles',
    discardRoles: 'Descartar',
    resetRoles: 'Restablecer a fábrica',
    rolesSaved: 'Permisos de roles guardados',
    rolesSaveError: 'No se pudieron guardar los permisos de roles',
    rolesDirty: 'Cambios sin guardar',
    title:        'Matriz de Permisos',
    subtitle:     'Permisos asignados por rol. Los permisos se aplican según el rol activo de la sesión.',
    noAccess:     'No tienes permisos para acceder a esta sección.',
    permissionCol: 'Permiso',
    tabMatrix:    'Matriz por Rol',
    tabOverrides: 'Permisos Adicionales por Usuario',
    allowed:      'Permitido',
    denied:       'Sin permiso',
    searchPlaceholder: 'Buscar por nombre o teléfono',
    permissions: {
      'users:read': 'Ver usuarios',
      'users:write': 'Editar usuarios',
      'admin:ranchos': 'Gestionar ranchos',
      'admin:rbac': 'Gestionar permisos',
      'admin:super': 'Super Admin',
      'inventory:read': 'Ver inventario',
      'inventory:write': 'Mover inventario',
      'warehouse:transfer': 'Traspasar entre bodegas',
      'payroll:read': 'Ver nómina',
      'payroll:write': 'Editar nómina',
      'machinery:read': 'Ver maquinaria',
      'lotes:read': 'Ver lotes',
      'lotes:write': 'Editar lotes',
      'lotes:approve': 'Aprobar o eliminar registros de lotes',
      'tasks:write': 'Editar tareas',
      'tasks:manage': 'Gestionar tareas (crear/editar/borrar)',
      'crop:write': 'Registrar cultivo',
      'irrigation:write': 'Registrar riego',
      'harvest:read': 'Ver cosecha',
      'harvest:write': 'Registrar cosecha',
      'merma:read': 'Ver merma',
      'finance:read': 'Ver finanzas',
      'finance:write': 'Editar finanzas',
      'reports:read': 'Ver reportes',
      'reports:configure': 'Configurar reportes',
      'audit:read': 'Ver auditoría',
      'vocabulary:write': 'Gestionar vocabulario',
      'config:write': 'Editar configuración',
      'attendance:read': 'Ver asistencia',
      'attendance:take': 'Pasar lista',
      'attendance:enroll': 'Enrolar personas (rostro)',
      'attendance:policy': 'Configurar política de asistencia',
      'attendance:prebaja_decide': 'Decidir pre-bajas',
      'attendance:delete_biometrics': 'Borrar datos biométricos',
      'attendance:gate': 'Usar caseta (pase de acceso)',
      'attendance:gate_authorize': 'Autorizar salida de personas dadas de baja',
    },
    userNotFound: 'Usuario no encontrado',
    saved: 'Permisos guardados correctamente',
    saveError: 'Error al guardar permisos',
    userLabel: 'Usuario',
    roleLabel: 'Rol',
    phoneLabel: 'Teléfono',
    rolePermsTitle: 'Permisos por rol',
    noBasePerms: 'Sin permisos base',
    extraPermsTitle: 'Permisos adicionales (opcional)',
    saveChanges: 'Guardar cambios',
    searchPrompt: 'Busca un usuario para asignar permisos adicionales',
  },

  // ── Porcino ───────────────────────────────────────────────────────────────────
  porcino: {
    title:          '🐷 Granja Porcina — Engorda',
    corralTitle:    'Corrales',
    corralLoading:  'Cargando corrales...',
    corralEmpty:    'Aún no hay corrales. Usa «+ Nuevo corral» para crear uno.',
    corralCapLabel: 'Cap.',
    corralCapUnit:  'cabezas',
    kpisLoading:    'Cargando KPIs...',
    noActiveLot:    'Sin lote activo en este corral. Usa «+ Registrar entrada» para registrar una entrada de cerdos.',
    eventsTitle:    'Historial de eventos',
    eventsLoading:  'Cargando eventos...',
    eventsEmpty:    'Sin eventos registrados',
    colDate:        'Fecha',
    colType:        'Tipo',
    colDetail:      'Detalle',
    colRecordedBy:  'Registrado por',
    detailCabezas:  'cabezas',
    detailKgCab:    'kg/cab',
    detailKgFood:   'kg alimento',
    detailCausa:    'Causa',
    kpiHeads:       'Cabezas actuales',
    kpiDaysUnit:    'días en corral',
    kpiEntryPrefix: 'Entrada',
    kpiWeight:      'Peso promedio',
    kpiGdp:         'GDP',
    kpiGdpSub:      'Ganancia diaria de peso',
    kpiFcr:         'Conversión alimenticia',
    kpiFcrUnit:     'kg consumidos',
    kpiMortality:   'Mortalidad',
    kpiMortalityUnit: 'bajas registradas',
    kpiCostKg:      'Costo/kg en pie',
    kpiCostKgSub:   'Costo total / kg vivos actuales',
    statusInUse:    'En uso',
    statusActive:   'Activo',
    statusEmpty:    'Vacío',
    statusInactive: 'Inactivo',
    eventoEntrada:  '🐷 Entrada',
    eventoPesaje:   '⚖️ Pesaje',
    eventoAlimento: '🌽 Alimento',
    eventoMortalidad: '💀 Baja',
    eventoMedicacion: '💊 Medicación',
    eventoVenta:    '💰 Venta',
    newCorralBtn:      '+ Nuevo corral',
    newCorralTitle:    'Nuevo corral',
    fieldRanchoId:     'Rancho *',
    searchRanchoPlaceholder: 'Buscar rancho...',
    fieldCorralName:   'Nombre *',
    fieldCapacity:     'Capacidad (cabezas) *',
    newEntradaBtn:     '+ Registrar entrada',
    newEntradaTitle:   'Registrar entrada de lote',
    fieldCabezas:      'Cabezas *',
    fieldPesoPromedio: 'Peso promedio (kg) *',
    fieldCostoPorCabeza: 'Costo por cabeza ($, opcional)',
    fieldProveedor:    'Proveedor',
    newEventBtn:       '+ Registrar evento',
    newEventTitle:     'Registrar evento',
    fieldEventType:    'Tipo de evento *',
    fieldKgAlimento:   'Kg de alimento *',
    fieldTipoAlimento: 'Tipo de alimento',
    fieldCausa:        'Causa',
    fieldPesoTotal:    'Peso total vendido (kg) *',
    fieldPrecioKg:     'Precio por kg ($) *',
    fieldDestino:      'Destino',
    fieldNotes:        'Notas',
    ranchoRequired:    'El rancho es requerido',
    nameRequired:      'El nombre es requerido',
    capacityRequired:  'La capacidad debe ser mayor a 0',
    cabezasRequired:   'Las cabezas deben ser mayor a 0',
    pesoRequired:      'El peso promedio debe ser mayor a 0',
    kgAlimentoRequired: 'Los kg de alimento deben ser mayor a 0',
    pesoTotalRequired: 'El peso total es requerido',
    precioKgRequired: 'El precio por kg es requerido',
    createError:       'Error al registrar',
    create:            'Registrar',
    gdpUnit: 'g/día',
  },

  // ── Nómina ────────────────────────────────────────────────────────────────────
  payroll: {
    title:            'Nómina Quincenal',
    loading:          'Cargando nómina...',
    openPeriod:       'Período abierto',
    noActivePeriod:   'Sin período activo',
    kpiTotal:         'Total acumulado',
    kpiWorkers:       'Trabajadores',
    kpiWorkersSub:    'En el período activo',
    kpiJornal:        'Jornal',
    kpiJornalSub:     'Por día trabajado',
    kpiDestajo:       'Destajo',
    kpiDestajoCub:    'Por unidad producida',
    kpiContrato:      'Contrato',
    kpiContratoSub:   'Monto fijo acordado',
    tabActive:        'Período Activo',
    tabByLot:         'Por Lote',
    tabHistory:       'Historial',
    recordsLabel:     'Registros',
    noActivePeriodOpen: 'Sin período abierto',
    noEntries:        'No hay registros en el período activo.',
    noEntriesSub:     'Usa «+ Registrar pago» para agregar trabajadores a este periodo.',
    colWorker:        'Trabajador',
    colLot:           'Lote',
    colActivity:      'Actividad',
    colType:          'Tipo',
    colDetail:        'Detalle',
    colTotal:         'Total',
    jornalDays:       'días',
    contratoLabel:    'Contrato fijo',
    chartTitle:       'Mano de Obra por Lote (MXN)',
    chartLegend:      'Total MO',
    noData:           'Sin datos',
    distTitle:        'Distribución por Tipo de Pago',
    distColType:      'Tipo',
    distColAmount:    'Monto',
    distTotal:        'Total',
    historyTitle:     'Historial de Períodos',
    historyLoading:   'Cargando historial...',
    historyEmpty:     'No hay períodos registrados.',
    histColPeriod:    'Período',
    histColDates:     'Fechas',
    histColStatus:    'Estado',
    histColCostBasis: 'Base de Costo',
    histColTotal:     'Total',
    statusOpen:       'Abierto',
    statusClosed:     'Cerrado',
    costBasisTotal:   'Producción total',
    costBasisSellable: 'Vendible',
    openPeriodBtn:    '+ Abrir período',
    closePeriodBtn:   'Cerrar período',
    closePeriodConfirm: '¿Cerrar este período de nómina? Se calculará el total final y no se podrán agregar más registros.',
    addEntryBtn:      '+ Registrar pago',
    openPeriodTitle:  'Abrir período de nómina',
    fieldLabel:       'Etiqueta *',
    fieldLabelPlaceholder: '1a Quincena Julio 2026',
    fieldStartDate:   'Fecha inicio *',
    fieldEndDate:     'Fecha fin *',
    fieldCostBasis:   'Base de costo',
    addEntryTitle:    'Registrar pago',
    fieldWorkerName:  'Nombre del trabajador *',
    unknownLote: 'Lote no disponible',
    workerPlaceholder: 'Buscar o escribir un nombre',
    workerFreeText: 'Se usará el nombre escrito',
    lotePlaceholder: 'Buscar lote',
    fieldWorkerPhone: 'Teléfono (opcional)',
    fieldLoteId:      'Lote *',
    payTypeJORNAL:  'Jornal',
    payTypeDESTAJO: 'Destajo',
    payTypeCONTRATO: 'Contrato',
    fieldPayType:     'Tipo de pago *',
    fieldActivity:    'Actividad *',
    fieldDays:        'Días trabajados',
    fieldUnits:       'Unidades producidas',
    fieldUnitLabel:   'Unidad (kg, cajas...)',
    fieldRate:        'Tarifa ($) *',
    fieldNotes:       'Notas',
    labelRequired:    'La etiqueta es requerida',
    datesRequired:    'Fecha inicio y fin son requeridas',
    workerRequired:   'El nombre del trabajador es requerido',
    loteRequired:     'Selecciona un lote',
    activityRequired: 'La actividad es requerida',
    rateRequired:     'La tarifa debe ser mayor a 0',
    openPeriodError:  'Error al abrir el período',
    closePeriodError: 'Error al cerrar el período',
    addEntryError:    'Error al registrar el pago',
    create:           'Crear',
  },

  // ── Actividades (tipos) ───────────────────────────────────────────────────────
  activityTypes: {
    PREPARACION:   'Preparación',
    SIEMBRA:       'Siembra',
    RIEGO:         'Riego',
    FERTILIZACION: 'Fertilización',
    FITOSANITARIO: 'Fitosanitario',
    COSECHA:       'Cosecha',
    MAQUINARIA:    'Maquinaria',
    LABORES:       'Labores',
    OTRO:          'Otro',
    NOVEDAD:       'Novedad',
    CLIMA:         'Clima',
  },

  // ── Activity Feed ─────────────────────────────────────────────────────────────
  activityFeed: {
    loading: 'Cargando actividades...',
    empty:   'No hay actividades recientes.',
    unknownPerson: 'Alguien',
    verb: {
      PREPARACION:   'preparó el terreno',
      SIEMBRA:       'sembró',
      RIEGO:         'regó',
      FERTILIZACION: 'aplicó fertilizante',
      FITOSANITARIO: 'aplicó un químico',
      COSECHA:       'cosechó',
      MAQUINARIA:    'usó maquinaria',
      LABORES:       'realizó labores',
      OTRO:          'registró una operación',
      NOVEDAD:       'reportó una novedad',
      CLIMA:         'registró un evento climático',
    },
    allTab:           'Todas',
    searchPlaceholder: 'Buscar en notas e insumos...',
    noResults:        'Sin resultados para esta búsqueda.',
    loadMore:         'Cargar más',
    editNotes:        'Editar nota',
    sowingDensity:    'Densidad de siembra',
    sowingRowSpacing: 'Distancia entre hileras',
    weatherRain: 'Lluvia',
    weatherFrost: 'Helada',
    sowingPlantSpacing: 'Distancia entre plantas',
    sowingGenetics:   'Genética',
    notesLabel:       'Nota',
    notesPlaceholder: 'Escribe una nota...',
    saveNotes:        'Guardar',
    cancelEdit:       'Cancelar',
    saveError:        'No se pudo guardar la nota. Intenta de nuevo.',
    newBadge:         '{count} datos nuevos',
    delete:           'Eliminar',
    deleteConfirmTitle: '¿Eliminar este registro?',
    deleteConfirmBody: 'Se eliminará este registro de "{name}" del historial y se revertirá el descuento de inventario asociado.',
    deleteError:      'No se pudo eliminar el registro. Puede que otro dato dependa de él.',
    stockUsed:        'Insumo descontado: {product} {qty} {unit}',
    mineTab:          'Mis datos',
    materialsLabel:   'Materiales',
  },

  // ── Portal Inversionista — resumen del día ────────────────────────────────────
  investor: {
    title:               'Resumen del día',
    subtitle:             'Vista general del proyecto — solo lectura',
    loading:              'Cargando resumen...',
    kpiLotes:             'Lotes activos',
    kpiActivities:        'Actividades hoy',
    kpiActivitiesSub:     'Registradas en el día',
    kpiCostToday:         'Costo del día',
    kpiPendingTasks:      'Tareas pendientes',
    kpiOverdueTasks:      'Tareas vencidas',
    financeTitle:         'Inversión y costos',
    kpiTotalCost:         'Costo total acumulado',
    kpiLotesConCosto:     'Lotes con costo registrado',
    logisticsTitle:       'Logística y exportación',
    kpiShipments:         'Embarques totales',
    kpiInTransit:         'En tránsito',
    kpiHeld:              'Detenidos',
    kpiDelivered:         'Entregados',
    kpiTempAnomalies:     'Excursiones de temperatura',
    lotesTitle:           'Mapa de lotes',
    modulesTitle:         'Mapa de zonas',
    noCrop:               'Sin cultivo asignado',
    activityTitle:        'Bitácora reciente',
    // F6 — Detalle de zona con sensores y dron
    plantingDate:         'Fecha de siembra',
    area:                 'Área',
    phenology:            'Fenología',
    phenologyStub:        'Gráfico plan-vs-real (F2)',
    soilSensors:          'Sensores de suelo',
    sensorDataStub:       'Gráficos de humedad, CE, pH (F5)',
    droneVideo:           'Video de dron',
    videoPlaceholder:     'Miniatura de video',
    openAnomalies:        'Anomalías abiertas',
  },

  // ── Portal Inversionista — Rendimiento y Cosecha ──────────────────────────────
  investorYield: {
    title:       'Rendimiento y Cosecha',
    subtitle:    'Producción, calidad y merma del proyecto — solo lectura',
    harvestTitle: 'Cosecha y empaque',
    mermaTitle:   'Merma y pérdidas',
    tabResumen:  'Resumen',
    tabAnalisis: 'Análisis',
    analysisTitle: 'Escenarios de pronóstico por zona',
    analysisSubtitle: 'Comparativo conservador / base / ideal a 7, 15 y 60 días — mismo forecast determinista de Producción.',
    analysisNoProject: 'Selecciona un proyecto en la barra superior para ver el análisis.',
    analysisNoModules: 'El proyecto activo no tiene zonas con pronóstico.',
    analysisForecastTitle: 'Producción prevista (próximos 15 días)',
    harvestMapTitle:    'Mapa de zonas por estado de cosecha',
    harvestMapSubtitle: 'Estado operativo de cada zona (F1) — proxy de avance de cosecha mientras no exista un % de progreso de cosecha por zona.',
    lossReasonsTitle:   'Causas de pérdida',
    analysisColModule: 'Zona',
    analysisColCrop:   'Cultivo',
    analysisScenarioLegend: 'Cada celda: conservador / base / ideal.',
  },

  // ── Portal Inversionista — Logística y Cobros ─────────────────────────────────
  investorLogistics: {
    title:              'Logística y Cobros',
    subtitle:            'Embarques, temperatura y estados de exportación — solo lectura',
    kpiTempAnomalies:    'Excursiones de temperatura',
    kpiDelays:           'Embarques con retraso',
    shipmentsTitle:      'Embarques recientes',
    collectionsTitle:    'Cobros',
    agingCurrent:        'Al corriente',
    agingBucketPrefix:   'Vencido',
    agingTotal:          'Total por cobrar',
    tableCustomer:       'Cliente',
    telemetryTitle:      'Telemetría del embarque',
    routeTitle:          'Ruta',
    temperatureTitle:    'Temperatura en tránsito',
    inRangePct:          '% del tiempo en rango',
    noTelemetry:         'Este embarque no tiene dispositivo de telemetría asignado.',
    telemetryError:      'No se pudo cargar la telemetría de este embarque. Intenta de nuevo más tarde.',
    selectShipment:      'Selecciona un embarque para ver su telemetría.',
    currentPosition:     'Posición actual',
    tempRange:           'Rango permitido',
    lastReading:         'Última lectura',
  },

  // ── Portal Inversionista — Detalle de zona (F1, sin mapa) ───────────────────
  investorModules: {
    title:              'Zonas',
    subtitle:            'Mapa de zonas del proyecto — solo lectura',
    loading:             'Cargando zonas...',
    noModules:           'Sin zonas registradas todavía.',
    noCrop:              'Sin cultivo asignado',
    allLotes: 'Todos los lotes',
    loteFilter: 'Filtrar por lote',
    kmlInvalid: 'El KML no tiene un polígono válido',
    kmlOutside: 'La geocerca del KML queda fuera de la zona padre o del lote',
    kmlSaved: 'Geocerca actualizada desde el KML',
    kmlError: 'No se pudo guardar la geocerca',
    viewOnMap:           'Ver en mapa',
    daysSincePlanting:   'Días de siembra',
    statusPREPARACION:   'Preparación',
    statusNORMAL:        'Normal',
    statusATENCION:      'Atención',
    statusCRITICO:       'Crítico',
    statusCOSECHANDO:    'Cosechando',
    loadingVideo:        'Cargando video…',
    videoLoadError:      'No se pudo cargar el video',
    notFound:            'Zona no encontrada',
    back:                'Atrás',
    plantingDate:        'Fecha de siembra',
    area:                'Área',
    fenologyTitle:       'Fenología',
    soilSensorsTitle:    'Sensores de suelo',
    videoTitle:          'Video de dron',
    anomaliesTitle:      'Anomalías abiertas',
    telemetryTemp:         'Temperatura (°C)',
    telemetryHumidity:     'Humedad ambiente (%)',
    telemetrySoilMoisture: 'Humedad de suelo (%)',
    telemetryError:        'No se pudo cargar la telemetría de la zona.',
    noTelemetry:           'Sin lecturas de sensores para esta zona todavía.',
    historyTitle:          'Historial',
    historyFrom:           'Desde',
    historyTo:             'Hasta',
    historyActivity:       'Actividad',
    historyStatus:         'Estado',
    historyAll:            'Todos',
    historyCurrent:        'Vigente',
    historyClosed:         'Cerrado',
    historyReasonCreate:   'Alta de zona',
    historyReasonUpdate:   'Cambio de cultivo',
    historyReasonBackfill: 'Migración',
    historyEmpty:          'Sin registros de historial con estos filtros.',
    historySince:          'Desde',
    historyUntil:          'hasta',
    childrenTitle:         'Zonas dentro de este lote',
    childrenEmpty:         'Sin subzonas.',
  },

  // ── Portal Inversionista — Producción (F2) ────────────────────────────────────
  investorProduction: {
    title:                'Producción',
    subtitle:              'Plan vs. real, pronóstico y anomalías de la zona — solo lectura',
    noProjectSelected:     'Selecciona un proyecto en la barra superior para ver su producción.',
    tabResumen:  'Resumen',
    tabProgreso: 'Progreso',
    progressTitle:    'Progreso por parcela',
    progressSubtitle: 'Todas las parcelas del proyecto activo — % de avance y desviación promedio.',
    progressColLote:         'Lote',
    progressColCrop:         'Cultivo',
    progressColCurrentStage: 'Etapa actual',
    progressColPct:          '% avance',
    progressColDeviation:    'Desviación (días)',
    progressCropTitle:       'Plan por cultivo',
    progressCropLoteCount:   'parcelas',
    progressGanttTitle:      'Matriz de parcelas — plan vs. real',
    progressGanttSubtitle:   'Todas las etapas de todas las parcelas del proyecto activo, ordenadas por lote.',
    progressForecastTitle:    'Pronóstico de producción por zona',
    progressForecastSubtitle: 'Escenario base a 15 días, por zona del proyecto activo.',
    loadingModules:        'Cargando zonas...',
    noModules:             'Sin zonas registradas en este proyecto.',
    noModulesHint:         'La vista de Producción se basa en el seguimiento por Zonas (F1). Para ver plan, pronóstico y anomalías de este proyecto, primero da de alta sus zonas en Mapa GIS.',
    moduleSelector:        'Zona',
    loadingPlan:           'Cargando plan de producción...',
    noPlan:                'Esta zona todavía no tiene plan de producción.',
    ganttTitle:            'Plan vs. real por etapa',
    ganttSubtitle:         'Barra gris = planeado. Barra de color = real (verde a tiempo, rojo atrasado, azul adelantado).',
    ganttPlanned:          'Planeado',
    ganttActual:           'Real',
    ganttOnTime:           'a tiempo',
    ganttLate:             'atrasado',
    ganttEarly:            'adelantado',
    funnelTitle:           'Curva de rendimiento acumulado',
    funnelSubtitle:        '% del rendimiento total del ciclo acumulado al terminar cada etapa',
    forecastTitle:         'Pronóstico de cosecha',
    forecastDisclaimer:    'Los kg de cada escenario son los ESPERADOS DENTRO de los próximos N días (incremental), no el acumulado del ciclo. La confianza baja conforme crece el horizonte.',
    loadingForecast:       'Cargando pronóstico...',
    noForecast:            'Sin pronóstico generado todavía para este horizonte.',
    horizon7:              'Próximos 7 días',
    horizon15:             'Próximos 15 días',
    horizon60:             'Próximos 60 días',
    confidence:            'Confianza',
    scenarioConservador:   'Conservador',
    scenarioBase:          'Base',
    scenarioIdeal:         'Ideal',
    anomaliesTitle:        'Anomalías abiertas',
    loadingAnomalies:      'Cargando anomalías...',
    noAnomalies:           'Sin anomalías abiertas.',
    responsible:           'Responsable',
    severityBAJA:          'Baja',
    severityMEDIA:         'Media',
    severityALTA:          'Alta',
    severityCRITICA:       'Crítica',
    anomalyTypeDESVIACION_FENOLOGICA: 'Desviación fenológica',
    anomalyTypePLAGA:      'Plaga',
    anomalyTypeRIEGO:      'Riego',
    anomalyTypeMAQUINARIA: 'Maquinaria',
    anomalyTypePERSONAL:   'Personal',
    anomalyTypeCLIMA:      'Clima',
    anomalyTypeCALIDAD:    'Calidad',
    anomalyTypeSENSOR:     'Sensor de campo',
    anomalyTypeOTRO:       'Otro',
  },

  // ── Portal Inversionista — Inversión y Fondos (F4) ────────────────────────────
  investorFunding: {
    title:              'Inversión y Fondos',
    subtitle:            'Capital, ministraciones y solicitudes de fondos — solo lectura',
    loading:             'Cargando...',
    noData:              'Sin datos todavía.',
    months:              'meses',
    kpiCommitted:        'Capital comprometido',
    kpiDrawn:            'Capital ministrado',
    kpiPending:          'Pendiente de ministrar',
    kpiCollected:        'Cobrado a la fecha',
    kpiRoi:              'ROI',
    kpiIrr:              'TIR anual',
    kpiPayback:          'Punto de equilibrio',
    byCurrencyTitle:    'Métricas por moneda',
    sourcesTitle:        'Fuentes de capital',
    drawdownsTitle:      'Ministraciones',
    fundRequestsTitle:   'Solicitudes de fondos',
    fundCategories: { INSUMOS: 'Insumos', MAQUINARIA: 'Maquinaria', MANO_DE_OBRA: 'Mano de obra', INFRAESTRUCTURA: 'Infraestructura', OTRO: 'Otro' } as Record<string, string>,
    tableName:           'Nombre',
    tableType:           'Tipo',
    tableCommitted:      'Comprometido',
    tableDrawn:          'Ministrado',
    tablePending:        'Pendiente',
    tableDate:           'Fecha',
    tableAmount:         'Monto',
    tableStatus:         'Estado',
    sourceTypeINVESTOR: 'Inversionista',
    sourceTypeBANK: 'Banco',
    sourceTypeFIRA: 'FIRA',
    sourceTypeOWN: 'Propio',
    tableCategory:       'Categoría',
    drawdownPLANNED:     'Planeada',
    drawdownRECEIVED:    'Recibida',
    drawdownCANCELLED:   'Cancelada',
    fundRequestPENDING:  'Pendiente',
    fundRequestAPPROVED: 'Aprobada',
    fundRequestREJECTED: 'Rechazada',
    fundRequestCANCELLED:'Cancelada',
  },

  // ── Detalle de lote ───────────────────────────────────────────────────────────
  filterPanel: {
    selectAll:       'Seleccionar Todo',
    clear:           'Limpiar',
    clearAll:        'Limpiar filtros',
    apply:           'Aplicar',
    applyFilterFor:  'Aplicar filtro de {label}',
    dateFrom:        'Desde',
    dateTo:          'Hasta',
  },
  loteDetail: {
    loading:     'Cargando lote...',
    notFound:    'Lote no encontrado.',
    crop:        'Cultivo',
    hectares:    'Hectáreas',
    accCost:     'Costo acumulado',
    recentActs:  'Actividades recientes',
    costsByType: 'Costos por categoría',
    noCosts:     'Sin costos registrados.',
    // Datos del lote — FilterPanel (gap FieldData)
    dataTitle:       'Datos del lote',
    dataFilterDate:  'Fecha',
    dataFilterType:  'Tipo',
    dataFilterUser:  'Usuario',
    dataEmpty:       'Sin datos que coincidan con los filtros.',
    dataOriginActivity: 'Actividad',
    dataOriginMovement: 'Movimiento',
    // Presupuesto base
    budgetTitle:          'Presupuesto base de insumos',
    budgetEmpty:          'Sin presupuesto base. Usa «+ Nuevo presupuesto» o aplica un protocolo a este lote.',
    budgetProtocol:       'Protocolo',
    budgetCycle:          'Ciclo',
    budgetChemicals:      'Químicos / Fitosanitarios',
    budgetFert:           'Fertilizantes',
    budgetCostHaChem:     'Costo/ha químicos',
    budgetCostHaFert:     'Costo/ha fertilizante',
    budgetTotal:          'Total presupuestado',

    // NDVI
    ndviTitle:        'Índice de Vegetación (NDVI)',
    ndviMean:         'Promedio',
    ndviMin:          'Mínimo',
    ndviMax:          'Máximo',
    ndviCloud:        'Cobertura nubosa',
    ndviDate:         'Fecha de imagen',
    ndviTimeline:     'Tendencia NDVI (90 días)',
    ndviNoBoundary:   'Sin geocerca definida. Define el polígono en el Mapa para activar NDVI.',
    ndviNoApiKey:     'Integración con Agromonitoring no configurada.',
    ndviDisabled:     'NDVI no está habilitado para este rancho; pídele a un administrador que lo active.',
    ndviNoData:       'No hay imágenes satelitales disponibles para este período.',
    ndviLoading:      'Obteniendo imagen satelital...',
    ndviHealthGood:   'Vegetación saludable',
    ndviHealthMid:    'Vegetación moderada',
    ndviHealthLow:    'Vegetación baja / estrés',

    // Fase B — capas de mapa, historial de precio, panel de riesgos
    mapLayersTitle:   'Capas de mapa',
    layerNdvi:        'NDVI',
    systemTitle: 'Cambios del sistema',
    systemEmpty: 'Sin cambios registrados todavía.',
    systemEvents: { LOTE_UPDATED: 'Lote editado', LOTE_BOUNDARY_CHANGED: 'Geocerca del lote', MODULE_CREATED: 'Zona creada', MODULE_UPDATED: 'Zona editada', MODULE_BOUNDARY_CHANGED: 'Geocerca de zona', MODULE_DELETED: 'Zona eliminada' },
    layerOrtho:       'Ortomosaico',
    orthoPlaceholder: 'Sin pipeline de ortomosaico todavía — este mapa se conectará cuando exista una fuente real de imágenes de dron/satélite georreferenciadas para la parcela.',
    priceTitle:       'Historial de precio',
    priceSubtitle:    'Precio unitario de órdenes de venta del mismo cultivo de la empresa — aproximado, el modelo de datos no vincula ventas a esta parcela específica todavía.',
    priceSubtitleWithCompany: 'Precio unitario de órdenes de venta del mismo cultivo de {company} — aproximado, el modelo de datos no vincula ventas a esta parcela específica todavía.',
    priceNoData:      'Sin órdenes de venta de este cultivo todavía.',
    priceLatest:      'Precio más reciente',
    riskTitle:        'Riesgos de esta parcela',
    riskNoData:       'Sin anomalías abiertas para esta parcela.',

    // Pestañas del detalle (Resumen / Mapa / Actividades / Finanzas)
    tabSummary:       'Resumen',
    tabMap:           'Mapa',
    tabActivities:    'Actividades',
    tabFinance:       'Finanzas',
    financeEmpty:     'Sin datos financieros para este lote todavía.',
  },

  // ── Maquinaria ────────────────────────────────────────────────────────────────
  machinery: {
    labor: {
      title:           'Mano de obra',
      lote:            'Lote',
      selectLote:      'Elige un lote',
      register:        'Registrar jornada',
      loading:         'Cargando mano de obra...',
      empty:           'Sin jornadas registradas en este lote.',
      date:            'Fecha',
      laborType:       'Tipo',
      activity:        'Actividad',
      workers:         'Trabajadores',
      hoursPerWorker:  'Horas por trabajador',
      dailyRate:       'Tarifa diaria por trabajador (MXN)',
      notes:           'Notas',
      totalCost:       'Costo',
      totalLabel:      'Total',
      save:            'Guardar',
      cancel:          'Cancelar',
      saveError:       'No se pudo registrar la jornada. Revisa los datos e inténtalo de nuevo.',
      types: { JORNAL: 'Jornal', DESTAJO: 'Destajo', CONTRATO: 'Contrato' },
    },
    title:           'Maquinaria',
    loading:         'Cargando maquinaria...',
    machinesUnit:    'máquinas',
    inUseUnit:       'en uso',
    rentedUnit:      'rentadas',
    kpiTotal:        'Total maquinaria',
    kpiTotalSub:     'en uso ahora',
    kpiRentals:      'En renta',
    kpiRentalsSub:   'de terceros',
    kpiDiesel:       'Diesel (precio actual)',
    kpiDieselFrom:   'desde',
    kpiDieselNone:   'Sin configurar',
    kpiSessions:     'Sesiones recientes',
    kpiSessionsSub:  'últimas',
    fleet:           'Flota',
    recentSessions:  'Sesiones recientes',
    catalog:         'Catálogo de actividades de campo',
    rental:          'Renta',
    noSessions:      'Sin sesiones registradas.',
    noCatalog:       'Sin catálogo. Ejecuta el seed script para poblar las actividades.',
    tableDevice:     'Máquina',
    tableActivity:   'Actividad',
    tableStart:      'Inicio',
    tableHours:      'Horas',
    tableDiesel:     'Diesel (L)',
    tableTotalCost:  'Costo total',
    tableCostPerHa:  'Costo/ha',
    tableStatus:     'Estado',
    sessionClosed:   'Cerrada',
    sessionActive:   'En curso',
    sessionOverrun:  'Desvío',
    overrunTooltip:  'Desvío de horas sin justificar',
    timerStart: 'Iniciar',
    timerStop: 'Detener',
    timerStartTitle: 'Iniciar operación',
    timerStopTitle: 'Detener operación',
    timerLote: 'Lote',
    timerActivity: 'Actividad',
    timerFuelLiters: 'Combustible (L)',
    timerFuelPrice: 'Precio por litro',
    timerHourlyRate: 'Tarifa por hora (opcional)',
    timerRunning: 'En curso',
    timerErrStart: 'No se pudo iniciar la operación',
    timerErrStop: 'No se pudo detener la operación',
    timerHectares: 'Hectáreas completadas (opcional)',
    timerBudgetCap: 'Presupuesto máximo por ha (opcional)',
    timerRentalCost: 'Renta del día (opcional)',
    timerResultTitle: 'Operación detenida',
    timerCostTotal: 'Costo total',
    timerCostPerHa: 'Costo por ha',
    timerCostPerHaNA: 'Costo/ha no calculado: indica las hectáreas completadas al detener.',
    timerAlertLabel: 'Alerta de presupuesto',
    timerAlertNONE: 'Dentro del presupuesto',
    timerAlertYELLOW: 'Amarilla: cerca del presupuesto',
    timerAlertORANGE: 'Naranja: alta',
    timerAlertRED: 'Roja: crítica',
    timerAlertEXCEEDED: 'Presupuesto excedido',
    timerNotPersisted: 'Resumen informativo: no se registró el gasto en contabilidad (en el bot se confirma con un borrador).',
    timerClose: 'Cerrar',
    timerRegister: 'Registrar en contabilidad',
    timerRegistered: 'Registrado en contabilidad.',
    timerErrRegister: 'No se pudo registrar el costo en contabilidad.',
    timerSelectLote: 'Selecciona un lote',
    timerActivityRequired: 'Escribe la actividad',
    timerDuration: 'Duración',
    catalogActivity: 'Actividad',
    catalogHrsHa:    'Hrs/ha',
    catalogDieselHa: 'Diesel/ha',
    catalogAlertPct: 'Alerta %',
    types: {
      TRACTOR: 'Tractor',
      FUMIGADORA: 'Fumigadora',
      DRON: 'Dron',
      CAMION: 'Camión',
      OTRO: 'Otro',
    },
    fuels: {
      DIESEL: 'Diésel',
      GASOLINE: 'Gasolina',
      ELECTRIC: 'Eléctrico',
    },
    newMachine: 'Nueva maquinaria',
    emptyFleet: 'Sin maquinaria registrada.',
    addFirst: 'Agregar primera máquina',
    rentedDefault: 'Rentada',
    perDay: '{amount}/día',
    plateLabel: 'Placas: {plate}',
    form: {
      editTitle: 'Editar maquinaria',
      name: 'Nombre *',
      type: 'Tipo *',
      fuel: 'Combustible',
      model: 'Modelo',
      year: 'Año',
      plate: 'Placas',
      status: 'Estado',
      isRental: 'Es maquinaria rentada',
      rentalOwner: 'Propietario / Arrendador',
      rentalCost: 'Costo/día (MXN)',
      droneSection: '🚁 Datos del dron',
      droneModel: 'Marca y modelo *',
      serial: 'Número de serie *',
      tank: 'Capacidad del tanque (L) *',
      coverage: 'Cobertura por carga (ha) *',
      pilotSection: '👨‍✈️ Piloto certificado',
      pilotName: 'Nombre completo *',
      pilotPhone: 'Teléfono *',
      license: 'Licencia AFAC/SICT *',
      licenseExpiry: 'Vencimiento licencia *',
      registration: 'Número de registro de aeronave',
      optional: 'Opcional',
      saveChanges: 'Guardar cambios',
      create: 'Crear maquinaria',
      errCreate: 'Error al crear',
      errUpdate: 'Error al actualizar',
      droneModelRequired: 'La marca/modelo del dron es requerida',
      serialRequired: 'El número de serie es requerido',
      tankRequired: 'La capacidad del tanque es requerida',
      pilotNameRequired: 'El nombre del piloto es requerido',
      pilotPhoneRequired: 'El teléfono del piloto es requerido',
      licenseRequired: 'El número de licencia es requerido',
      licenseExpiryRequired: 'La fecha de vencimiento de licencia es requerida',
      deleteTitle: 'Eliminar maquinaria',
      deleteConfirm: '¿Eliminar {name}? Esta acción no se puede deshacer.',
    },
  },

  // ── Maquinaria (estados) ──────────────────────────────────────────────────────
  machineryStatus: {
    AVAILABLE:      'Disponible',
    IN_USE:         'En uso',
    MAINTENANCE:    'Mantenimiento',
    OUT_OF_SERVICE: 'Fuera de servicio',
  },

  // ── Merma (página dedicada — Sprint A) ────────────────────────────────────────
  merma: {
    title:              'Merma / Pérdidas',
    loading:            'Cargando merma...',
    kpiRejectedKg:      'Total rechazado (kg)',
    kpiImpact:          'Impacto económico',
    kpiRecords:         'Eventos registrados',
    tableTitle:         'Historial de merma',
    tableDate:          'Fecha',
    tableLote:          'Lote',
    tableBatch:         'Ciclo',
    tableReason:        'Causa',
    tableKg:            'Kg rechazados',
    tableBoxes:         'Cajas',
    tableImpact:        'Impacto ($)',
    tableStatus:        'Estado',
    noRecords:          'Sin merma registrada.',
    registerBtn:        '+ Registrar merma',
    closeBtn:           'Cerrar reporte',
    closeConfirm:       '¿Cerrar el reporte de merma de este ciclo? Todos los registros pasarán a CERRADA.',
    registerTitle:      'Registrar merma',
    fieldLote:          'Lote',
    fieldLoteZone:      'Lote o zona',
    fieldBatch:         'Ciclo (batchId)',
    fieldReason:        'Causa',
    fieldKg:            'Kg rechazados',
    fieldBoxes:         'Cajas rechazadas (opcional)',
    fieldCostKg:        'Costo/kg ($, opcional)',
    fieldNotes:         'Notas',
    filterAllLotes:     'Todos los lotes',
    filterAllBatches:   'Todos los ciclos',
    chartTitle:         'Merma por causa (kg)',
    successCreate:      'Merma registrada.',
    successClose:       'Reporte cerrado.',
    errorCreate:        'Error al registrar merma.',
    errorClose:         'Error al cerrar el reporte.',
    reasonCLIMA:           'Daño por clima',
    reasonPLAGA:           'Daño por plaga',
    reasonMECANICO:        'Daño mecánico',
    reasonRECHAZO_CALIDAD: 'Rechazo calidad/calibre',
    reasonPUDRICION:       'Pudrición',
    reasonOTRO:            'Otra causa',
    statusREGISTRADA:   'Registrada',
    statusVERIFICADA:   'Verificada',
    statusCERRADA:      'Cerrada',
  },

  // ── Exportación (Sprint B) ────────────────────────────────────────────────────
  export: {
    kdeTitle: 'Datos clave de trazabilidad',
    kdeRecipientLocation: 'Ubicación del destinatario',
    kdeOriginLocation: 'Lugar de origen',
    kdeShipDate: 'Fecha de envío',
    kdeRefDoc: 'Documento de referencia',
    kdeTlcs: 'Códigos de lote',
    title:            'Exportación',
    loading:          'Cargando embarques...',
    // KPIs
    kpiTotal:         'Total embarques',
    kpiInTransit:     'En tránsito',
    kpiHeld:          'Retenidos',
    kpiDelivered:     'Entregados',
    kpiKg:            'KG enviados',
    kpiTransitDays:   'Días tránsito prom.',
    // Tabla
    tableContainer:   'Contenedor',
    tableProduct:     'Producto',
    tableDestination: 'Destino',
    tableKg:          'KG',
    tableBoxes:       'Cajas',
    tableStatus:      'Estado',
    tableDeparted:    'Salida',
    tableArrived:     'Llegada',
    noData:           'Sin embarques registrados.',
    // Detalle
    detailTitle:      'Detalle del embarque',
    detailEventsTitle:'Cadena de eventos',
    docDownload:      'Descargar',
    // Estatus
    statusDRAFT:                'Borrador',
    statusPACKING:              'Empacando',
    statusSEALED:               'Sellado',
    statusDEPARTED:             'Salió',
    statusCUSTOMS_SUBMITTED:    'En aduana',
    statusCUSTOMS_CLEARED:      'Aduana OK',
    statusCUSTOMS_HOLD:         'Aduana retiene',
    statusFDA_SUBMITTED:        'En FDA',
    statusFDA_CLEARED:          'FDA OK',
    statusFDA_HOLD:             'FDA retiene',
    statusARRIVED:              'Llegó',
    statusDELIVERED:            'Entregado',
    statusCANCELLED:            'Cancelado',
    daysUnit: 'días',
  },

  // ── Transporte (Sprint B) ─────────────────────────────────────────────────────
  transport: {
    title:            'Transporte',
    loading:          'Cargando embarques...',
    addBtn:           '+ Registrar embarque',
    noData:           'Sin embarques registrados.',
    // Filtros
    filterPeriod:     'Período',
    filterLote:       'Lote',
    filterAllLote:    'Todos los lotes',
    // Tabla
    tableDate:        'Fecha',
    tableDestination: 'Destino',
    tableDriver:      'Chofer',
    tablePlate:       'Placa',
    tableKg:          'KG total',
    tableBoxes:       'Cajas',
    tableStatus:      'Estado',
    tableGradeA:      'Grado A',
    tableGradeB:      'Grado B',
    tableGradeC:      'Grado C',
    // Estado
    statusPENDING:    'Pendiente',
    statusEN_RUTA:    'En ruta',
    statusENTREGADO:  'Entregado',
    statusCANCELADO:  'Cancelado',
    // Acción
    markEnRuta:       'Marcar en ruta',
    markEntregado:    'Marcar entregado',
    markCancelado:    'Cancelar',
    confirmAction:    '¿Confirmar cambio de estado?',
    // Nuevo embarque
    newShipmentTitle: 'Registrar embarque',
    fieldLoteId:      'Lote *',
    fieldLoteIdPlaceholder: 'lote_simiente_04',
    fieldDestination: 'Destino *',
    fieldDestinationPlaceholder: 'Empacadora Central, McAllen TX...',
    fieldDriver:      'Chofer',
    fieldTruckPlate:  'Placa',
    fieldTransportCompany: 'Empresa de transporte',
    fieldScheduledAt: 'Fecha programada',
    fieldBoxesTitle:  'Cajas',
    fieldCalibre:     'Calibre',
    fieldBoxCount:    'Cantidad de cajas',
    fieldWeightKg:    'Peso (kg)',
    fieldGrade:       'Grado',
    addBoxRow:        '+ Agregar fila',
    removeBoxRow:     'Quitar',
    loteRequired:     'El lote es requerido',
    destinationRequired: 'El destino es requerido',
    boxesRequired:    'Agrega al menos una fila de cajas',
    createShipmentError: 'Error al registrar el embarque',
    create:           'Registrar',
  },

  // ── Trazabilidad (Sprint B) ───────────────────────────────────────────────────
  fsmaExport: {
    title:           'Entrega FSMA 204',
    subtitle:        'Hoja de KDE por código de lote (TLC) para entregar en 24 horas, rastreo y simulacro de retiro.',
    disabled:        'La trazabilidad FSMA 204 no está activa para esta empresa.',
    exportTitle:     'Hoja de KDE',
    rangeFrom:       'Desde',
    rangeTo:         'Hasta',
    tlcOptional:     'TLC (opcional)',
    exportXlsx:      'Descargar .xlsx',
    exportCsv:       'Descargar .csv',
    exportError:     'No se pudo generar la hoja',
    exportTruncated: 'La hoja tiene más registros de empaque que el límite de exportación, así que la exportación está incompleta.',
    traceTitle:      'Rastreo por TLC',
    traceTlc:        'Código de lote (TLC)',
    traceForward:    'Hacia adelante (a quién fue)',
    traceBackward:   'Hacia atrás (de dónde vino)',
    traceError:      'No se pudo consultar el rastreo',
    lotesLabel:      'Lotes de origen',
    foliosLabel:     'Folios',
    unmatchedLabel:  'Kg no conciliados',
    noShipments:     'Sin embarques para este TLC.',
    none:            '—',
    drillTitle:      'Simulacro de retiro',
    drillStart:      'Inicio del simulacro',
    drillFinish:     'Fin del simulacro',
    drillMerma:      'Merma (kg, opcional)',
    drillNotes:      'Notas (opcional)',
    drillSubmit:     'Registrar simulacro',
    drillError:      'No se pudo registrar el simulacro',
    drillMinutes:    'Tiempo transcurrido',
    drillPassed:     'Cumple',
    drillFailed:     'No cumple',
    drillNoThreshold: 'Sin veredicto: falta configurar el umbral de balance de masas',
    drillsHistory:   'Simulacros registrados',
  },

  traceabilityPlan: {
    title:              'Plan de trazabilidad',
    subtitle:           'Plan de la regla de trazabilidad 21 CFR 1.1315 (FSMA 204). Se guarda por empresa y se puede exportar.',
    recordsLocation:    'Dónde se guardan los registros',
    recordsFormat:      'Formato de los registros',
    foodIdentification: 'Cómo se identifican los alimentos de la lista',
    tlcProcedure:       'Cómo se asignan los códigos de lote de trazabilidad (TLC)',
    contactName:        'Punto de contacto: nombre',
    contactPhone:       'Punto de contacto: teléfono',
    contactEmail:       'Punto de contacto: correo (opcional)',
    version:            'Versión',
    save:               'Guardar plan',
    saving:             'Guardando...',
    saved:              'Plan guardado',
    saveError:          'No se pudo guardar el plan',
    exportXlsx:         'Exportar .xlsx (plan y mapa de finca)',
    exportGeoJson:      'Exportar GeoJSON (geocercas)',
    exportError:        'No se pudo exportar',
    noPlan:             'Aún no hay plan guardado.',
    readOnly:           'Solo lectura: necesitas permiso de escritura de trazabilidad para editar.',
  },
  traceability: {
    destinationLabel: 'Destino:',
    buyerLabel: 'Comprador:',
    eventCOOLING: 'Enfriado',
    kdeComplete: 'Datos clave completos',
    kdeMissingPrefix: 'Faltan',
    kdeFields: {
      coolingLocation: 'Lugar de enfriado',
      coolingDate: 'Fecha de enfriado',
      product: 'Producto',
      quantityKg: 'Cantidad (kg)',
      recipientLocation: 'Ubicación del destinatario',
      referenceDocType: 'Tipo de documento de referencia',
      referenceDocNumber: 'Número de documento de referencia',
      packingLocation: 'Lugar de empaque inicial',
      harvesterName: 'Cosechador',
      harvesterPhone: 'Teléfono del cosechador',
      tlc: 'Código de lote de trazabilidad',
      harvestedAt: 'Fecha de cosecha',
      originLocation: 'Lugar de origen del envío',
      shipDate: 'Fecha de envío',
    },
    foliosTitle: 'Folios — {lote}',
    title:              'Trazabilidad',
    loading:            'Cargando folios...',
    addFolioBtn:        '+ Nuevo folio',
    noData:             'Sin folios. Selecciona un lote.',
    loteLabel:          'Lote',
    // Tabla folios
    tableFolioId:       'Folio',
    tableProduct:       'Producto',
    tableVariety:       'Variedad',
    tableEstKg:         'KG est.',
    tableStatus:        'Estado',
    tableCreated:       'Creado',
    // Detalle
    detailTitle:        'Cadena de custodia',
    detailNoEvents:     'Sin eventos en este folio.',
    eventType:          'Tipo de evento',
    eventDesc:          'Descripción',
    eventTemp:          'Temperatura',
    eventKg:            'KG',
    eventBy:            'Operador',
    addEventBtn:        '+ Agregar evento',
    // Estados folio
    statusOPEN:         'Abierto',
    statusIN_TRANSIT:   'En tránsito',
    statusDELIVERED:    'Entregado',
    statusCLOSED:       'Cerrado',
    // Tipos de evento
    eventFIELD_OP:      'Operación de campo',
    eventHARVEST:       'Cosecha',
    eventPACKING:       'Empaque',
    eventCONTAINER:     'Contenedor',
    eventCUSTOMS:       'Aduana',
    eventEXPORT:        'Exportación',
    // Form crear folio
    formProduct:        'Producto',
    formVariety:        'Variedad',
    formEstKg:          'KG estimados',
    formDestination:    'Destino',
    formBuyer:          'Comprador',
    folioCreated:       'Folio creado.',
    eventAdded:         'Evento agregado.',
    errorCreate:        'Error al crear folio.',
    errorEvent:         'Error al agregar evento.',
  },

  // ── Protocolos (Sprint B) ─────────────────────────────────────────────────────
  protocol: {
    title:              'Protocolos de insumos',
    loading:            'Cargando protocolos...',
    noData:             'Aún no hay protocolos. Usa «+ Nuevo protocolo» para crear uno.',
    filterCrop:         'Cultivo',
    filterRancho:       'Rancho',
    filterAll:          'Todos',
    // Tabla
    tableId:            'ID',
    tableCrop:          'Cultivo',
    tableCiclo:         'Ciclo',
    tableType:          'Tipo',
    tableCostHa:        'Costo/ha',
    tableCreated:       'Creado',
    tableSource:        'Origen',
    // Detalle
    detailTitle:        'Detalle del protocolo',
    detailApps:         'Calendario de aplicaciones',
    detailDay:          'Día',
    detailProducts:     'Productos',
    detailCostHa:       'Costo/ha',
    detailCatalog:      'Catálogo de precios',
    detailName:         'Producto',
    detailPresentation: 'Presentación',
    detailPrice:        'Precio unitario',
    detailCategory:     'Categoría',
    // Tipos
    typeQUIMICO:        'Químico',
    typeFERTILIZANTE:   'Fertilizante',
    typeAMBOS:          'Ambos',
    // Fuente
    sourceTELEGRAM_DOC:   'Documento',
    sourceTELEGRAM_PHOTO: 'Foto',
    sourceTELEGRAM_TEXT:  'Texto',
    newProtocol:        '+ Nuevo protocolo',
    newProtocolTitle:   'Nuevo protocolo',
    editProtocolTitle:  'Editar protocolo',
    deleteBtn:          'Eliminar',
    deleteTitle:        'Eliminar protocolo',
    deleteConfirm:      '¿Eliminar este protocolo? Esta acción no se puede deshacer.',
    applyBtn:           'Aplicar a lote',
    applyTitle:         'Aplicar protocolo como presupuesto',
    applyDesc:          'Se sumará el costo del protocolo al presupuesto del lote y ciclo indicados.',
    applyModeLabel: '¿Qué quieres crear?',
    applyModeBudget: 'Solo presupuesto',
    applyModeTasks: 'Presupuesto con tareas',
    applyModeTasksHint: 'Además del presupuesto se crean el plan de producción y una tarea por aplicación, fechadas desde la siembra.',
    fieldLoteOrZone: 'Lote o zona *',
    loteOrZoneRequired: 'Selecciona un lote o zona',
    applySuccessTasks: 'Protocolo aplicado: presupuesto y tareas creadas.',
    fieldZone:          'Zona *',
    fieldProject:       'Proyecto *',
    fieldPlantingDate:  'Fecha de siembra *',
    zoneRequired:       'Selecciona una zona',
    projectRequired:    'Selecciona un proyecto',
    plantingDateRequired: 'La fecha de siembra es obligatoria',
    fieldCrop:          'Cultivo',
    fieldRanchoId:      'Rancho ID',
    fieldCiclo:         'Ciclo',
    fieldType:          'Tipo *',
    fieldCostoQuimico:  'Costo químicos ($/ha)',
    fieldCostoFert:     'Costo fertilizante ($/ha)',
    fieldCostoTotal:    'Costo total ($/ha) *',
    applicationsTitle:  'Aplicaciones',
    fieldDias:          'Días (ej: 9-10)',
    fieldProductName:   'Producto',
    fieldDose:          'Dosis (ej: 800ml)',
    fieldCostoHaApp:    'Costo/ha',
    addProduct:         '+ Producto',
    removeProduct:      'Quitar',
    addApplication:     '+ Agregar aplicación',
    removeApplication:  'Quitar aplicación',
    catalogTitle:       'Catálogo de precios',
    fieldPresentacion:  'Presentación',
    fieldPrecioUnitario: 'Precio unitario',
    fieldCategory:      'Categoría',
    addCatalogItem:     '+ Agregar producto al catálogo',
    removeCatalogItem:  'Quitar',
    fieldLoteId:        'Lote *',
    fieldHectareas:     'Hectáreas *',
    typeRequired:       'Selecciona un tipo',
    costoTotalRequired: 'El costo total es requerido',
    applicationsRequired: 'Agrega al menos una aplicación',
    loteRequired:       'El lote es requerido',
    hectareasRequired:  'Las hectáreas deben ser mayor a 0',
    cicloRequired:      'El ciclo es requerido',
    createError:        'Error al guardar el protocolo',
    applyError:         'Error al aplicar el protocolo',
    applySuccess:       'Protocolo aplicado al presupuesto.',
    create:             'Guardar',
    typeMARCO_FERTILIZACION: 'Marco de fertilización',
    typeMARCO_PULVERIZACION: 'Marco de pulverización',
    sourceWEB: 'Captura web',
    sourceIMPORT_XLSX: 'Excel',
    newMarco: '+ Nuevo marco',
    newMarcoTitle: 'Nuevo marco',
    editMarcoTitle: 'Editar marco',
    tableName: 'Nombre',
    marcoName: 'Nombre del marco *',
    marcoNamePlaceholder: 'Ej: YUCHOY 90',
    marcoKind: 'Tipo de marco',
    marcoColumns: 'Productos (columnas)',
    marcoColumnName: 'Producto',
    marcoColumnUnit: 'Unidad',
    marcoAddColumn: '+ Producto',
    marcoRemoveColumn: 'Quitar columna',
    marcoRows: 'Tiempos de fertilización',
    marcoAddRow: '+ Agregar tiempo',
    marcoDuplicateRow: 'Duplicar fila',
    marcoRemoveRow: 'Quitar fila',
    marcoTiempo: 'Tiempo',
    marcoDias: 'Días de siembra',
    marcoTipoFert: 'Tipo de fertilizante',
    marcoObs: 'Observación',
    marcoEtapa: 'Etapa fenológica',
    marcoFertHint: 'Cantidad por hectárea en la unidad de cada columna. Usa -1 para el fertilizante base.',
    marcoPulvHint: 'Productos y dosis por aplicación (ej: BELEAF 300g). Usa Observación para pH o riego.',
    marcoNameRequired: 'El nombre del marco es requerido',
    marcoColumnsRequired: 'Agrega al menos un producto con nombre',
    marcoRowsRequired: 'Agrega al menos un tiempo',
    marcoDiasInvalid: 'Cada fila necesita los días de siembra (número)',
    marcoCantidadInvalid: 'Las cantidades deben ser números mayores o iguales a 0',
    marcoSaveError: 'Error al guardar el marco',
    detailMarcoFert: 'Matriz de fertilización',
    marcoNoApply: 'Los marcos no llevan costo y no se aplican como presupuesto.',
    duplicateBtn: 'Duplicar',
    duplicateTitle: 'Duplicar marco',
    duplicateDesc: 'Se creará una copia que podrás editar. Cambia el nombre, cultivo o ciclo si aplica.',
    duplicateConfirm: 'Crear copia',
    duplicateError: 'Error al duplicar',
    duplicateCopySuffix: 'copia',
    importBtn: 'Importar Excel',
    importTitle: 'Importar marcos desde Excel',
    importIntro: 'Sube un archivo .xlsx con marcos de fertilización o de pulverización. Se detecta el tipo de cada hoja y verás una vista previa antes de guardar.',
    importChoose: 'Elegir archivo',
    importValidating: 'Validando...',
    importReadError: 'No se pudo leer el archivo. Verifica que sea un .xlsx con el formato de los marcos.',
    importError: 'No se pudieron importar los marcos',
    importErrorsTitle: 'Revisa el archivo',
    importColSheet: 'Hoja',
    importColMessage: 'Problema',
    importColDetail: 'Contenido',
    importColStatus: 'Estado',
    importDetected: 'marco(s) detectado(s)',
    importProductos: 'productos',
    importTiempos: 'tiempos',
    importAplicaciones: 'aplicaciones',
    importStatusNew: 'Nuevo',
    importReplace: 'Reemplazar',
    importExistsHint: 'Los marcos que ya existen no se modifican a menos que marques «Reemplazar». Al reemplazar se conservan su cultivo, ciclo y rancho.',
    importUnitNote: 'Las cantidades de fertilización se cargan en kg/ha. Si alguna columna usa otra unidad, edítala después en el marco.',
    importConfirm: 'Importar',
    importImporting: 'Importando...',
    importDone: 'Importación lista',
    importCreated: 'creado(s)',
    importReplaced: 'reemplazado(s)',
    importSkipped: 'omitido(s)',
    importClose: 'Cerrar',
  },

  activityCategories: {
    PREPARACION_TERRENO: 'Preparación de terreno',
    SIEMBRA:             'Siembra & trasplante',
    FUMIGACION:          'Fumigación',
    FERTILIZACION:       'Fertilización',
    RIEGO:               'Riego',
    COSECHA:             'Cosecha',
    TRANSPORTE:          'Transporte',
    LABORES:             'Labores generales',
  },

  // ── Cultivo / Fenología + Scouting (Sprint A) ─────────────────────────────────
  crop: {
    title:              'Cultivo',
    loading:            'Cargando datos de cultivo...',
    tabPhenology:       'Fenología',
    tabScouting:        'Scouting / Plagas',
    loteLabel:          'Lote',
    cicloLabel:         'Ciclo',
    cicloPlaceholder:   'ej: 2026-A',
    cicloSearch:        'Consultar',
    cicloUse:          'Usar "{value}"',
    noCiclo:            'Ingresa el ciclo para ver el historial.',
    // Fenología
    phenoTitle:         'Historial fenológico',
    phenoAddBtn:        '+ Registrar etapa',
    phenoNoRecords:     'Sin etapas registradas para este ciclo.',
    phenoTableDate:     'Fecha',
    phenoTableStage:    'Etapa',
    phenoTableCrop:     'Cultivo',
    phenoTableDap:      'DAP',
    phenoTableBy:       'Registrado por',
    phenoDialogTitle:   'Registrar etapa fenológica',
    assignTitle: 'Cultivo y siembra',
    assignHintZones: 'Este lote tiene zonas: asigna el cultivo y la fecha de siembra en cada una.',
    assignHintLote: 'Este lote no tiene zonas: el cultivo y la siembra se asignan al lote completo.',
    assignCropLabel: 'Cultivo',
    assignDateLabel: 'Fecha de siembra',
    assignZoneCol: 'Zona',
    assignNoCatalog: 'Aún no hay cultivos en el catálogo. Da de alta uno en la pestaña Catálogo.',
    assignGoCatalog: 'Ir al Catálogo',
    needAssignment: 'Esta zona o lote no tiene cultivo en el ciclo elegido. Inicia el ciclo en la pestaña Asignación.',
    startCycle: 'Iniciar ciclo',
    closeCycle: 'Cerrar ciclo',
    closeCycleTitle: 'Cerrar el ciclo',
    closeCycleConfirm: '¿Cerrar el ciclo {ciclo} de {zone}? El mapa seguirá mostrando el cultivo atenuado como último ciclo cerrado hasta que inicies otro; el historial se conserva.',
    cycleOf: 'Ciclo de {zone}',
    historyTitle: 'Historial de ciclos',
    historyEmpty: 'Este lote todavía no tiene ciclos.',
    historyZone: 'Zona',
    historyStatus: 'Estado',
    historyClosedAt: 'Cierre',
    historyClosedBy: 'Cerrado por',
    cycleOpen: 'Abierto',
    cycleClosed: 'Cerrado',
    needAssignmentGo: 'Ir a Asignación',
    assignCropType: 'Tipo agronómico (opcional)',
    cropTypeLeaves: 'Hojas', cropTypeFruit: 'Fruta', cropTypeOther: 'Otro', cropTypeAdd: 'agregar {text}',
    assignError: 'No se pudo guardar',
    removeCropError: 'No se pudo quitar el cultivo',
    assignCatalog: 'Catálogo de cultivos',
    assignDeleteCrop: 'Eliminar cultivo',
    assignDeleteInUse: 'No se puede eliminar "{name}": está en uso ({usage}).',
    assignDeleteError: 'No se pudo eliminar el cultivo',
    tabAssignment: 'Asignación',
    tabCatalog: 'Catálogo',
    allLotesTitle: 'Todos los lotes',
    loteAll: '<Todos>',
    allLotesHint: 'Elige un lote para asignarle cultivo y ver su ciclo.',
    colLote: 'Lote',
    colHa: 'Ha',
    colCrop: 'Cultivo',
    colCycle: 'Ciclo',
    cycleNone: 'Sin ciclo',
    catalogTitle: 'Catálogo de cultivos',
    catalogNew: '+ Nuevo cultivo',
    catalogColName: 'Nombre',
    catalogColColor: 'Color',
    catalogEmpty: 'Sin cultivos en el catálogo.',
    catalogEdit: 'Editar',
    catalogCreateTitle: 'Nuevo cultivo',
    catalogEditTitle: 'Editar cultivo',
    fsmaCovered: 'FSMA 204: cubierto',
    fsmaNotCovered: 'FSMA 204: no cubierto',
    fsmaUnknown: 'FSMA 204: sin definir',
    catalogSaveError: 'No se pudo guardar el cultivo',
    catalogDeleteConfirm: '¿Eliminar "{name}" del catálogo? Solo se puede si no está en uso.',
    phenoTableZone: 'Zona',
    zoneFilterLabel: 'Zona',
    zoneAll: 'Todas las zonas',
    usageLotes: '{n} lote(s)',
    usageModules: '{n} zona(s)',
    usageHistory: '{n} registro(s) de historial de zona',
    usagePhenology: '{n} registro(s) de fenología',
    phenoFieldCultivo:  'Tipo de cultivo',
    phenoFieldStage:    'Etapa',
    phenoFieldDap:      'DAP (días desde siembra)',
    phenoFieldNotes:    'Notas',
    phenoSuccess:       'Etapa registrada.',
    phenoError:         'Error al registrar etapa.',
    // Scouting
    scoutTitle:         'Scouting — Plagas y Enfermedades',
    scoutAddBtn:        '+ Registrar detección',
    scoutNoRecords:     'Sin detecciones registradas para este ciclo.',
    scoutTableDate:     'Fecha',
    scoutTableName:     'Plaga / Enfermedad',
    scoutTableType:     'Tipo',
    scoutTablePressure: 'Presión',
    scoutTablePct:      '% Área afectada',
    scoutTableAction:   'Acción tomada',
    scoutDialogTitle:   'Registrar plaga / enfermedad',
    scoutFieldPestType: 'Tipo',
    scoutFieldName:     'Nombre de la plaga / enfermedad',
    scoutFieldPressure: 'Nivel de presión',
    scoutFieldPct:      '% Área afectada (0–100)',
    scoutFieldAction:   'Acción tomada',
    scoutFieldNotes:    'Notas',
    scoutSuccess:       'Detección registrada.',
    scoutError:         'Error al registrar detección.',
    // Alertas
    alertsTitle:        'Alertas activas',
    alertsNone:         'Sin alertas activas.',
    // Etapas
    stagePREPARACION_SUELO: 'Preparación de suelo',
    stageSIEMBRA:           'Siembra',
    stageGERMINACION:       'Germinación',
    stageEMERGENCIA:        'Emergencia',
    stageESTABLECIMIENTO:   'Establecimiento',
    stageVEGETATIVO:        'Vegetativo',
    stageFLORACION:         'Floración',
    stageFRUCTIFICACION:    'Fructificación',
    stageMADURACION:        'Maduración',
    stageCOSECHA:           'Cosecha',
    stagePOST_COSECHA:      'Post-cosecha',
    // Presiones
    pressureBAJO:   'Bajo',
    pressureMEDIO:  'Medio',
    pressureALTO:   'Alto',
    presureCRITICO: 'Crítico',
    // Tipos de plaga
    pestPLAGA:       'Plaga',
    pestENFERMEDAD:  'Enfermedad',
    pestMALEZA:      'Maleza',
    scoutEvidenceTitle: 'Evidencia fotográfica',
    scoutPhotoAlt: 'Evidencia de scouting',
    scoutPhotoAltZoom: 'Evidencia de scouting ampliada',
  },

  // ── Super Admin (gestión de tenants/empresas) ─────────────────────────────────
  superAdmin: {
    accessDenied:       'Acceso denegado — solo disponible para SUPER_ADMIN',
    tenantCreated:      'Empresa creada',
    tenantCreateError:  'Error al crear empresa',
    tenantUpdated:      'Empresa actualizada',
    tenantUpdateError:  'Error al actualizar',
    editTenant:         'Editar empresa',
    newTenant:          'Nueva empresa',
    fieldName:          'Nombre de la empresa',
    fieldNamePlaceholder: 'Ej: Mi Empresa',
    fieldCode:          'Código / Slug URL',
    fieldCodeHint:      'Ej: mi-empresa → /mi-empresa/login',
    fieldCodePlaceholder: 'mi-empresa',
    fieldLogo:          'URL del Logo',
    fieldLogoHint:      'URL pública de la imagen (PNG/SVG)',
    fieldLogoPlaceholder: 'https://cdn.example.com/logo.png',
    cancel:             'Cancelar',
    saveChanges:        'Guardar cambios',
    createTenant:       'Crear empresa',
    title:              'Empresas',
    tenantsRegisteredSingular: 'empresa registrada',
    tenantsRegisteredPlural: 'empresas registradas',
    newTenantBtn:       'Nueva empresa',
    searchPlaceholder:  'Buscar empresa o código...',
    loadingTenants:     'Cargando empresas...',
    noResults:          'Sin resultados',
    noTenants:          'No hay empresas registradas',
    colCompany:         'Empresa',
    colCode:            'Código',
    colStatus:          'Estado',
    colCreated:         'Creada',
    colActions:         'Acciones',
    statusActive:       'Activa',
    statusInactive:     'Inactiva',
    login:              'Login',
    edit:               'Editar',
    deactivate:         'Desactivar',
    activate:           'Activar',
    loginError:         'Error al entrar',
    loginErrorBody:     'No se pudo acceder a la empresa.',
    tenantDeactivated:  'Empresa desactivada',
    tenantActivated:    'Empresa activada',
    statusChangeError:  'No se pudo cambiar el estado',
    activateNeedsCode:  'Esta empresa no tiene código (slug de URL). Ábrela con Editar, asígnale un código y vuelve a activarla.',
    deactivateTitle:    'Desactivar empresa',
    deactivateBodySuffix: 'quedará inactiva: sus usuarios no podrán iniciar sesión, pero todos sus datos (lotes, actividades, finanzas) se conservan. Puedes reactivarla en cualquier momento.',
    // Seguridad y configuración
    accessHoursTitle:   'Ventana horaria de acceso',
    accessHoursHint:    'Restricción de acceso por hora UTC. SUPER_ADMIN está exento.',
    accessHoursStart:   'Inicio (HH:MM UTC)',
    accessHoursEnd:     'Fin (HH:MM UTC)',
    passwordPolicyTitle: 'Política de contraseñas',
    passwordPolicyHint: 'Requisitos mínimos para contraseñas nuevas.',
    passwordMinLength:  'Longitud mínima',
    passwordMinLengthPlaceholder: '8',
    passwordMaxAgeDays: 'Expiración (días)',
    passwordMaxAgeDaysPlaceholder: '90 (opcional)',
    featureFlagsTitle: 'Features habilitados',
    featureFlagsHint: 'Controla qué módulos/features puede usar esta empresa.',
    demoAccessTitle:    'Acceso demo',
    demoAccessEnabled:  'Habilitado — se muestra selector de roles demo',
    demoAccessDisabled: 'Deshabilitado',
    otpTitle:           'Verificación en dos pasos (OTP)',
    otpHint:            "Código que llega por Telegram al iniciar sesión (Google o contraseña). Con \"Si lo tiene\", quien no tiene Telegram entra solo con su contraseña o Google.",
    otpModeRequired:    "Exigir — todos necesitan Telegram para recibir el código",
    otpModeIfLinked:    "Si lo tiene — el código solo para quien tiene Telegram vinculado",
    otpModeNever:       "Nunca — sin código para nadie (útil en desarrollo)",
    otpEnabled:         'Habilitado — requiere OTP por Telegram',
    otpDisabled:        'Deshabilitado — sin OTP',
    enabled:            'Habilitado',
    disabled:           'Deshabilitado',
    featureLabels: {
      dashboard:    'Dashboard',
      field:        'Campo & Lotes',
      tasks:        'Tareas',
      chat:         'Chat IA',
      finance:      'Finanzas',
      users:        'Gestión de Usuarios',
      settings:     'Configuración',
      irrigation:   'Riego & Fertirrigación',
      harvest:      'Cosecha & Empaque',
      inventory:    'Inventario & Bodega',
      machinery:    'Maquinaria',
      spray:        'Fitosanitario (Plagas)',
      merma:        'Merma (Pérdidas)',
      crop:         'Cultivo & Fenología',
      payroll:      'Nómina',
      porcino:      'Módulo Porcino',
      export:       'Exportación',
      transport:    'Transporte',
      traceability: 'Trazabilidad',
      map:          'Mapa GIS',
      reports:      'Reportes',
      protocol:     'Protocolos de Insumos',
      bulkImport:   'Carga Masiva',
    },
    tenantDeleted: 'Empresa eliminada',
    tenantDeleteError: 'No se pudo eliminar la empresa',
    deleteTenantTitle: 'Eliminar empresa',
    deleteTenantBody: '¿Eliminar {name}? Esta acción oculta la empresa de la lista. Los datos (usuarios, lotes, actividades) no se borran y pueden recuperarse manualmente si es necesario.',
    changeBtn: 'Cambiar',
    currentBtn: 'Actual',
    currentTenantHint: 'Ya estás en esta empresa',
    activateToLogin: 'Activa la empresa para poder iniciar sesión',
  },

  // ── Ranchos Admin (CRUD ranchos/bodegas) ──────────────────────────────────────
  pageTitle: {
    login: 'Iniciar sesión', demoLogin: 'Acceso demo', acceptInvite: 'Completa tu registro', register: 'Registro',
    dashboard: 'Dashboard', users: 'Usuarios', ranchos: 'Ranchos', field: 'Campo', map: 'Mapa',
    irrigation: 'Riego', inventory: 'Inventario',
  },
  ranchosAdmin: {
    pageTitle:          'Administración de Ranchos',
    noPermission:       'No tienes permisos para ver esta página.',
    editRancho:         'Editar',
    newRancho:          'Nuevo rancho',
    fieldName:          'Nombre *',
    fieldNamePlaceholder: 'Rancho La Simiente',
    fieldLocation:      'Ubicación',
    fieldLocationPlaceholder: 'Ébano, SLP',
    fieldHectareas:     'Hectáreas totales',
    fieldHectareasPlaceholder: '150.5',
    fieldLatitude:      'Latitud',
    fieldLongitude:     'Longitud',
    useMapBtn:          'Ver en mapa',
    pickPointHint:      'Haz click en el mapa para fijar el punto',
    confirmPoint:       'Confirmar punto',
    useMyLocation: 'Usar mi ubicación',
    locLocating: 'Ubicando…',
    locDenied: 'Permiso de ubicación denegado.',
    locUnavailable: 'No se pudo obtener tu ubicación.',
    locTimeout: 'Se agotó el tiempo para obtener tu ubicación.',
    locUnsupported: 'Tu navegador no soporta geolocalización.',
    usesFarmModulesSwitch: 'Usa subdivisión en Zonas',
    usesFarmModulesHelp: 'Si se desactiva, este rancho solo se administra a nivel Lote.',
    nameRequired:       'Nombre requerido',
    createError:        'Error al crear rancho',
    statusActive: 'Activo',
    updateError:        'Error al actualizar rancho',
    cancel:             'Cancelar',
    saveChanges:        'Guardar cambios',
    createRancho:       'Crear rancho',
    newWarehouse:       'Nueva bodega',
    fieldWarehouseName: 'Nombre *',
    fieldWarehouseNamePlaceholder: 'Bodega principal',
    fieldWarehouseLocationPlaceholder: 'Rancho Simiente — nave 2',
    warehouseCreateError: 'Error al crear bodega',
    editWarehouse: 'Editar bodega',
    saveWarehouse: 'Guardar cambios',
    warehouseUpdateError: 'Error al actualizar bodega',
    fieldWarehouseRancho: 'Alcance',
    warehouseSharedOption: 'Compartida (toda la empresa)',
    warehouseSharedHint: 'Una bodega compartida aparece en todos los ranchos; el costo de cada consumo lo carga el rancho del lote que consume.',
    colWarehouseScope: 'Alcance',
    createWarehouse:    'Crear bodega',
    ranchosTitle:       'Ranchos',
    tabRanchos:         'Ranchos',
    tabWarehouses:      'Bodegas',
    tabTelegramGroups:  'Grupos de Telegram',
    lotesManagedInField: 'Los lotes y sus zonas se administran en Campo',
    colName:            'Nombre',
    colLocation:        'Ubicación',
    colHectareas:       'Hectáreas',
    colActions:         'Acciones',
    noRanchos:          'No hay ranchos registrados',
    warehousesTitle:    'Bodegas',
    colId:              'ID',
    noWarehouses:       'No hay bodegas registradas',
    deleteRanchoTitle:  'Eliminar rancho',
    deleteRanchoConfirmPrefix: '¿Eliminar ',
    deleteRanchoConfirmSuffix: '? Los lotes asociados no se eliminarán pero quedarán sin rancho.',
    deleteWarehouseTitle: 'Eliminar bodega',
    deleteWarehouseConfirmPrefix: '¿Eliminar ',
    deleteWarehouseConfirmSuffix: '? El stock existente en esta bodega no se eliminará.',
    delete:             'Eliminar',
  },

  // ── Grupos de Telegram vinculados a rancho ────────────────────────────────────
  telegramGroupsAdmin: {
    title:              'Grupos de Telegram',
    subtitle:           'Un grupo vinculado determina el rancho/lote de todo mensaje enviado ahí, sin importar el default guardado del usuario.',
    newGroup:            '+ Vincular grupo',
    colLabel:            'Nombre',
    colChatId:           'Chat ID',
    colRancho:           'Rancho',
    colLote:             'Lote',
    colLinkedBy:         'Vinculado por',
    colLinkedAt:         'Fecha',
    colStatus:           'Estado',
    colActions:          'Acciones',
    noGroups:            'No hay grupos vinculados',
    wholeRancho:         'Todo el rancho',
    statusActive:        'Activo',
    statusInactive:      'Inactivo',
    deactivate:          'Desactivar',
    activate:            'Reactivar',
    colRole: 'Rol del grupo',
    roleAny: 'Todos (según quien escribe)',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar grupo',
    deleteBody: '¿Eliminar el vínculo de "{name}"? El grupo de Telegram no se borra: solo deja de estar ligado a un rancho y el bot se despide. Se puede volver a vincular después.',
    deleteError: 'No se pudo eliminar el grupo',
    ranchoDeleted: 'Rancho eliminado',
    fieldChatId:         'Chat ID *',
    fieldChatIdPlaceholder: '-4123456789',
    addBotHint:          'Vinculación automática: al agregar el bot {bot} a un grupo (o a un canal, como administrador), el bot te pregunta por privado a qué rancho vincularlo; este formulario es un respaldo.\n\nAntes de vincular: 1) agrega el bot {bot} al grupo de Telegram; 2) hazlo administrador (si no, Telegram no le pasa el texto libre); 3) cada integrante que escriba ahí debe haber vinculado su Telegram en Usuarios.',
    fieldChatIdHint:     'Respaldo manual: también puedes ejecutar /vincular_grupo dentro del grupo para vincularlo desde el bot, o agregar temporalmente a @RawDataBot para ver su Chat ID.',
    fieldRancho:         'Rancho *',
    fieldRanchoPlaceholder: 'Selecciona un rancho',
    fieldLote:           'Lote (opcional)',
    fieldLotePlaceholder: 'Todo el rancho',
    fieldLabel:          'Nombre del grupo *',
    fieldLabelPlaceholder: 'Rancho Simiente — General',
    fieldLanguage:       'Idioma de los avisos',
    fieldLanguageHint:   'Idioma en que el bot publica los avisos en este grupo.',
    colLanguage:         'Idioma',
    languageDefault:     'Por defecto',
    chatIdRequired:      'Chat ID requerido',
    ranchoRequired:      'Selecciona un rancho',
    labelRequired:       'Nombre requerido',
    createError:         'Error al vincular el grupo',
    updateError:         'Error al actualizar el grupo',
    cancel:              'Cancelar',
    save:                'Vincular',
    colPurpose:          'Propósito',
    colMode:             'Modo',
    purposeCapture:      'Captura',
    purposeSupervision:  'Supervisión',
    modeAll:             'Todo',
    modeMention:         'Solo mención',
    configure:           'Configurar',
    purposeDialogTitle:  'Propósito del grupo — {name}',
    purposeDialogBody:   'Captura: el bot responde a lo que escriben las personas en el grupo. Supervisión: el grupo solo recibe copias de los usuarios; el bot no responde ahí.',
    purposeLabel:        'Propósito',
    modeLabel:           'Cómo responde el bot',
    modeHint:            'Todo: responde a cada mensaje. Solo mención: responde solo cuando lo mencionan.',
    scopeLabel:          'Alcance de la copia',
    scopeRole:           'Por rol',
    scopeRancho:         'Por rancho',
    roleLabel:           'Rol que se copia',
    rolePlaceholder:     'Elige un rol',
    roleRequired:        'Selecciona un rol',
    purposeSaveError:    'No se pudo guardar el propósito del grupo',
    inviteSupervisor:    'Invitar supervisor',
    inviteSent:          'Enlace enviado a tu chat privado de Telegram. Cada persona que lo use queda en espera hasta que la apruebes.',
    inviteError:         'No se pudo crear el enlace de invitación',
    watchedToggle:       'Vigilados',
    watchedTitle:        'Vigilados y supervisores — {name}',
    watchedHint:         'Vigilados son los usuarios cuya copia llega a este grupo. Cada uno tiene su tema, que se crea solo.',
    colTopic:            'Tema',
    colLevel:            'Nivel',
    noWatched:           'Ningún usuario recibe copia en este grupo.',
    topicOpen:           'Abierto',
    topicClosed:         'Cerrado',
    topicNone:           'Sin tema todavía',
    supervisorsTitle:    'Supervisores',
    noSupervisors:       'Sin lista de supervisores por ahora.',
    verified:            'Verificado',
    unverified:          'Sin verificar',
    watchedLoadError:    'No se pudo cargar la lista de vigilados',
  },

  // ── Carga masiva (Bulk Import) ────────────────────────────────────────────────
  bulkImport: {
    pageTitle:          'Carga Masiva de Datos',
    sectionTitle:       'Importar desde Excel',
    sectionDesc:        'Carga ranchos, lotes, usuarios, productos, catálogos en lote.',
    dropText:           'Arrastra el archivo Excel aquí o haz clic para seleccionar',
    selectFile:         'Seleccionar archivo',
    processing:         'Procesando...',
    formatsSupported:   'Formatos soportados: .xlsx, .xls, .csv',
    analyzing:          'Analizando archivo...',
    validationErrorTitle: 'Error en la validación',
    validationErrorsPrefix: 'Se encontraron ',
    validationErrorsSuffix: ' error(es) de validación. Por favor revisa los datos e intenta de nuevo.',
    readError:          'No se pudo leer el archivo. Asegúrate de que sea un .xlsx/.csv válido con las hojas Ranchos, Lotes, Usuarios, Catalogo.',
    validationSuccess:  'Validación exitosa - No hay errores',
    importSuccessPrefix: 'Importación completada exitosamente. ',
    importSuccessSuffix: ' registros creados.',
    importError:        'Error al importar los datos.',
    summaryTitle:       'Resumen de Importación',
    summaryRanchos:     'Ranchos',
    summaryLotes:       'Lotes',
    summaryUsuarios:    'Usuarios',
    summaryProductos:   'Productos',
    previewTitle:       'Vista previa (primeras 5 filas)',
    previewShowingPrefix: 'Mostrando 5 de ',
    previewShowingSuffix: ' filas',
    cancel:             'Cancelar',
    confirmImport:      'Confirmar e Importar',
    importing:          'Importando...',
    templatesTitle:     'Plantillas Disponibles',
    templatesDesc:      'Descarga las plantillas para rellenarlas correctamente:',
    templateRanchos:    'Plantilla de Ranchos',
    templateLotes:      'Plantilla de Lotes',
    templateUsuarios:   'Plantilla de Usuarios',
    templateProductos:  'Plantilla de Productos',
    confirmDialogTitle: 'Confirmar Importación',
    confirmDialogBody:  '¿Estás seguro de que deseas importar estos datos?',
    confirmDialogNotePrefix: 'Esta acción creará ',
    confirmDialogNoteSuffix: ' nuevos registros en el sistema.',
    confirm:            'Confirmar',
    rowLabelPrefix:     'Fila ',
    errorsMorePrefix:   '... y ',
    errorsMoreSuffix:   ' erro(es) más',
    filaLabel:          'fila',
    filasLabel:         'filas',
    downloadComplete:   'Descargar Plantilla Completa',
  },

  // ── Registro ──────────────────────────────────────────────────────────────
  register: {
    title: 'Regístrate',
    titleFor: (tenantName: string) => `Regístrate en ${tenantName}`,
    needInviteLink: 'Necesitas un link de invitación de tu rancho para registrarte.',
    loading: 'Cargando...',
    invalidCode: 'El código de registro no es válido o expiró.',
    stepTelegram: 'Paso 1 de 2 · Verifica tu Telegram',
    stepAccess: 'Paso 2 de 2 · Elige cómo entrarás',
    telegramIntro: 'Abre el bot de Telegram, toca «Iniciar» y comparte tu contacto con el botón. Tu número se toma de Telegram: no se escribe aquí.',
    openTelegram: 'Abrir Telegram',
    waitingTelegram: 'Esperando a que compartas tu contacto en Telegram…',
    telegramLinkedWaitingPhone: 'Telegram vinculado. Falta compartir tu contacto en el chat con el bot.',
    telegramTimeout: 'Se agotó el tiempo de espera para la verificación.',
    retry: 'Generar un enlace nuevo',
    phoneVerified: (masked: string) => `Telegram verificado ✓ ${masked}`,
    nameLabel: 'Nombre',
    lastNameLabel: 'Apellido',
    emailLabel: 'Correo',
    passwordLabel: 'Contraseña',
    confirmPasswordLabel: 'Confirmar contraseña',
    methodGoogle: 'Continuar con Google',
    methodOr: 'o',
    methodPassword: 'Usar correo y contraseña',
    submit: 'Enviar solicitud',
    nameRequired: 'Escribe tu nombre.',
    emailInvalid: 'Escribe un correo válido.',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
    passwordMismatch: 'Las contraseñas no coinciden.',
    googleFailed: 'No se pudo verificar tu cuenta de Google. Intenta de nuevo.',
    tooManyAttempts: 'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
    genericError: 'Ocurrió un error, intenta de nuevo.',
    pendingTitle: 'Solicitud enviada',
    pendingMessage: 'Tu solicitud quedó pendiente. Un administrador la revisará y te avisaremos por Telegram cuando esté aprobada.',
    webModeLink: 'Registrarme sin Telegram',
    webTitle: 'Solicitar acceso',
    phoneLabel: 'Teléfono (opcional)',
    phoneInvalid: 'Teléfono inválido. Usa formato internacional, por ejemplo +52 442 123 4567.',
    webPendingTitle: 'Solicitud en revisión',
    webPendingMessage: 'Tu solicitud está en revisión. Un administrador de la empresa la revisará y te dará acceso cuando esté aprobada.',
  },

  // ── Usuarios ──────────────────────────────────────────────────────────────
  users: {
    inviteTitle:            'Invitar por link',
    inviteTelegramLink:     'Vincular en Telegram',
    deleteError:            'No se pudo eliminar el usuario',
    roleWarnSuperAdmin:     '⚠️ Super Admin da control total de la plataforma, incluso sobre otras empresas, y permite consultas libres a la base de datos. Úsalo solo para administradores de plataforma.',
    roleWarnAdmin:          '⚠️ Admin puede gestionar usuarios, ranchos, finanzas y ajustes. Asígnalo solo a quien deba administrar.',
    roleWarnMany:           'Tiene muchos roles. Para un trabajador de campo basta con «Campo»: marcar más roles le da acceso a funciones que no necesita.',
    ranchoFilterInfo:       'Mostrando {n} de {total} usuarios con acceso a {rancho} (incluye a quienes tienen acceso a todos los ranchos).',
    allRanchosBadge:        'Acceso a todos los ranchos',
    unlinkTelegramButton:   'Desvincular',
    unlinkTelegramTitle:    'Desvincular Telegram',
    unlinkTelegramBody:     '¿Desvincular el Telegram de {name}? Dejará de poder usar el bot con esta cuenta hasta que lo vincule de nuevo; después ese Telegram podrá vincularse a otra cuenta.',
    unlinkTelegramConfirm:  'Desvincular',
    unlinkTelegramError:    'No se pudo desvincular el Telegram',
    unlockResetButton: 'Desbloquear contraseña',
    resetLockedLabel: 'Recuperación bloqueada',
    resetWaitingLabel: 'Recuperación en espera',
    unlockResetDone: '✓ Desbloqueado',
    unlockResetError: 'No se pudo desbloquear',
    mergeButton: 'Unificar',
    mergeTitle: 'Unificar usuarios',
    mergeBody: 'Este usuario ({name}) se queda y absorbe a otro: el teléfono, Telegram, correo y contraseña que le falten, además de los roles y accesos del otro. El otro usuario quedará deshabilitado. No se puede deshacer.',
    mergePick: 'Usuario que se absorbe',
    mergePickPlaceholder: 'Elige un usuario',
    mergeConfirm: 'Unificar',
    mergeError: 'No se pudo unificar',
    companyLinkTitle: "Link de la empresa",
    companyLinkHint: "Sirve para que cualquiera pida acceso por su cuenta. Queda pendiente hasta que un administrador lo apruebe en Solicitudes.",
    companyLinkGenerate: "Generar link de la empresa",
    companyLinkRegenerate: "Regenerar",
    companyLinkRegenerateHint: "Regenerarlo desactiva el link anterior.",
    companyLinkError: "No se pudo generar el link",
    accountButton: 'Cuenta',
    accountTitle: 'Cuenta y acceso',
    accountHint: 'Teléfono, correo, Telegram y contraseña son las formas de entrar de esta persona.',
    accessNotSet: 'Sin definir',
    accessAdd: 'Agregar',
    accessChange: 'Cambiar',
    accessRemove: 'Quitar',
    accessSave: 'Guardar',
    accessPhone: 'Teléfono',
    accessEmail: 'Correo',
    accessTelegram: 'Telegram',
    accessPassword: 'Contraseña',
    accessTelegramLinked: 'Vinculado',
    accessTelegramLink: 'Vincular por link',
    accessPasswordSet: 'Tiene contraseña',
    accessPasswordNone: 'Sin contraseña',
    accessPasswordPlaceholder: 'Nueva contraseña (mín. 8)',
    accessPasswordNeedsEmail: 'Agrega un correo para poder usar contraseña.',
    accessError: 'No se pudo guardar el cambio',
    cannotDisableSelf:      'No puedes deshabilitar tu propia cuenta',
    cannotRemoveOwnAdminRole: 'No puedes quitarte tu propio rol de administrador',
    selfRolesSessionWarning: 'Se cerrará tu sesión al guardar el cambio de tus roles. Vuelve a entrar para ver los cambios.',
    confirmAndSave: 'Confirmar y guardar',
    cannotDeleteSelf:       'No puedes eliminar tu propia cuenta',
    inviteTelegramHint:     'Ábrelo desde la cuenta de Telegram que usará la persona y que comparta su contacto. Si el teléfono ya tiene cuenta, se le vincula Telegram.',
    addTitle:               'Agregar usuario',
    editTitle:              'Editar usuario',
    copyLabel:              'Copia de supervisión',
    copyNone:               'Sin copia',
    copyLevel1:             'Nivel 1: todo',
    copyLevel2:             'Nivel 2: filtrado',
    copyLevel3:             'Nivel 3: solo avisos',
    mainGroupLabel:         'Grupo principal de copia',
    mainGroupAuto:          'Automático (según rol o rancho)',
    copyNeedsUserId:        'Este usuario no tiene identificador para la copia; no se puede cambiar aquí.',
    deleteTitle:            'Eliminar usuario',
    phoneLabel:             'Teléfono (WhatsApp / Telegram) *',
    phoneOnly:              'Teléfono',
    languageLabel:          'Idioma',
    inviteButton:           'Invitar por link',
    addButton:              '+ Agregar usuario',
    pendingRegistrationsTab:'Solicitudes',
    pendingEmpty: 'No hay solicitudes pendientes',
    pendingLoading: 'Cargando solicitudes...',
    pendingMethodGoogle: 'Google',
    pendingMethodPassword: 'Correo y contraseña',
    pendingRanchosLabel: 'Ranchos permitidos',
    pendingRanchosPlaceholder: 'Todos los ranchos',
    pendingLotesLabel: 'Lotes permitidos',
    pendingLotesPlaceholder: 'Selecciona lotes',
    pendingNeedLote: 'Un trabajador de campo necesita al menos un lote; sin lotes no tendrá acceso a ninguno.',
    grantExpensesApprove: 'Puede aprobar gastos generales',
    pendingApproveError: 'No se pudo completar la acción. Intenta de nuevo.',
    pendingAlreadyResolved: 'Esta solicitud ya fue resuelta por otra persona.',
    pendingRejectTitle: 'Rechazar solicitud',
    pendingRejectBody: '¿Rechazar la solicitud de {name}? Se le avisará por Telegram.',
    activityTab: 'Actividad',
    activityColName: 'Nombre',
    activityColPhone: 'Teléfono',
    activityColTelegram: 'Telegram',
    activityColLastSeen: 'Última actividad',
    activityNever: 'Nunca',
    activityToday: 'Hoy',
    activityDaysAgo: 'Hace {n} días',
    activityEmpty: 'Sin datos de actividad',
    approve:                'Aprobar',
    reject:                 'Rechazar',
    confirm:                'Confirmar',
    pageTitle: 'Usuarios',
    systemUsers: 'Usuarios del sistema',
    loadingUsers: 'Cargando usuarios...',
    telegramLinked: '✓ Telegram vinculado',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    rolesLabel: 'Roles *',
    emailOptional: 'Email (opcional)',
    emailPlaceholder: 'usuario@ejemplo.com',
    namePlaceholder: 'Ej: Juan García',
    nameTooLong: 'El nombre no puede tener más de {max} caracteres',
    phoneRequired: 'El teléfono es requerido',
    rolesRequired: 'Selecciona al menos un rol',
    createError: 'Error al crear usuario',
    saveError: 'Error al guardar cambios',
    inviteError: 'No se pudo generar la invitación',
    inviteShareMessage: 'Te invito a unirte a Agrovid — usa este link para crear tu cuenta:',
    inviteEmailSubject: 'Invitación a Agrovid',
    inviteShareHint: 'Comparte este link — expira en 7 días y solo puede usarse una vez:',
    copied: '✓ Copiado',
    copyLink: 'Copiar link',
    shareTelegram: 'Enviar por Telegram',
    shareWhatsapp: 'Enviar por WhatsApp',
    shareEmail: 'Enviar por correo',
    shareEmailHint: 'Agrega un email arriba para prellenar el destinatario',
    generateLink: 'Generar link',
    deleteActiveWarning: '{name} está activo. Primero debes deshabilitarlo antes de poder eliminarlo — así evitamos borrar por error a alguien que sigue trabajando.',
    deleteConfirmBody: '¿Eliminar a {name}? Esta acción no se puede deshacer.',
    ranchosPlaceholder: 'Selecciona ranchos',
    accessAllRanchos: '✓ Acceso a todos los ranchos (click para restringir)',
    accessRestrictRanchos: 'Restringir a ranchos seleccionados (click para dar acceso total)',
    defaultRanchoLabel: 'Rancho activo por defecto',
    defaultRanchoNone: 'Sin ranchos disponibles',
    defaultRanchoUnset: 'Sin definir — usa el primero de "Ranchos permitidos"',
    defaultRanchoHint: 'Es el rancho que usa el bot de Telegram cuando el usuario no elige uno explícitamente con /rancho.',
    accessAllLotes: '✓ Acceso a todos los lotes (click para restringir)',
    accessRestrictLotes: 'Restringir a lotes seleccionados (click para dar acceso total)',
    saveAccess: 'Guardar accesos',
  },

  // ── Vocabulario ────────────────────────────────────────────────────────────
  vocabulary: {
    title:                  'Vocabulario de la empresa',
    titleWithCompany:       'Vocabulario de {company}',
    description:            'Términos y modismos que el bot aprende para corregir transcripciones de voz.',
    pendingTitle:           'Sugerencias pendientes de revisión',
    activeTerms:            'Términos activos',
    aliasDetected:          'Alias detectado',
    termSuggested:          'Término sugerido',
    origin:                 'Origen',
    actions:                'Acciones',
    approve:                'Aprobar',
    reject:                 'Rechazar',
    addTerm:                'Agregar término',
    term:                   'Término',
    aliases:                'Alias',
    category:               'Categoría',
    scope:                  'Ámbito',
    noTerms:                'No hay términos registrados',
    delete:                 'Eliminar',
    loading:                'Cargando...',
    cancel:                 'Cancelar',
    save:                   'Guardar',
    user:                   'Usuario',
    tenant:                 'Empresa',
    autoLearned:            'Auto-aprendido',
    manual:                 'Manual',
    dialogTitle:            'Agregar término de vocabulario',
    canonicalTerm:          'Término canónico',
    placeCanonical:         'ej. Abamectin',
    aliasesComma:           'Alias (separados por coma)',
    placeAliases:           'ej. abama, avamectina',
    placeCategory:          'ej. chemical',
  },

  // ── Dispositivos (F5) ──────────────────────────────────────────────────────
  drones: {
    title:       'Vuelos de dron',
    zoneFilter:  'Lote o zona',
    subtitle:    'Fumigación con dron: superficie, litros y repetición de cada vuelo',
    flights:     'Vuelos',
    hectares:    'Hectáreas tratadas',
    liters:      'Litros aplicados',
    flightHours: 'Horas de vuelo',
    replay:      'Repetición del vuelo',
    play:        'Reproducir',
    pause:       'Pausar',
    restart:     'Reiniciar',
    speed:       'Velocidad',
    elapsed:     'Tiempo',
    sprayed:     'Tratado',
    battery:     'Batería',
    colDate:     'Fecha',
    colLote:     'Lote',
    colHa:       'Hectáreas',
    colLiters:   'Litros',
    colDuration: 'Duración',
    colBattery:  'Batería',
    colAircraft: 'Aeronave',
    empty:       'Sin vuelos registrados.',
    simulated:   'Trayectoria ilustrativa con la superficie, los litros y la separación de pasadas del vuelo.',
    flightOf:    'Vuelo del',
  },
  droneImport: {
    button:         'Importar vuelos (Excel)',
    title:          'Importar vuelos de dron',
    intro:          'Carga un Excel con un vuelo por fila. Primero se valida y verás una vista previa; nada se guarda hasta que confirmes.',
    template:       'Descargar plantilla',
    chooseFile:     'Elegir archivo .xlsx',
    validating:     'Validando…',
    summary:        'filas válidas',
    errorsTitle:    'Corrige estos errores y vuelve a subir el archivo',
    colRow:         'Fila',
    colField:       'Campo',
    colMessage:     'Problema',
    colDate:        'Fecha',
    colType:        'Tipo',
    colLote:        'Lote',
    colValves:      'Válvulas',
    colHa:          'Ha',
    colLiters:      'Litros',
    confirm:        'Importar',
    importing:      'Importando…',
    close:          'Cerrar',
    readError:      'No se pudo leer el archivo. Usa la plantilla y revisa que tenga las columnas fecha y lote.',
    importError:    'No se pudo importar. Revisa el archivo e inténtalo de nuevo.',
    done:           'Vuelos creados',
    skipped:        'ya existían',
    typeAPPLICATION: 'Aplicación',
    typeVIDEO:       'Video',
    typeSCOUTING:    'Monitoreo',
  },
  devices: {
    title:            'Dispositivos',
    subtitle:          'Sensores, trackers y drones que reportan a la plataforma',
    empty:             'Sin dispositivos registrados. Da de alta el primero para empezar a recibir telemetría.',
    add:               'Nuevo dispositivo',
    name:              'Nombre',
    type:              'Tipo',
    capabilities:      'Capacidades',
    binding:           'Asignado a',
    unbound:           'Sin asignar',
    bindingIdPlaceholder: 'ID del embarque/zona/lote',
    bindingTargetPlaceholder: 'Selecciona el destino vinculado',
    status:            'Estado',
    lastSeen:          'Última señal',
    never:             'Nunca',
    apiKeyPrefix:      'Clave',
    rotateKey:         'Rotar clave',
    rotateConfirm:     'Al rotar, la clave actual deja de funcionar de inmediato. El dispositivo tendrá que reconfigurarse con la nueva. ¿Continuar?',
    keyShownOnce:      'Copia esta clave ahora — no se puede volver a ver. Si la pierdes, tendrás que rotarla.',
    keyCopied:         'Clave copiada',
    copy:              'Copiar',
    statusACTIVE:      'Activo',
    statusINACTIVE:    'Inactivo',
    statusREVOKED:     'Revocado',
    typeGPS_TRACKER:   'Tracker GPS',
    typeTHERMOGRAPH:   'Termógrafo',
    typeSOIL_SENSOR:   'Sensor de suelo',
    typeWEATHER_STATION: 'Estación meteorológica',
    typeDRONE:         'Dron',
    typeCARRIER_API:   'API de transportista',
    typeRAIN_GAUGE:    'Pluviómetro',
    save:              'Guardar',
    cancel:            'Cancelar',
  },

  // ── Demo Login (selector de rol demo) ──────────────────────────────────────────
  demoLogin: {
    unavailable: 'El demo no está disponible en este entorno.',
    goToLogin: 'Ir a iniciar sesión',
    roleLabels: {
      ADMIN:             'Administrador',
      AGRONOMIST:        'Agrónomo',
      SUPERVISOR:        'Supervisor de campo',
      WAREHOUSE_MANAGER: 'Bodeguero',
      FIELD_WORKER:      'Trabajador de campo',
      SUPER_ADMIN:       'Super Administrador',
      AUDITOR:           'Auditor',
      HR:           'Recursos Humanos',
      GUARD:           'Vigilante',
      INVESTOR:          'Inversionista',
    },
    roleDesc: {
      ADMIN:             'Acceso administrativo completo: usuarios, finanzas y ajustes',
      AGRONOMIST:        'Protocolos de cultivo, fenología y monitoreo de plagas',
      SUPERVISOR:        'Operaciones de campo y gestión de tareas',
      WAREHOUSE_MANAGER: 'Inventario, stock y manejo FEFO',
      FIELD_WORKER:      'Acceso básico para registrar operaciones y actividades',
      SUPER_ADMIN:       'Control total de la plataforma',
      AUDITOR:           'Acceso de solo lectura a todo el sistema',
      HR:           'Personal, enrolamiento y asistencia por rostro',
      GUARD:           'Caseta: verifica pases de lista y registra vehículos',
      INVESTOR:          'Portal del inversionista: producción, inversión y logística en solo lectura',
    },
    enterAs: 'Entrar como',
    subtitle: 'Selecciona el rol con el que quieres explorar el demo',
    connectError: 'No se pudo conectar al servidor de demo.',
  },

  // ── Fase C — Documentos (repositorio transversal) ──────────────────────────
  documents: {
    title:    'Documentos',
    subtitle: 'Repositorio documental de la empresa, agrupado por origen.',
    subtitleWithCompany: 'Repositorio documental de {company}, agrupado por origen.',
    loading:  'Cargando documentos...',
    noDocuments: 'No hay documentos.',
    folderSHIPMENT:       'Embarques',
    folderINVOICE:        'Facturas',
    folderMODULE:         'Zonas',
    folderPURCHASE_ORDER: 'Órdenes de compra',
    folderOTHER:          'Otros',
    docCountSuffix: 'documentos',
    colType: 'Tipo',
    colDate: 'Fecha',
    colGeneratedBy: 'Generado por',
    download: 'Descargar',
    back: 'Volver',
    kpiTotal: 'Documentos totales',
    kpiTopFolder: 'Carpeta con más documentos',
    kpiLast30d: 'Subidos (últimos 30 días)',
    kpiDocTypes: 'Tipos de documento',
    recentTitle: 'Documentos recientes',
  },

  // ── Fase C — Riesgos (agregación de anomalías + merma) ─────────────────────
  riesgos: {
    title:    'Riesgos',
    subtitle: 'Vista consolidada de riesgo abierto: anomalías de producción y eventos de merma recientes.',
    anomaliesTitle: 'Anomalías abiertas',
    loadingAnomalies: 'Cargando anomalías...',
    noAnomalies: 'Sin anomalías abiertas.',
    mermaTitle: 'Merma reciente de mayor impacto',
    loadingMerma: 'Cargando merma...',
    noMerma: 'Sin registros de merma recientes.',
    complianceTitle: 'Cumplimiento (PHI/REI/MRL)',
    complianceNote: 'El sistema bloquea en tiempo real las operaciones fuera de norma (PHI/REI/MRL), pero todavía no guarda un historial consultable de bloqueos — esta sección se habilitará cuando exista ese registro.',
    responsible: 'Responsable',
    impact: 'Impacto',
    kpiOpen: 'Riesgos abiertos',
    kpiCritical: 'Críticos',
    kpiHigh: 'Altos',
    kpiMedium: 'Medios',
    kpiLow: 'Bajos',
    kpiWithResponsible: 'Con responsable asignado',
    kpiMermaImpact: 'Impacto de merma (total)',
    moduleRiskTitle: 'Mapa de riesgo por zona',
    noActiveProject: 'Selecciona un proyecto activo para ver el mapa de riesgo por zona.',
    noRisk: 'Sin riesgo',
    categoryTitle: 'Riesgos por categoría',
    tableTitle: 'Registro de riesgos y alertas',
    colDate: 'Fecha',
    colCategory: 'Categoría',
    colDescription: 'Descripción',
    colLevel: 'Nivel',
    colResponsible: 'Responsable',
    colStatus: 'Estado',
    statusABIERTA: 'Abierta',
    statusEN_PROCESO: 'En proceso',
    statusRESUELTA: 'Resuelta',
    statusDESCARTADA: 'Descartada',
  },

  // ── Gastos generales — bandeja de aprobación (B2) ───────────────────────────
  // ── Gastos generales — dashboard (B3) ───────────────────────────────────────
  calculators: {
    title: 'Calculadoras',
    subtitle: 'Calcula costos, rendimiento y flujo de efectivo con tus supuestos.',
    calculate: 'Calcular',
    result: 'Resultado',
    fromSystem: 'del sistema',
    loadError: 'No se pudo cargar el catálogo.',
    runError: 'No se pudo calcular.',
  },
  expensesDashboard: {
    title: 'Gastos generales',
    subtitle: 'Resumen de gastos confirmados en moneda base.',
    from: 'Desde',
    to: 'Hasta',
    rancho: 'Rancho',
    lote: 'Lote',
    all: 'Todos',
    kpiTotal: 'Total del periodo',
    kpiCount: 'Gastos confirmados',
    kpiPending: 'Por aprobar',
    byCategory: 'Por categoría',
    byCounterparty: 'Por proveedor',
    byMonth: 'Por mes',
    empty: 'Sin datos en el periodo.',
    loading: 'Cargando...',
    error: 'No se pudo cargar el resumen.',
    excluded: 'Se excluyeron {n} gasto(s) con otra moneda base.',
    noCounterparty: 'Sin proveedor',
    colCategory: 'Categoría',
    colCounterparty: 'Proveedor',
    colMonth: 'Mes',
    colTotal: 'Total',
    viewPending: 'Ver por aprobar',
  },

  expenseApprovals: {
    title: 'Gastos por aprobar',
    subtitle: 'Gastos generales registrados sin aprobación directa. Apruébalos o recházalos.',
    loading: 'Cargando...',
    empty: 'No hay gastos por aprobar.',
    colDate: 'Fecha',
    colDescription: 'Concepto',
    colCounterparty: 'Proveedor',
    colAmount: 'Monto',
    colScope: 'Imputación',
    colRegisteredBy: 'Registrado por',
    scopeTenant: 'Empresa',
    scopeRancho: 'Rancho',
    scopeLote: 'Lote',
    approve: 'Aprobar',
    reject: 'Rechazar',
    rejectTitle: 'Rechazar gasto',
    rejectBody: 'El gasto quedará rechazado y no contará en los reportes. El motivo es opcional.',
    reasonLabel: 'Motivo (opcional)',
    cancel: 'Cancelar',
    conflict: 'Este gasto ya fue resuelto por otra persona. Se actualizó la lista.',
    actionError: 'No se pudo completar la acción. Intenta de nuevo.',
  },

  // ── Fase D — Costos (portal inversionista) ──────────────────────────────────
  costos: {
    title: 'Costos',
    subtitle: 'Control de costos, flujo de caja y cartera por cobrar.',
    loading: 'Cargando...',
    noData: 'Sin datos.',
    kpiPlanned: 'Presupuesto total',
    kpiExecuted: 'Ya generado',
    kpiExecPct: '% Ejecución',
    kpiRevenue: 'Ingreso estimado',
    kpiMargin: 'Margen bruto',
    kpiMarginPct: '% Margen',
    kpiGeneralExpenses: 'Gastos generales',
    indirectsTitle: 'Indirectos prorrateados por lote',
    colLote: 'Lote',
    colIndirect: 'Indirectos',
    colIndirectPerHa: 'Indirectos/ha',
    excludedCurrencyNote: 'Hay gastos generales en otra moneda base que no se incluyen en estos totales:',
    compositionTitle: 'Composición del costo (generado)',
    compositionCenterLabel: 'costo total',
    cashflowTitle: 'Flujo de caja proyectado',
    budgetTitle: 'Presupuesto vs real por categoría',
    colCategory: 'Categoría',
    colPlanned: 'Presup.',
    colExecuted: 'Gastado',
    colVariance: 'Varianza',
    colPct: '% Ejec.',
    receivablesTitle: 'Cuentas por cobrar',
    agingCurrent: 'Al corriente',
    agingBucketPrefix: 'Vencido',
    agingTotal: 'Total por cobrar',
  },
  // Reglas PHI/REI/MRL de la empresa
  complianceRules: {
    title: 'Reglas de cumplimiento',
    subtitle: 'Intervalos PHI (días antes de cosechar), REI (horas antes de reingresar) y límites MRL por agroquímico, cultivo y mercado. El sistema bloquea cualquier aplicación o cosecha sin regla.',
    newRule: 'Nueva regla',
    importExcel: 'Importar Excel',
    filterProduct: 'Producto',
    filterCrop: 'Cultivo',
    filterMarket: 'Mercado',
    allProducts: 'Todos los productos',
    allMarkets: 'Todos los mercados',
    colProduct: 'Producto',
    colCrop: 'Cultivo',
    colMarket: 'Mercado',
    colPhi: 'PHI (días)',
    colRei: 'REI (horas)',
    colMrl: 'MRL',
    colScope: 'Origen',
    colActions: 'Acciones',
    scopeTenant: 'Empresa',
    scopeGlobal: 'General (solo lectura)',
    edit: 'Editar',
    delete: 'Eliminar',
    deleteTitle: 'Eliminar regla',
    deleteConfirm: '¿Eliminar la regla de {product} en {crop} ({market})? Sin regla, el sistema bloqueará aplicaciones y cosechas con ese producto.',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando...',
    loading: 'Cargando reglas...',
    emptyTitle: 'Aún no hay reglas de cumplimiento',
    emptyHint: 'Agrega una regla por cada agroquímico, cultivo y mercado, o importa la plantilla de Excel. Sin regla, el sistema bloquea la aplicación o la cosecha por seguridad.',
    emptyNoProducts: 'Primero da de alta tus agroquímicos en Inventario (categoría Agroquímico).',
    noMatches: 'Ninguna regla coincide con los filtros.',
    dialogNewTitle: 'Nueva regla de cumplimiento',
    dialogEditTitle: 'Editar regla de cumplimiento',
    fieldProduct: 'Agroquímico',
    fieldCrop: 'Cultivo',
    fieldCropHint: 'Elige del catálogo o escribe uno nuevo.',
    fieldMarket: 'Mercado',
    fieldPhi: 'PHI (días antes de cosechar)',
    fieldRei: 'REI (horas antes de reingresar)',
    fieldMrl: 'MRL (límite máximo de residuos)',
    fieldMrlUnit: 'Unidad',
    fieldNotes: 'Notas',
    requiredFields: 'Completa producto, cultivo, mercado, PHI, REI y MRL.',
    errorGeneric: 'No se pudo guardar la regla.',
    importTitle: 'Importar reglas desde Excel',
    importHelp: 'Descarga la plantilla, llena una fila por regla (Producto puede ser el nombre o el id del agroquímico) y súbela. Revisa la vista previa antes de confirmar.',
    downloadTemplate: 'Descargar plantilla',
    chooseFile: 'Archivo .xlsx',
    preview: 'Vista previa',
    previewing: 'Revisando...',
    previewSummary: '{total} filas: {valid} válidas ({toCreate} nuevas, {toUpdate} actualizaciones), {errors} con errores.',
    colRow: 'Fila',
    colStatus: 'Estado',
    statusOk: 'OK',
    actionCreate: 'Nueva',
    actionUpdate: 'Actualiza',
    fixErrors: 'Corrige las filas con errores y vuelve a revisar el archivo para poder confirmar.',
    confirmImport: 'Confirmar importación',
    importing: 'Importando...',
    imported: 'Importación lista: {created} nuevas, {updated} actualizadas.',
    failedRows: 'No se guardaron las filas: {rows}.',
    close: 'Cerrar',
  },
} as const;

// DeepString widens every leaf to `string` so other locales can use any value
type DeepString<T> = {
  [K in keyof T]: T[K] extends (...args: any[]) => any
    ? T[K]
    : T[K] extends object
      ? DeepString<T[K]>
      : string;
};
export type Translations = DeepString<typeof es>;
